/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amarantos API
 * REST API for the Amarantos construction and infrastructure management platform. Supports both the Panel (web) and App (mobile) clients.
 *
 * OpenAPI spec version: 1.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AppAccount,
  AppAccountCreateRequest,
  AuditLogListResponse,
  Benchmark,
  BenchmarkCreateRequest,
  BenchmarkListResponse,
  BenchmarkUpdateRequest,
  Certificate,
  CertificateCreateRequest,
  CertificateListResponse,
  ConflictResponse,
  CreateSessionRequest,
  DeleteRestrictedResponse,
  ElementAssignment,
  ElementAssignmentRequest,
  ElementDocument,
  ElementDocumentCreateRequest,
  ElementDocumentListResponse,
  ForbiddenResponse,
  Instrument,
  InstrumentCreateRequest,
  InstrumentListResponse,
  InstrumentUpdateRequest,
  ListAuditLogsParams,
  ListElementDocumentsParams,
  ListGroupedNetworkElementsParams,
  ListInstrumentsParams,
  ListMeasurementsParams,
  ListNetworkConnectionsParams,
  ListNetworkNodesParams,
  ListNodeComponentTypesParams,
  ListPersonsParams,
  ListProductCertificatesParams,
  ListProductSpecificationsParams,
  ListProductsParams,
  ListProjectBenchmarksParams,
  ListProjectDocumentsParams,
  ListProjectGroupedMaterialsParams,
  ListProjectMaterialsParams,
  ListProjectNetworksParams,
  ListProjectPersonsParams,
  ListProjectProductsParams,
  ListProjectWorkStatusUpdatesParams,
  ListProjectsParams,
  ListSuppliersParams,
  Material,
  MaterialCreateRequest,
  MaterialGroupListResponse,
  MaterialListResponse,
  MaterialRecalculation,
  MaterialUpdateRequest,
  MeResponse,
  Measurement,
  MeasurementCreateRequest,
  MeasurementListResponse,
  Network,
  NetworkConnection,
  NetworkConnectionCreateRequest,
  NetworkConnectionListResponse,
  NetworkConnectionUpdateRequest,
  NetworkCreateRequest,
  NetworkElementGroupListResponse,
  NetworkListResponse,
  NetworkNode,
  NetworkNodeCreateRequest,
  NetworkNodeListResponse,
  NetworkNodeUpdateRequest,
  NetworkStatsResponse,
  NetworkUpdateRequest,
  NodeComponentType,
  NodeComponentTypeCreateRequest,
  NodeComponentTypeListResponse,
  NodeComponentTypeUpdateRequest,
  NotFoundResponse,
  PanelAccount,
  PanelAccountCreateRequest,
  PasswordResetConfirm,
  PasswordResetRequest,
  Person,
  PersonCreateRequest,
  PersonListResponse,
  PersonUpdateRequest,
  Product,
  ProductCreateRequest,
  ProductListResponse,
  ProductSpecificationListResponse,
  ProductUpdateRequest,
  Project,
  ProjectCreateRequest,
  ProjectDocument,
  ProjectDocumentCreateRequest,
  ProjectDocumentListResponse,
  ProjectDocumentUpdateRequest,
  ProjectListResponse,
  ProjectPerson,
  ProjectPersonCreateRequest,
  ProjectPersonListResponse,
  ProjectPersonUpdateRequest,
  ProjectProduct,
  ProjectProductCreateRequest,
  ProjectProductListResponse,
  ProjectProductUpdateRequest,
  ProjectUpdateRequest,
  Supplier,
  SupplierCreateRequest,
  SupplierListResponse,
  SupplierUpdateRequest,
  UnauthorizedResponse,
  ValidationErrorResponse,
  WorkStatusUpdate,
  WorkStatusUpdateAuthorEditRequest,
  WorkStatusUpdateCreateRequest,
  WorkStatusUpdateListResponse,
  WorkStatusUpdatePatchRequest
} from './model';

import { customFetch } from '../http-client';
import type { ErrorType , BodyType } from '../http-client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Request password reset
 */
export const requestPasswordReset = (
    passwordResetRequest: BodyType<PasswordResetRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/auth/password/reset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: passwordResetRequest, signal
    },
      options);
    }




export const getRequestPasswordResetMutationKey = () => ['requestPasswordReset'] as const;

export const getRequestPasswordResetMutationOptions = <TError = ErrorType<ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError,RequestPasswordResetMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError,RequestPasswordResetMutationVariables, TContext> => {

const mutationKey = getRequestPasswordResetMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestPasswordReset>>, RequestPasswordResetMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  requestPasswordReset(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof requestPasswordReset>>>
    export type RequestPasswordResetMutationBody = BodyType<PasswordResetRequest>
    export type RequestPasswordResetMutationError = ErrorType<ValidationErrorResponse>
    export type RequestPasswordResetMutationVariables = {data: BodyType<PasswordResetRequest>}

    /**
 * @summary Request password reset
 */
export const useRequestPasswordReset = <TError = ErrorType<ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError,RequestPasswordResetMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestPasswordReset>>,
        TError,
        RequestPasswordResetMutationVariables,
        TContext
      > => {
      return useMutation(getRequestPasswordResetMutationOptions(options), queryClient);
    }

/**
 * @summary Confirm password reset
 */
export const confirmPasswordReset = (
    passwordResetConfirm: BodyType<PasswordResetConfirm>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/auth/password/reset/confirm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: passwordResetConfirm, signal
    },
      options);
    }




export const getConfirmPasswordResetMutationKey = () => ['confirmPasswordReset'] as const;

export const getConfirmPasswordResetMutationOptions = <TError = ErrorType<ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmPasswordReset>>, TError,ConfirmPasswordResetMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmPasswordReset>>, TError,ConfirmPasswordResetMutationVariables, TContext> => {

const mutationKey = getConfirmPasswordResetMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmPasswordReset>>, ConfirmPasswordResetMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  confirmPasswordReset(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof confirmPasswordReset>>>
    export type ConfirmPasswordResetMutationBody = BodyType<PasswordResetConfirm>
    export type ConfirmPasswordResetMutationError = ErrorType<ValidationErrorResponse>
    export type ConfirmPasswordResetMutationVariables = {data: BodyType<PasswordResetConfirm>}

    /**
 * @summary Confirm password reset
 */
export const useConfirmPasswordReset = <TError = ErrorType<ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmPasswordReset>>, TError,ConfirmPasswordResetMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmPasswordReset>>,
        TError,
        ConfirmPasswordResetMutationVariables,
        TContext
      > => {
      return useMutation(getConfirmPasswordResetMutationOptions(options), queryClient);
    }

/**
 * @summary Create session (login)
 */
export const createSession = (
    createSessionRequest: BodyType<CreateSessionRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/sessions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSessionRequest, signal
    },
      options);
    }




export const getCreateSessionMutationKey = () => ['createSession'] as const;

export const getCreateSessionMutationOptions = <TError = ErrorType<UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSession>>, TError,CreateSessionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSession>>, TError,CreateSessionMutationVariables, TContext> => {

const mutationKey = getCreateSessionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSession>>, CreateSessionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createSession(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createSession>>>
    export type CreateSessionMutationBody = BodyType<CreateSessionRequest>
    export type CreateSessionMutationError = ErrorType<UnauthorizedResponse>
    export type CreateSessionMutationVariables = {data: BodyType<CreateSessionRequest>}

    /**
 * @summary Create session (login)
 */
export const useCreateSession = <TError = ErrorType<UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSession>>, TError,CreateSessionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSession>>,
        TError,
        CreateSessionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateSessionMutationOptions(options), queryClient);
    }

/**
 * @summary Refresh access token
 */
export const refreshSession = (

 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/sessions`, method: 'PATCH', signal
    },
      options);
    }




export const getRefreshSessionMutationKey = () => ['refreshSession'] as const;

export const getRefreshSessionMutationOptions = <TError = ErrorType<UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshSession>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshSession>>, TError,void, TContext> => {

const mutationKey = getRefreshSessionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshSession>>, void> = () => {


          return  refreshSession(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshSessionMutationResult = NonNullable<Awaited<ReturnType<typeof refreshSession>>>

    export type RefreshSessionMutationError = ErrorType<UnauthorizedResponse>


    /**
 * @summary Refresh access token
 */
export const useRefreshSession = <TError = ErrorType<UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshSession>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refreshSession>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRefreshSessionMutationOptions(options), queryClient);
    }

/**
 * Clears the `jwt` and `refresh_jwt` cookies. Unauthenticated on purpose so logout still works once the access token has expired; header-mode clients get the same 204 and discard their tokens client-side.
 * @summary Destroy session (logout)
 */
export const destroySession = (

 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/sessions`, method: 'DELETE', signal
    },
      options);
    }




export const getDestroySessionMutationKey = () => ['destroySession'] as const;

export const getDestroySessionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroySession>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof destroySession>>, TError,void, TContext> => {

const mutationKey = getDestroySessionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroySession>>, void> = () => {


          return  destroySession(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroySessionMutationResult = NonNullable<Awaited<ReturnType<typeof destroySession>>>

    export type DestroySessionMutationError = ErrorType<unknown>


    /**
 * @summary Destroy session (logout)
 */
export const useDestroySession = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroySession>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof destroySession>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDestroySessionMutationOptions(options), queryClient);
    }

/**
 * @summary Get current account
 */
export const getMe = (

 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<MeResponse>(
      {url: `/me`, method: 'GET', signal
    },
      options);
    }




export const getGetMeInfiniteQueryKey = () => {
    return [
    'infinite', `/me`
    ] as const;
    }

export const getGetMeQueryKey = () => {
    return [
    `/me`
    ] as const;
    }


export const getGetMeInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getMe>>>, TError = ErrorType<UnauthorizedResponse>>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeInfiniteQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeInfiniteQueryError = ErrorType<UnauthorizedResponse>


export function useGetMeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMe>>>, TError = ErrorType<UnauthorizedResponse>>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMe>>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMe>>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current account
 */

export function useGetMeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMe>>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<UnauthorizedResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = ErrorType<UnauthorizedResponse>


export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<UnauthorizedResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current account
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<UnauthorizedResponse>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeSuspenseQueryError = ErrorType<UnauthorizedResponse>


export function useGetMeSuspense<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<UnauthorizedResponse>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeSuspense<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeSuspense<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current account
 */

export function useGetMeSuspense<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary List persons
 */
export const listPersons = (
    params?: ListPersonsParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<PersonListResponse>(
      {url: `/persons`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListPersonsInfiniteQueryKey = (params?: ListPersonsParams,) => {
    return [
    'infinite', `/persons`, ...(params ? [params] : [])
    ] as const;
    }

export const getListPersonsQueryKey = (params?: ListPersonsParams,) => {
    return [
    `/persons`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPersonsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listPersons>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(params?: ListPersonsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listPersons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPersonsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPersons>>> = ({ signal }) => listPersons(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listPersons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPersonsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listPersons>>>
export type ListPersonsInfiniteQueryError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>


export function useListPersonsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listPersons>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params: undefined |  ListPersonsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listPersons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPersons>>,
          TError,
          Awaited<ReturnType<typeof listPersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPersonsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listPersons>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListPersonsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listPersons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPersons>>,
          TError,
          Awaited<ReturnType<typeof listPersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPersonsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listPersons>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListPersonsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listPersons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List persons
 */

export function useListPersonsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listPersons>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListPersonsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listPersons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPersonsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListPersonsQueryOptions = <TData = Awaited<ReturnType<typeof listPersons>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(params?: ListPersonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPersons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPersonsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPersons>>> = ({ signal }) => listPersons(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPersons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPersonsQueryResult = NonNullable<Awaited<ReturnType<typeof listPersons>>>
export type ListPersonsQueryError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>


export function useListPersons<TData = Awaited<ReturnType<typeof listPersons>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params: undefined |  ListPersonsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPersons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPersons>>,
          TError,
          Awaited<ReturnType<typeof listPersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPersons<TData = Awaited<ReturnType<typeof listPersons>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListPersonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPersons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPersons>>,
          TError,
          Awaited<ReturnType<typeof listPersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPersons<TData = Awaited<ReturnType<typeof listPersons>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListPersonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPersons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List persons
 */

export function useListPersons<TData = Awaited<ReturnType<typeof listPersons>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListPersonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPersons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPersonsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListPersonsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listPersons>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(params?: ListPersonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPersons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPersonsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPersons>>> = ({ signal }) => listPersons(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPersons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPersonsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listPersons>>>
export type ListPersonsSuspenseQueryError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>


export function useListPersonsSuspense<TData = Awaited<ReturnType<typeof listPersons>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params: undefined |  ListPersonsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPersons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPersonsSuspense<TData = Awaited<ReturnType<typeof listPersons>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListPersonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPersons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPersonsSuspense<TData = Awaited<ReturnType<typeof listPersons>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListPersonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPersons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List persons
 */

export function useListPersonsSuspense<TData = Awaited<ReturnType<typeof listPersons>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListPersonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listPersons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPersonsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Create person
 */
export const createPerson = (
    personCreateRequest: BodyType<PersonCreateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Person>(
      {url: `/persons`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: personCreateRequest, signal
    },
      options);
    }




export const getCreatePersonMutationKey = () => ['createPerson'] as const;

export const getCreatePersonMutationOptions = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPerson>>, TError,CreatePersonMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPerson>>, TError,CreatePersonMutationVariables, TContext> => {

const mutationKey = getCreatePersonMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPerson>>, CreatePersonMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createPerson(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePersonMutationResult = NonNullable<Awaited<ReturnType<typeof createPerson>>>
    export type CreatePersonMutationBody = BodyType<PersonCreateRequest>
    export type CreatePersonMutationError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ValidationErrorResponse>
    export type CreatePersonMutationVariables = {data: BodyType<PersonCreateRequest>}

    /**
 * @summary Create person
 */
export const useCreatePerson = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPerson>>, TError,CreatePersonMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPerson>>,
        TError,
        CreatePersonMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePersonMutationOptions(options), queryClient);
    }

/**
 * @summary Get person
 */
export const getPerson = (
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Person>(
      {url: `/persons/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetPersonInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/persons/${id}`
    ] as const;
    }

export const getGetPersonQueryKey = (id: number,) => {
    return [
    `/persons/${id}`
    ] as const;
    }


export const getGetPersonInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPerson>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerson>>> = ({ signal }) => getPerson(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPerson>>>
export type GetPersonInfiniteQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetPersonInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPerson>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerson>>,
          TError,
          Awaited<ReturnType<typeof getPerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPerson>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerson>>,
          TError,
          Awaited<ReturnType<typeof getPerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPerson>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get person
 */

export function useGetPersonInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPerson>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPersonQueryOptions = <TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerson>>> = ({ signal }) => getPerson(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonQueryResult = NonNullable<Awaited<ReturnType<typeof getPerson>>>
export type GetPersonQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetPerson<TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerson>>,
          TError,
          Awaited<ReturnType<typeof getPerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerson<TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerson>>,
          TError,
          Awaited<ReturnType<typeof getPerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerson<TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get person
 */

export function useGetPerson<TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPersonSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerson>>> = ({ signal }) => getPerson(id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPerson>>>
export type GetPersonSuspenseQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetPersonSuspense<TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonSuspense<TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonSuspense<TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get person
 */

export function useGetPersonSuspense<TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Update person
 */
export const updatePerson = (
    id: number,
    personUpdateRequest: BodyType<PersonUpdateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Person>(
      {url: `/persons/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: personUpdateRequest, signal
    },
      options);
    }




export const getUpdatePersonMutationKey = () => ['updatePerson'] as const;

export const getUpdatePersonMutationOptions = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePerson>>, TError,UpdatePersonMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePerson>>, TError,UpdatePersonMutationVariables, TContext> => {

const mutationKey = getUpdatePersonMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePerson>>, UpdatePersonMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updatePerson(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePersonMutationResult = NonNullable<Awaited<ReturnType<typeof updatePerson>>>
    export type UpdatePersonMutationBody = BodyType<PersonUpdateRequest>
    export type UpdatePersonMutationError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>
    export type UpdatePersonMutationVariables = {id: number;data: BodyType<PersonUpdateRequest>}

    /**
 * @summary Update person
 */
export const useUpdatePerson = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePerson>>, TError,UpdatePersonMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePerson>>,
        TError,
        UpdatePersonMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePersonMutationOptions(options), queryClient);
    }

/**
 * @summary Delete person
 */
export const deletePerson = (
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/persons/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeletePersonMutationKey = () => ['deletePerson'] as const;

export const getDeletePersonMutationOptions = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | DeleteRestrictedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePerson>>, TError,DeletePersonMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePerson>>, TError,DeletePersonMutationVariables, TContext> => {

const mutationKey = getDeletePersonMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePerson>>, DeletePersonMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deletePerson(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePersonMutationResult = NonNullable<Awaited<ReturnType<typeof deletePerson>>>

    export type DeletePersonMutationError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | DeleteRestrictedResponse>
    export type DeletePersonMutationVariables = {id: number}

    /**
 * @summary Delete person
 */
export const useDeletePerson = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | DeleteRestrictedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePerson>>, TError,DeletePersonMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePerson>>,
        TError,
        DeletePersonMutationVariables,
        TContext
      > => {
      return useMutation(getDeletePersonMutationOptions(options), queryClient);
    }

/**
 * @summary Create panel account (invite)
 */
export const createPanelAccount = (
    panelAccountCreateRequest: BodyType<PanelAccountCreateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<PanelAccount>(
      {url: `/panel-accounts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: panelAccountCreateRequest, signal
    },
      options);
    }




export const getCreatePanelAccountMutationKey = () => ['createPanelAccount'] as const;

export const getCreatePanelAccountMutationOptions = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ConflictResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPanelAccount>>, TError,CreatePanelAccountMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPanelAccount>>, TError,CreatePanelAccountMutationVariables, TContext> => {

const mutationKey = getCreatePanelAccountMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPanelAccount>>, CreatePanelAccountMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createPanelAccount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePanelAccountMutationResult = NonNullable<Awaited<ReturnType<typeof createPanelAccount>>>
    export type CreatePanelAccountMutationBody = BodyType<PanelAccountCreateRequest>
    export type CreatePanelAccountMutationError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ConflictResponse | ValidationErrorResponse>
    export type CreatePanelAccountMutationVariables = {data: BodyType<PanelAccountCreateRequest>}

    /**
 * @summary Create panel account (invite)
 */
export const useCreatePanelAccount = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ConflictResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPanelAccount>>, TError,CreatePanelAccountMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPanelAccount>>,
        TError,
        CreatePanelAccountMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePanelAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Delete panel account
 */
export const deletePanelAccount = (
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/panel-accounts/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeletePanelAccountMutationKey = () => ['deletePanelAccount'] as const;

export const getDeletePanelAccountMutationOptions = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | DeleteRestrictedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePanelAccount>>, TError,DeletePanelAccountMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePanelAccount>>, TError,DeletePanelAccountMutationVariables, TContext> => {

const mutationKey = getDeletePanelAccountMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePanelAccount>>, DeletePanelAccountMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deletePanelAccount(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePanelAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deletePanelAccount>>>

    export type DeletePanelAccountMutationError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | DeleteRestrictedResponse>
    export type DeletePanelAccountMutationVariables = {id: number}

    /**
 * @summary Delete panel account
 */
export const useDeletePanelAccount = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | DeleteRestrictedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePanelAccount>>, TError,DeletePanelAccountMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePanelAccount>>,
        TError,
        DeletePanelAccountMutationVariables,
        TContext
      > => {
      return useMutation(getDeletePanelAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Create app account
 */
export const createAppAccount = (
    appAccountCreateRequest: BodyType<AppAccountCreateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<AppAccount>(
      {url: `/app-accounts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: appAccountCreateRequest, signal
    },
      options);
    }




export const getCreateAppAccountMutationKey = () => ['createAppAccount'] as const;

export const getCreateAppAccountMutationOptions = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ConflictResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAppAccount>>, TError,CreateAppAccountMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAppAccount>>, TError,CreateAppAccountMutationVariables, TContext> => {

const mutationKey = getCreateAppAccountMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAppAccount>>, CreateAppAccountMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createAppAccount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAppAccountMutationResult = NonNullable<Awaited<ReturnType<typeof createAppAccount>>>
    export type CreateAppAccountMutationBody = BodyType<AppAccountCreateRequest>
    export type CreateAppAccountMutationError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ConflictResponse | ValidationErrorResponse>
    export type CreateAppAccountMutationVariables = {data: BodyType<AppAccountCreateRequest>}

    /**
 * @summary Create app account
 */
export const useCreateAppAccount = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ConflictResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAppAccount>>, TError,CreateAppAccountMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAppAccount>>,
        TError,
        CreateAppAccountMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAppAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Get app account
 */
export const getAppAccount = (
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<AppAccount>(
      {url: `/app-accounts/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetAppAccountInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/app-accounts/${id}`
    ] as const;
    }

export const getGetAppAccountQueryKey = (id: number,) => {
    return [
    `/app-accounts/${id}`
    ] as const;
    }


export const getGetAppAccountInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAppAccount>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAppAccount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAppAccountInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppAccount>>> = ({ signal }) => getAppAccount(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAppAccount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAppAccountInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAppAccount>>>
export type GetAppAccountInfiniteQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useGetAppAccountInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAppAccount>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAppAccount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppAccount>>,
          TError,
          Awaited<ReturnType<typeof getAppAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppAccountInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAppAccount>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAppAccount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppAccount>>,
          TError,
          Awaited<ReturnType<typeof getAppAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppAccountInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAppAccount>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAppAccount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get app account
 */

export function useGetAppAccountInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAppAccount>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAppAccount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAppAccountInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAppAccountQueryOptions = <TData = Awaited<ReturnType<typeof getAppAccount>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppAccount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAppAccountQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppAccount>>> = ({ signal }) => getAppAccount(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAppAccount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAppAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getAppAccount>>>
export type GetAppAccountQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useGetAppAccount<TData = Awaited<ReturnType<typeof getAppAccount>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppAccount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppAccount>>,
          TError,
          Awaited<ReturnType<typeof getAppAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppAccount<TData = Awaited<ReturnType<typeof getAppAccount>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppAccount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppAccount>>,
          TError,
          Awaited<ReturnType<typeof getAppAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppAccount<TData = Awaited<ReturnType<typeof getAppAccount>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppAccount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get app account
 */

export function useGetAppAccount<TData = Awaited<ReturnType<typeof getAppAccount>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppAccount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAppAccountQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAppAccountSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAppAccount>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppAccount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAppAccountQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppAccount>>> = ({ signal }) => getAppAccount(id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppAccount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAppAccountSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAppAccount>>>
export type GetAppAccountSuspenseQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useGetAppAccountSuspense<TData = Awaited<ReturnType<typeof getAppAccount>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppAccount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppAccountSuspense<TData = Awaited<ReturnType<typeof getAppAccount>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppAccount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppAccountSuspense<TData = Awaited<ReturnType<typeof getAppAccount>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppAccount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get app account
 */

export function useGetAppAccountSuspense<TData = Awaited<ReturnType<typeof getAppAccount>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppAccount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAppAccountSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Delete app account
 */
export const deleteAppAccount = (
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/app-accounts/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteAppAccountMutationKey = () => ['deleteAppAccount'] as const;

export const getDeleteAppAccountMutationOptions = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAppAccount>>, TError,DeleteAppAccountMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAppAccount>>, TError,DeleteAppAccountMutationVariables, TContext> => {

const mutationKey = getDeleteAppAccountMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAppAccount>>, DeleteAppAccountMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteAppAccount(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAppAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAppAccount>>>

    export type DeleteAppAccountMutationError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>
    export type DeleteAppAccountMutationVariables = {id: number}

    /**
 * @summary Delete app account
 */
export const useDeleteAppAccount = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAppAccount>>, TError,DeleteAppAccountMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAppAccount>>,
        TError,
        DeleteAppAccountMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAppAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Regenerate PIN
 */
export const regenerateAppAccountPin = (
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<AppAccount>(
      {url: `/app-accounts/${id}/regenerate`, method: 'POST', signal
    },
      options);
    }




export const getRegenerateAppAccountPinMutationKey = () => ['regenerateAppAccountPin'] as const;

export const getRegenerateAppAccountPinMutationOptions = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateAppAccountPin>>, TError,RegenerateAppAccountPinMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof regenerateAppAccountPin>>, TError,RegenerateAppAccountPinMutationVariables, TContext> => {

const mutationKey = getRegenerateAppAccountPinMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateAppAccountPin>>, RegenerateAppAccountPinMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  regenerateAppAccountPin(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegenerateAppAccountPinMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateAppAccountPin>>>

    export type RegenerateAppAccountPinMutationError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>
    export type RegenerateAppAccountPinMutationVariables = {id: number}

    /**
 * @summary Regenerate PIN
 */
export const useRegenerateAppAccountPin = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateAppAccountPin>>, TError,RegenerateAppAccountPinMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regenerateAppAccountPin>>,
        TError,
        RegenerateAppAccountPinMutationVariables,
        TContext
      > => {
      return useMutation(getRegenerateAppAccountPinMutationOptions(options), queryClient);
    }

/**
 * @summary List suppliers
 */
export const listSuppliers = (
    params?: ListSuppliersParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<SupplierListResponse>(
      {url: `/suppliers`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListSuppliersInfiniteQueryKey = (params?: ListSuppliersParams,) => {
    return [
    'infinite', `/suppliers`, ...(params ? [params] : [])
    ] as const;
    }

export const getListSuppliersQueryKey = (params?: ListSuppliersParams,) => {
    return [
    `/suppliers`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSuppliersInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listSuppliers>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(params?: ListSuppliersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listSuppliers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSuppliersInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSuppliers>>> = ({ signal }) => listSuppliers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listSuppliers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSuppliersInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listSuppliers>>>
export type ListSuppliersInfiniteQueryError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>


export function useListSuppliersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listSuppliers>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params: undefined |  ListSuppliersParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listSuppliers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSuppliers>>,
          TError,
          Awaited<ReturnType<typeof listSuppliers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSuppliersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listSuppliers>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListSuppliersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listSuppliers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSuppliers>>,
          TError,
          Awaited<ReturnType<typeof listSuppliers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSuppliersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listSuppliers>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListSuppliersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listSuppliers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List suppliers
 */

export function useListSuppliersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listSuppliers>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListSuppliersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listSuppliers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSuppliersInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListSuppliersQueryOptions = <TData = Awaited<ReturnType<typeof listSuppliers>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(params?: ListSuppliersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuppliers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSuppliersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSuppliers>>> = ({ signal }) => listSuppliers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSuppliers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSuppliersQueryResult = NonNullable<Awaited<ReturnType<typeof listSuppliers>>>
export type ListSuppliersQueryError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>


export function useListSuppliers<TData = Awaited<ReturnType<typeof listSuppliers>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params: undefined |  ListSuppliersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuppliers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSuppliers>>,
          TError,
          Awaited<ReturnType<typeof listSuppliers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSuppliers<TData = Awaited<ReturnType<typeof listSuppliers>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListSuppliersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuppliers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSuppliers>>,
          TError,
          Awaited<ReturnType<typeof listSuppliers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSuppliers<TData = Awaited<ReturnType<typeof listSuppliers>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListSuppliersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuppliers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List suppliers
 */

export function useListSuppliers<TData = Awaited<ReturnType<typeof listSuppliers>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListSuppliersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuppliers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSuppliersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListSuppliersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listSuppliers>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(params?: ListSuppliersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSuppliers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSuppliersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSuppliers>>> = ({ signal }) => listSuppliers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSuppliers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSuppliersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listSuppliers>>>
export type ListSuppliersSuspenseQueryError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>


export function useListSuppliersSuspense<TData = Awaited<ReturnType<typeof listSuppliers>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params: undefined |  ListSuppliersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSuppliers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSuppliersSuspense<TData = Awaited<ReturnType<typeof listSuppliers>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListSuppliersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSuppliers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSuppliersSuspense<TData = Awaited<ReturnType<typeof listSuppliers>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListSuppliersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSuppliers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List suppliers
 */

export function useListSuppliersSuspense<TData = Awaited<ReturnType<typeof listSuppliers>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListSuppliersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSuppliers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSuppliersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Create supplier
 */
export const createSupplier = (
    supplierCreateRequest: BodyType<SupplierCreateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Supplier>(
      {url: `/suppliers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: supplierCreateRequest, signal
    },
      options);
    }




export const getCreateSupplierMutationKey = () => ['createSupplier'] as const;

export const getCreateSupplierMutationOptions = <TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSupplier>>, TError,CreateSupplierMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSupplier>>, TError,CreateSupplierMutationVariables, TContext> => {

const mutationKey = getCreateSupplierMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSupplier>>, CreateSupplierMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createSupplier(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSupplierMutationResult = NonNullable<Awaited<ReturnType<typeof createSupplier>>>
    export type CreateSupplierMutationBody = BodyType<SupplierCreateRequest>
    export type CreateSupplierMutationError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>
    export type CreateSupplierMutationVariables = {data: BodyType<SupplierCreateRequest>}

    /**
 * @summary Create supplier
 */
export const useCreateSupplier = <TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSupplier>>, TError,CreateSupplierMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSupplier>>,
        TError,
        CreateSupplierMutationVariables,
        TContext
      > => {
      return useMutation(getCreateSupplierMutationOptions(options), queryClient);
    }

/**
 * @summary Get supplier
 */
export const getSupplier = (
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Supplier>(
      {url: `/suppliers/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetSupplierInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/suppliers/${id}`
    ] as const;
    }

export const getGetSupplierQueryKey = (id: number,) => {
    return [
    `/suppliers/${id}`
    ] as const;
    }


export const getGetSupplierInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getSupplier>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSupplier>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupplierInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupplier>>> = ({ signal }) => getSupplier(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSupplier>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSupplierInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getSupplier>>>
export type GetSupplierInfiniteQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetSupplierInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getSupplier>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSupplier>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupplier>>,
          TError,
          Awaited<ReturnType<typeof getSupplier>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupplierInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getSupplier>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSupplier>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupplier>>,
          TError,
          Awaited<ReturnType<typeof getSupplier>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupplierInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getSupplier>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSupplier>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get supplier
 */

export function useGetSupplierInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getSupplier>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSupplier>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSupplierInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSupplierQueryOptions = <TData = Awaited<ReturnType<typeof getSupplier>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupplier>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupplierQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupplier>>> = ({ signal }) => getSupplier(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupplier>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSupplierQueryResult = NonNullable<Awaited<ReturnType<typeof getSupplier>>>
export type GetSupplierQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetSupplier<TData = Awaited<ReturnType<typeof getSupplier>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupplier>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupplier>>,
          TError,
          Awaited<ReturnType<typeof getSupplier>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupplier<TData = Awaited<ReturnType<typeof getSupplier>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupplier>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupplier>>,
          TError,
          Awaited<ReturnType<typeof getSupplier>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupplier<TData = Awaited<ReturnType<typeof getSupplier>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupplier>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get supplier
 */

export function useGetSupplier<TData = Awaited<ReturnType<typeof getSupplier>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupplier>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSupplierQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSupplierSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSupplier>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSupplier>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupplierQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupplier>>> = ({ signal }) => getSupplier(id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSupplier>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSupplierSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSupplier>>>
export type GetSupplierSuspenseQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetSupplierSuspense<TData = Awaited<ReturnType<typeof getSupplier>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSupplier>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupplierSuspense<TData = Awaited<ReturnType<typeof getSupplier>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSupplier>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupplierSuspense<TData = Awaited<ReturnType<typeof getSupplier>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSupplier>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get supplier
 */

export function useGetSupplierSuspense<TData = Awaited<ReturnType<typeof getSupplier>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSupplier>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSupplierSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Update supplier
 */
export const updateSupplier = (
    id: number,
    supplierUpdateRequest: BodyType<SupplierUpdateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Supplier>(
      {url: `/suppliers/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: supplierUpdateRequest, signal
    },
      options);
    }




export const getUpdateSupplierMutationKey = () => ['updateSupplier'] as const;

export const getUpdateSupplierMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSupplier>>, TError,UpdateSupplierMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSupplier>>, TError,UpdateSupplierMutationVariables, TContext> => {

const mutationKey = getUpdateSupplierMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSupplier>>, UpdateSupplierMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateSupplier(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSupplierMutationResult = NonNullable<Awaited<ReturnType<typeof updateSupplier>>>
    export type UpdateSupplierMutationBody = BodyType<SupplierUpdateRequest>
    export type UpdateSupplierMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>
    export type UpdateSupplierMutationVariables = {id: number;data: BodyType<SupplierUpdateRequest>}

    /**
 * @summary Update supplier
 */
export const useUpdateSupplier = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSupplier>>, TError,UpdateSupplierMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSupplier>>,
        TError,
        UpdateSupplierMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateSupplierMutationOptions(options), queryClient);
    }

/**
 * @summary Delete supplier
 */
export const deleteSupplier = (
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/suppliers/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteSupplierMutationKey = () => ['deleteSupplier'] as const;

export const getDeleteSupplierMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | DeleteRestrictedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSupplier>>, TError,DeleteSupplierMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSupplier>>, TError,DeleteSupplierMutationVariables, TContext> => {

const mutationKey = getDeleteSupplierMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSupplier>>, DeleteSupplierMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteSupplier(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSupplierMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSupplier>>>

    export type DeleteSupplierMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | DeleteRestrictedResponse>
    export type DeleteSupplierMutationVariables = {id: number}

    /**
 * @summary Delete supplier
 */
export const useDeleteSupplier = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | DeleteRestrictedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSupplier>>, TError,DeleteSupplierMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSupplier>>,
        TError,
        DeleteSupplierMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteSupplierMutationOptions(options), queryClient);
    }

/**
 * @summary List instruments
 */
export const listInstruments = (
    params?: ListInstrumentsParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<InstrumentListResponse>(
      {url: `/instruments`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListInstrumentsInfiniteQueryKey = (params?: ListInstrumentsParams,) => {
    return [
    'infinite', `/instruments`, ...(params ? [params] : [])
    ] as const;
    }

export const getListInstrumentsQueryKey = (params?: ListInstrumentsParams,) => {
    return [
    `/instruments`, ...(params ? [params] : [])
    ] as const;
    }


export const getListInstrumentsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listInstruments>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(params?: ListInstrumentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listInstruments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInstrumentsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInstruments>>> = ({ signal }) => listInstruments(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listInstruments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInstrumentsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listInstruments>>>
export type ListInstrumentsInfiniteQueryError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>


export function useListInstrumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listInstruments>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params: undefined |  ListInstrumentsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listInstruments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInstruments>>,
          TError,
          Awaited<ReturnType<typeof listInstruments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInstrumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listInstruments>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListInstrumentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listInstruments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInstruments>>,
          TError,
          Awaited<ReturnType<typeof listInstruments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInstrumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listInstruments>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListInstrumentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listInstruments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List instruments
 */

export function useListInstrumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listInstruments>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListInstrumentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listInstruments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInstrumentsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListInstrumentsQueryOptions = <TData = Awaited<ReturnType<typeof listInstruments>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(params?: ListInstrumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInstruments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInstrumentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInstruments>>> = ({ signal }) => listInstruments(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInstruments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInstrumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listInstruments>>>
export type ListInstrumentsQueryError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>


export function useListInstruments<TData = Awaited<ReturnType<typeof listInstruments>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params: undefined |  ListInstrumentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInstruments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInstruments>>,
          TError,
          Awaited<ReturnType<typeof listInstruments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInstruments<TData = Awaited<ReturnType<typeof listInstruments>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListInstrumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInstruments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInstruments>>,
          TError,
          Awaited<ReturnType<typeof listInstruments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInstruments<TData = Awaited<ReturnType<typeof listInstruments>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListInstrumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInstruments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List instruments
 */

export function useListInstruments<TData = Awaited<ReturnType<typeof listInstruments>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListInstrumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInstruments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInstrumentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListInstrumentsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listInstruments>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(params?: ListInstrumentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInstruments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInstrumentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInstruments>>> = ({ signal }) => listInstruments(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInstruments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInstrumentsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listInstruments>>>
export type ListInstrumentsSuspenseQueryError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>


export function useListInstrumentsSuspense<TData = Awaited<ReturnType<typeof listInstruments>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params: undefined |  ListInstrumentsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInstruments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInstrumentsSuspense<TData = Awaited<ReturnType<typeof listInstruments>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListInstrumentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInstruments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInstrumentsSuspense<TData = Awaited<ReturnType<typeof listInstruments>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListInstrumentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInstruments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List instruments
 */

export function useListInstrumentsSuspense<TData = Awaited<ReturnType<typeof listInstruments>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListInstrumentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInstruments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInstrumentsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Create instrument
 */
export const createInstrument = (
    instrumentCreateRequest: BodyType<InstrumentCreateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Instrument>(
      {url: `/instruments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: instrumentCreateRequest, signal
    },
      options);
    }




export const getCreateInstrumentMutationKey = () => ['createInstrument'] as const;

export const getCreateInstrumentMutationOptions = <TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInstrument>>, TError,CreateInstrumentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInstrument>>, TError,CreateInstrumentMutationVariables, TContext> => {

const mutationKey = getCreateInstrumentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInstrument>>, CreateInstrumentMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createInstrument(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInstrumentMutationResult = NonNullable<Awaited<ReturnType<typeof createInstrument>>>
    export type CreateInstrumentMutationBody = BodyType<InstrumentCreateRequest>
    export type CreateInstrumentMutationError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>
    export type CreateInstrumentMutationVariables = {data: BodyType<InstrumentCreateRequest>}

    /**
 * @summary Create instrument
 */
export const useCreateInstrument = <TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInstrument>>, TError,CreateInstrumentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createInstrument>>,
        TError,
        CreateInstrumentMutationVariables,
        TContext
      > => {
      return useMutation(getCreateInstrumentMutationOptions(options), queryClient);
    }

/**
 * @summary Get instrument
 */
export const getInstrument = (
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Instrument>(
      {url: `/instruments/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetInstrumentInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/instruments/${id}`
    ] as const;
    }

export const getGetInstrumentQueryKey = (id: number,) => {
    return [
    `/instruments/${id}`
    ] as const;
    }


export const getGetInstrumentInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getInstrument>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getInstrument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInstrumentInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInstrument>>> = ({ signal }) => getInstrument(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getInstrument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInstrumentInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getInstrument>>>
export type GetInstrumentInfiniteQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetInstrumentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getInstrument>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getInstrument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInstrument>>,
          TError,
          Awaited<ReturnType<typeof getInstrument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInstrumentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getInstrument>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getInstrument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInstrument>>,
          TError,
          Awaited<ReturnType<typeof getInstrument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInstrumentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getInstrument>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getInstrument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get instrument
 */

export function useGetInstrumentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getInstrument>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getInstrument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInstrumentInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetInstrumentQueryOptions = <TData = Awaited<ReturnType<typeof getInstrument>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstrument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInstrumentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInstrument>>> = ({ signal }) => getInstrument(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInstrument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInstrumentQueryResult = NonNullable<Awaited<ReturnType<typeof getInstrument>>>
export type GetInstrumentQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetInstrument<TData = Awaited<ReturnType<typeof getInstrument>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstrument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInstrument>>,
          TError,
          Awaited<ReturnType<typeof getInstrument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInstrument<TData = Awaited<ReturnType<typeof getInstrument>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstrument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInstrument>>,
          TError,
          Awaited<ReturnType<typeof getInstrument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInstrument<TData = Awaited<ReturnType<typeof getInstrument>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstrument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get instrument
 */

export function useGetInstrument<TData = Awaited<ReturnType<typeof getInstrument>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstrument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInstrumentQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetInstrumentSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getInstrument>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInstrument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInstrumentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInstrument>>> = ({ signal }) => getInstrument(id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInstrument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInstrumentSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getInstrument>>>
export type GetInstrumentSuspenseQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetInstrumentSuspense<TData = Awaited<ReturnType<typeof getInstrument>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInstrument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInstrumentSuspense<TData = Awaited<ReturnType<typeof getInstrument>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInstrument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInstrumentSuspense<TData = Awaited<ReturnType<typeof getInstrument>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInstrument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get instrument
 */

export function useGetInstrumentSuspense<TData = Awaited<ReturnType<typeof getInstrument>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getInstrument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInstrumentSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Update instrument
 */
export const updateInstrument = (
    id: number,
    instrumentUpdateRequest: BodyType<InstrumentUpdateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Instrument>(
      {url: `/instruments/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: instrumentUpdateRequest, signal
    },
      options);
    }




export const getUpdateInstrumentMutationKey = () => ['updateInstrument'] as const;

export const getUpdateInstrumentMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInstrument>>, TError,UpdateInstrumentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInstrument>>, TError,UpdateInstrumentMutationVariables, TContext> => {

const mutationKey = getUpdateInstrumentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInstrument>>, UpdateInstrumentMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateInstrument(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateInstrumentMutationResult = NonNullable<Awaited<ReturnType<typeof updateInstrument>>>
    export type UpdateInstrumentMutationBody = BodyType<InstrumentUpdateRequest>
    export type UpdateInstrumentMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>
    export type UpdateInstrumentMutationVariables = {id: number;data: BodyType<InstrumentUpdateRequest>}

    /**
 * @summary Update instrument
 */
export const useUpdateInstrument = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInstrument>>, TError,UpdateInstrumentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateInstrument>>,
        TError,
        UpdateInstrumentMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateInstrumentMutationOptions(options), queryClient);
    }

/**
 * Soft delete (ADR-0028): the instrument is withdrawn from the catalog — it stops appearing in lists and its id reads as gone — but the record is retained, so measurements that referenced it keep its data. Its serial number becomes reusable.
 * @summary Delete instrument
 */
export const deleteInstrument = (
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/instruments/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteInstrumentMutationKey = () => ['deleteInstrument'] as const;

export const getDeleteInstrumentMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInstrument>>, TError,DeleteInstrumentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteInstrument>>, TError,DeleteInstrumentMutationVariables, TContext> => {

const mutationKey = getDeleteInstrumentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInstrument>>, DeleteInstrumentMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteInstrument(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteInstrumentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInstrument>>>

    export type DeleteInstrumentMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse>
    export type DeleteInstrumentMutationVariables = {id: number}

    /**
 * @summary Delete instrument
 */
export const useDeleteInstrument = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInstrument>>, TError,DeleteInstrumentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteInstrument>>,
        TError,
        DeleteInstrumentMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteInstrumentMutationOptions(options), queryClient);
    }

/**
 * Results are ordered by product name ascending. Search matches the product name and the supplier's company and short names, diacritic-insensitive.
 * @summary List products
 */
export const listProducts = (
    params?: ListProductsParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<ProductListResponse>(
      {url: `/products`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListProductsInfiniteQueryKey = (params?: ListProductsParams,) => {
    return [
    'infinite', `/products`, ...(params ? [params] : [])
    ] as const;
    }

export const getListProductsQueryKey = (params?: ListProductsParams,) => {
    return [
    `/products`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProductsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listProducts>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(params?: ListProductsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProducts>>> = ({ signal }) => listProducts(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProductsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listProducts>>>
export type ListProductsInfiniteQueryError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>


export function useListProductsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProducts>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params: undefined |  ListProductsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProducts>>,
          TError,
          Awaited<ReturnType<typeof listProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProductsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProducts>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListProductsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProducts>>,
          TError,
          Awaited<ReturnType<typeof listProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProductsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProducts>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListProductsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List products
 */

export function useListProductsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProducts>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListProductsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProductsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProductsQueryOptions = <TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(params?: ListProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProducts>>> = ({ signal }) => listProducts(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listProducts>>>
export type ListProductsQueryError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>


export function useListProducts<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params: undefined |  ListProductsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProducts>>,
          TError,
          Awaited<ReturnType<typeof listProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProducts<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProducts>>,
          TError,
          Awaited<ReturnType<typeof listProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProducts<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List products
 */

export function useListProducts<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProductsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProductsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(params?: ListProductsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProducts>>> = ({ signal }) => listProducts(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProductsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listProducts>>>
export type ListProductsSuspenseQueryError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>


export function useListProductsSuspense<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params: undefined |  ListProductsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProductsSuspense<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListProductsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProductsSuspense<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListProductsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List products
 */

export function useListProductsSuspense<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListProductsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProductsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Create product
 */
export const createProduct = (
    productCreateRequest: BodyType<ProductCreateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Product>(
      {url: `/products`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productCreateRequest, signal
    },
      options);
    }




export const getCreateProductMutationKey = () => ['createProduct'] as const;

export const getCreateProductMutationOptions = <TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,CreateProductMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,CreateProductMutationVariables, TContext> => {

const mutationKey = getCreateProductMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProduct>>, CreateProductMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createProduct(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProductMutationResult = NonNullable<Awaited<ReturnType<typeof createProduct>>>
    export type CreateProductMutationBody = BodyType<ProductCreateRequest>
    export type CreateProductMutationError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>
    export type CreateProductMutationVariables = {data: BodyType<ProductCreateRequest>}

    /**
 * @summary Create product
 */
export const useCreateProduct = <TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,CreateProductMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProduct>>,
        TError,
        CreateProductMutationVariables,
        TContext
      > => {
      return useMutation(getCreateProductMutationOptions(options), queryClient);
    }

/**
 * @summary Get product
 */
export const getProduct = (
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Product>(
      {url: `/products/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetProductInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/products/${id}`
    ] as const;
    }

export const getGetProductQueryKey = (id: number,) => {
    return [
    `/products/${id}`
    ] as const;
    }


export const getGetProductInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProduct>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProduct>>> = ({ signal }) => getProduct(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProduct>>>
export type GetProductInfiniteQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetProductInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProduct>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProduct>>,
          TError,
          Awaited<ReturnType<typeof getProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProduct>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProduct>>,
          TError,
          Awaited<ReturnType<typeof getProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProduct>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get product
 */

export function useGetProductInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProduct>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProductQueryOptions = <TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProduct>>> = ({ signal }) => getProduct(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductQueryResult = NonNullable<Awaited<ReturnType<typeof getProduct>>>
export type GetProductQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProduct>>,
          TError,
          Awaited<ReturnType<typeof getProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProduct>>,
          TError,
          Awaited<ReturnType<typeof getProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get product
 */

export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProductSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProduct>>> = ({ signal }) => getProduct(id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProduct>>>
export type GetProductSuspenseQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetProductSuspense<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductSuspense<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductSuspense<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get product
 */

export function useGetProductSuspense<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Update product
 */
export const updateProduct = (
    id: number,
    productUpdateRequest: BodyType<ProductUpdateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Product>(
      {url: `/products/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: productUpdateRequest, signal
    },
      options);
    }




export const getUpdateProductMutationKey = () => ['updateProduct'] as const;

export const getUpdateProductMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,UpdateProductMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,UpdateProductMutationVariables, TContext> => {

const mutationKey = getUpdateProductMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProduct>>, UpdateProductMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateProduct(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProductMutationResult = NonNullable<Awaited<ReturnType<typeof updateProduct>>>
    export type UpdateProductMutationBody = BodyType<ProductUpdateRequest>
    export type UpdateProductMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>
    export type UpdateProductMutationVariables = {id: number;data: BodyType<ProductUpdateRequest>}

    /**
 * @summary Update product
 */
export const useUpdateProduct = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,UpdateProductMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProduct>>,
        TError,
        UpdateProductMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateProductMutationOptions(options), queryClient);
    }

/**
 * @summary Delete product
 */
export const deleteProduct = (
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/products/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteProductMutationKey = () => ['deleteProduct'] as const;

export const getDeleteProductMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | DeleteRestrictedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProduct>>, TError,DeleteProductMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProduct>>, TError,DeleteProductMutationVariables, TContext> => {

const mutationKey = getDeleteProductMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProduct>>, DeleteProductMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteProduct(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProduct>>>

    export type DeleteProductMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | DeleteRestrictedResponse>
    export type DeleteProductMutationVariables = {id: number}

    /**
 * @summary Delete product
 */
export const useDeleteProduct = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | DeleteRestrictedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProduct>>, TError,DeleteProductMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProduct>>,
        TError,
        DeleteProductMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteProductMutationOptions(options), queryClient);
    }

/**
 * Ordered newest-first by upload time (id tie-break), so the first row is exactly the certificate the product's latest_certificate reflects.
 * @summary List certificates for product
 */
export const listProductCertificates = (
    productId: number,
    params?: ListProductCertificatesParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<CertificateListResponse>(
      {url: `/products/${productId}/certificates`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListProductCertificatesInfiniteQueryKey = (productId: number,
    params?: ListProductCertificatesParams,) => {
    return [
    'infinite', `/products/${productId}/certificates`, ...(params ? [params] : [])
    ] as const;
    }

export const getListProductCertificatesQueryKey = (productId: number,
    params?: ListProductCertificatesParams,) => {
    return [
    `/products/${productId}/certificates`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProductCertificatesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listProductCertificates>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(productId: number,
    params?: ListProductCertificatesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProductCertificates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductCertificatesInfiniteQueryKey(productId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProductCertificates>>> = ({ signal }) => listProductCertificates(productId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: productId !== null && productId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProductCertificates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProductCertificatesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listProductCertificates>>>
export type ListProductCertificatesInfiniteQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>


export function useListProductCertificatesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProductCertificates>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 productId: number,
    params: undefined |  ListProductCertificatesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProductCertificates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProductCertificates>>,
          TError,
          Awaited<ReturnType<typeof listProductCertificates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProductCertificatesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProductCertificates>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 productId: number,
    params?: ListProductCertificatesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProductCertificates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProductCertificates>>,
          TError,
          Awaited<ReturnType<typeof listProductCertificates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProductCertificatesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProductCertificates>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 productId: number,
    params?: ListProductCertificatesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProductCertificates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List certificates for product
 */

export function useListProductCertificatesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProductCertificates>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 productId: number,
    params?: ListProductCertificatesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProductCertificates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProductCertificatesInfiniteQueryOptions(productId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProductCertificatesQueryOptions = <TData = Awaited<ReturnType<typeof listProductCertificates>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(productId: number,
    params?: ListProductCertificatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductCertificates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductCertificatesQueryKey(productId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProductCertificates>>> = ({ signal }) => listProductCertificates(productId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: productId !== null && productId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProductCertificates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProductCertificatesQueryResult = NonNullable<Awaited<ReturnType<typeof listProductCertificates>>>
export type ListProductCertificatesQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>


export function useListProductCertificates<TData = Awaited<ReturnType<typeof listProductCertificates>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 productId: number,
    params: undefined |  ListProductCertificatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductCertificates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProductCertificates>>,
          TError,
          Awaited<ReturnType<typeof listProductCertificates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProductCertificates<TData = Awaited<ReturnType<typeof listProductCertificates>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 productId: number,
    params?: ListProductCertificatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductCertificates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProductCertificates>>,
          TError,
          Awaited<ReturnType<typeof listProductCertificates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProductCertificates<TData = Awaited<ReturnType<typeof listProductCertificates>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 productId: number,
    params?: ListProductCertificatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductCertificates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List certificates for product
 */

export function useListProductCertificates<TData = Awaited<ReturnType<typeof listProductCertificates>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 productId: number,
    params?: ListProductCertificatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductCertificates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProductCertificatesQueryOptions(productId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProductCertificatesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listProductCertificates>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(productId: number,
    params?: ListProductCertificatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProductCertificates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductCertificatesQueryKey(productId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProductCertificates>>> = ({ signal }) => listProductCertificates(productId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProductCertificates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProductCertificatesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listProductCertificates>>>
export type ListProductCertificatesSuspenseQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>


export function useListProductCertificatesSuspense<TData = Awaited<ReturnType<typeof listProductCertificates>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 productId: number,
    params: undefined |  ListProductCertificatesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProductCertificates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProductCertificatesSuspense<TData = Awaited<ReturnType<typeof listProductCertificates>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 productId: number,
    params?: ListProductCertificatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProductCertificates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProductCertificatesSuspense<TData = Awaited<ReturnType<typeof listProductCertificates>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 productId: number,
    params?: ListProductCertificatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProductCertificates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List certificates for product
 */

export function useListProductCertificatesSuspense<TData = Awaited<ReturnType<typeof listProductCertificates>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 productId: number,
    params?: ListProductCertificatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProductCertificates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProductCertificatesSuspenseQueryOptions(productId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Upload certificate for product
 */
export const createProductCertificate = (
    productId: number,
    certificateCreateRequest: BodyType<CertificateCreateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {

      const formData = new FormData();
formData.append(`expires_at`, certificateCreateRequest.expires_at);
formData.append(`file`, certificateCreateRequest.file);

      return customFetch<Certificate>(
      {url: `/products/${productId}/certificates`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getCreateProductCertificateMutationKey = () => ['createProductCertificate'] as const;

export const getCreateProductCertificateMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductCertificate>>, TError,CreateProductCertificateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProductCertificate>>, TError,CreateProductCertificateMutationVariables, TContext> => {

const mutationKey = getCreateProductCertificateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProductCertificate>>, CreateProductCertificateMutationVariables> = (props) => {
          const {productId,data} = props ?? {};

          return  createProductCertificate(productId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProductCertificateMutationResult = NonNullable<Awaited<ReturnType<typeof createProductCertificate>>>
    export type CreateProductCertificateMutationBody = BodyType<CertificateCreateRequest>
    export type CreateProductCertificateMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>
    export type CreateProductCertificateMutationVariables = {productId: number;data: BodyType<CertificateCreateRequest>}

    /**
 * @summary Upload certificate for product
 */
export const useCreateProductCertificate = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductCertificate>>, TError,CreateProductCertificateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProductCertificate>>,
        TError,
        CreateProductCertificateMutationVariables,
        TContext
      > => {
      return useMutation(getCreateProductCertificateMutationOptions(options), queryClient);
    }

/**
 * @summary Get certificate
 */
export const getProductCertificate = (
    productId: number,
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Certificate>(
      {url: `/products/${productId}/certificates/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetProductCertificateInfiniteQueryKey = (productId: number,
    id: number,) => {
    return [
    'infinite', `/products/${productId}/certificates/${id}`
    ] as const;
    }

export const getGetProductCertificateQueryKey = (productId: number,
    id: number,) => {
    return [
    `/products/${productId}/certificates/${id}`
    ] as const;
    }


export const getGetProductCertificateInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProductCertificate>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(productId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductCertificate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductCertificateInfiniteQueryKey(productId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductCertificate>>> = ({ signal }) => getProductCertificate(productId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: productId !== null && productId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductCertificate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductCertificateInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProductCertificate>>>
export type GetProductCertificateInfiniteQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetProductCertificateInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProductCertificate>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 productId: number,
    id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductCertificate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductCertificate>>,
          TError,
          Awaited<ReturnType<typeof getProductCertificate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductCertificateInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProductCertificate>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 productId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductCertificate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductCertificate>>,
          TError,
          Awaited<ReturnType<typeof getProductCertificate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductCertificateInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProductCertificate>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 productId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductCertificate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get certificate
 */

export function useGetProductCertificateInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProductCertificate>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 productId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductCertificate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductCertificateInfiniteQueryOptions(productId,id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProductCertificateQueryOptions = <TData = Awaited<ReturnType<typeof getProductCertificate>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(productId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCertificate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductCertificateQueryKey(productId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductCertificate>>> = ({ signal }) => getProductCertificate(productId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: productId !== null && productId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductCertificate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductCertificateQueryResult = NonNullable<Awaited<ReturnType<typeof getProductCertificate>>>
export type GetProductCertificateQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetProductCertificate<TData = Awaited<ReturnType<typeof getProductCertificate>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 productId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCertificate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductCertificate>>,
          TError,
          Awaited<ReturnType<typeof getProductCertificate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductCertificate<TData = Awaited<ReturnType<typeof getProductCertificate>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 productId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCertificate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductCertificate>>,
          TError,
          Awaited<ReturnType<typeof getProductCertificate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductCertificate<TData = Awaited<ReturnType<typeof getProductCertificate>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 productId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCertificate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get certificate
 */

export function useGetProductCertificate<TData = Awaited<ReturnType<typeof getProductCertificate>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 productId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCertificate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductCertificateQueryOptions(productId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProductCertificateSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProductCertificate>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(productId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductCertificate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductCertificateQueryKey(productId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductCertificate>>> = ({ signal }) => getProductCertificate(productId,id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductCertificate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductCertificateSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProductCertificate>>>
export type GetProductCertificateSuspenseQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetProductCertificateSuspense<TData = Awaited<ReturnType<typeof getProductCertificate>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 productId: number,
    id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductCertificate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductCertificateSuspense<TData = Awaited<ReturnType<typeof getProductCertificate>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 productId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductCertificate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductCertificateSuspense<TData = Awaited<ReturnType<typeof getProductCertificate>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 productId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductCertificate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get certificate
 */

export function useGetProductCertificateSuspense<TData = Awaited<ReturnType<typeof getProductCertificate>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 productId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductCertificate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductCertificateSuspenseQueryOptions(productId,id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Delete certificate
 */
export const deleteProductCertificate = (
    productId: number,
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/products/${productId}/certificates/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteProductCertificateMutationKey = () => ['deleteProductCertificate'] as const;

export const getDeleteProductCertificateMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductCertificate>>, TError,DeleteProductCertificateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProductCertificate>>, TError,DeleteProductCertificateMutationVariables, TContext> => {

const mutationKey = getDeleteProductCertificateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProductCertificate>>, DeleteProductCertificateMutationVariables> = (props) => {
          const {productId,id} = props ?? {};

          return  deleteProductCertificate(productId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductCertificateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProductCertificate>>>

    export type DeleteProductCertificateMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse>
    export type DeleteProductCertificateMutationVariables = {productId: number;id: number}

    /**
 * @summary Delete certificate
 */
export const useDeleteProductCertificate = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductCertificate>>, TError,DeleteProductCertificateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProductCertificate>>,
        TError,
        DeleteProductCertificateMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteProductCertificateMutationOptions(options), queryClient);
    }

/**
 * The manufacturer-agnostic catalog of what a node or a connection needs — a category, a composition material and a size (ADR-0031). Read-only: rows are maintained from the console and the seeds until the client delivers the authoritative nomenclature, so there is no write surface. Ordered by category, then composition material, then size.
 * @summary List product specifications
 */
export const listProductSpecifications = (
    params?: ListProductSpecificationsParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<ProductSpecificationListResponse>(
      {url: `/product-specifications`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListProductSpecificationsInfiniteQueryKey = (params?: ListProductSpecificationsParams,) => {
    return [
    'infinite', `/product-specifications`, ...(params ? [params] : [])
    ] as const;
    }

export const getListProductSpecificationsQueryKey = (params?: ListProductSpecificationsParams,) => {
    return [
    `/product-specifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProductSpecificationsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listProductSpecifications>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(params?: ListProductSpecificationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProductSpecifications>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductSpecificationsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProductSpecifications>>> = ({ signal }) => listProductSpecifications(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProductSpecifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProductSpecificationsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listProductSpecifications>>>
export type ListProductSpecificationsInfiniteQueryError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>


export function useListProductSpecificationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProductSpecifications>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params: undefined |  ListProductSpecificationsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProductSpecifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProductSpecifications>>,
          TError,
          Awaited<ReturnType<typeof listProductSpecifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProductSpecificationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProductSpecifications>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListProductSpecificationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProductSpecifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProductSpecifications>>,
          TError,
          Awaited<ReturnType<typeof listProductSpecifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProductSpecificationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProductSpecifications>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListProductSpecificationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProductSpecifications>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List product specifications
 */

export function useListProductSpecificationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProductSpecifications>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListProductSpecificationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProductSpecifications>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProductSpecificationsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProductSpecificationsQueryOptions = <TData = Awaited<ReturnType<typeof listProductSpecifications>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(params?: ListProductSpecificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductSpecifications>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductSpecificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProductSpecifications>>> = ({ signal }) => listProductSpecifications(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProductSpecifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProductSpecificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listProductSpecifications>>>
export type ListProductSpecificationsQueryError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>


export function useListProductSpecifications<TData = Awaited<ReturnType<typeof listProductSpecifications>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params: undefined |  ListProductSpecificationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductSpecifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProductSpecifications>>,
          TError,
          Awaited<ReturnType<typeof listProductSpecifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProductSpecifications<TData = Awaited<ReturnType<typeof listProductSpecifications>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListProductSpecificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductSpecifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProductSpecifications>>,
          TError,
          Awaited<ReturnType<typeof listProductSpecifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProductSpecifications<TData = Awaited<ReturnType<typeof listProductSpecifications>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListProductSpecificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductSpecifications>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List product specifications
 */

export function useListProductSpecifications<TData = Awaited<ReturnType<typeof listProductSpecifications>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListProductSpecificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductSpecifications>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProductSpecificationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProductSpecificationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listProductSpecifications>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(params?: ListProductSpecificationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProductSpecifications>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductSpecificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProductSpecifications>>> = ({ signal }) => listProductSpecifications(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProductSpecifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProductSpecificationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listProductSpecifications>>>
export type ListProductSpecificationsSuspenseQueryError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>


export function useListProductSpecificationsSuspense<TData = Awaited<ReturnType<typeof listProductSpecifications>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params: undefined |  ListProductSpecificationsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProductSpecifications>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProductSpecificationsSuspense<TData = Awaited<ReturnType<typeof listProductSpecifications>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListProductSpecificationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProductSpecifications>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProductSpecificationsSuspense<TData = Awaited<ReturnType<typeof listProductSpecifications>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListProductSpecificationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProductSpecifications>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List product specifications
 */

export function useListProductSpecificationsSuspense<TData = Awaited<ReturnType<typeof listProductSpecifications>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListProductSpecificationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProductSpecifications>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProductSpecificationsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * The company-level catalog of generic node parts — rings, bases, covers. Newest first. Search matches the name, diacritic-insensitive; withdrawn entries never appear.
 * @summary List node component types
 */
export const listNodeComponentTypes = (
    params?: ListNodeComponentTypesParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<NodeComponentTypeListResponse>(
      {url: `/node-component-types`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListNodeComponentTypesInfiniteQueryKey = (params?: ListNodeComponentTypesParams,) => {
    return [
    'infinite', `/node-component-types`, ...(params ? [params] : [])
    ] as const;
    }

export const getListNodeComponentTypesQueryKey = (params?: ListNodeComponentTypesParams,) => {
    return [
    `/node-component-types`, ...(params ? [params] : [])
    ] as const;
    }


export const getListNodeComponentTypesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listNodeComponentTypes>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(params?: ListNodeComponentTypesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listNodeComponentTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNodeComponentTypesInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNodeComponentTypes>>> = ({ signal }) => listNodeComponentTypes(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listNodeComponentTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNodeComponentTypesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listNodeComponentTypes>>>
export type ListNodeComponentTypesInfiniteQueryError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>


export function useListNodeComponentTypesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listNodeComponentTypes>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params: undefined |  ListNodeComponentTypesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listNodeComponentTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNodeComponentTypes>>,
          TError,
          Awaited<ReturnType<typeof listNodeComponentTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNodeComponentTypesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listNodeComponentTypes>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListNodeComponentTypesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listNodeComponentTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNodeComponentTypes>>,
          TError,
          Awaited<ReturnType<typeof listNodeComponentTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNodeComponentTypesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listNodeComponentTypes>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListNodeComponentTypesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listNodeComponentTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List node component types
 */

export function useListNodeComponentTypesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listNodeComponentTypes>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListNodeComponentTypesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listNodeComponentTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNodeComponentTypesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListNodeComponentTypesQueryOptions = <TData = Awaited<ReturnType<typeof listNodeComponentTypes>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(params?: ListNodeComponentTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNodeComponentTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNodeComponentTypesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNodeComponentTypes>>> = ({ signal }) => listNodeComponentTypes(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNodeComponentTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNodeComponentTypesQueryResult = NonNullable<Awaited<ReturnType<typeof listNodeComponentTypes>>>
export type ListNodeComponentTypesQueryError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>


export function useListNodeComponentTypes<TData = Awaited<ReturnType<typeof listNodeComponentTypes>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params: undefined |  ListNodeComponentTypesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNodeComponentTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNodeComponentTypes>>,
          TError,
          Awaited<ReturnType<typeof listNodeComponentTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNodeComponentTypes<TData = Awaited<ReturnType<typeof listNodeComponentTypes>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListNodeComponentTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNodeComponentTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNodeComponentTypes>>,
          TError,
          Awaited<ReturnType<typeof listNodeComponentTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNodeComponentTypes<TData = Awaited<ReturnType<typeof listNodeComponentTypes>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListNodeComponentTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNodeComponentTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List node component types
 */

export function useListNodeComponentTypes<TData = Awaited<ReturnType<typeof listNodeComponentTypes>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListNodeComponentTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNodeComponentTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNodeComponentTypesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListNodeComponentTypesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listNodeComponentTypes>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(params?: ListNodeComponentTypesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNodeComponentTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNodeComponentTypesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNodeComponentTypes>>> = ({ signal }) => listNodeComponentTypes(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNodeComponentTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNodeComponentTypesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listNodeComponentTypes>>>
export type ListNodeComponentTypesSuspenseQueryError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>


export function useListNodeComponentTypesSuspense<TData = Awaited<ReturnType<typeof listNodeComponentTypes>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params: undefined |  ListNodeComponentTypesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNodeComponentTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNodeComponentTypesSuspense<TData = Awaited<ReturnType<typeof listNodeComponentTypes>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListNodeComponentTypesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNodeComponentTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNodeComponentTypesSuspense<TData = Awaited<ReturnType<typeof listNodeComponentTypes>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListNodeComponentTypesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNodeComponentTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List node component types
 */

export function useListNodeComponentTypesSuspense<TData = Awaited<ReturnType<typeof listNodeComponentTypes>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListNodeComponentTypesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNodeComponentTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNodeComponentTypesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Create node component type
 */
export const createNodeComponentType = (
    nodeComponentTypeCreateRequest: BodyType<NodeComponentTypeCreateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<NodeComponentType>(
      {url: `/node-component-types`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: nodeComponentTypeCreateRequest, signal
    },
      options);
    }




export const getCreateNodeComponentTypeMutationKey = () => ['createNodeComponentType'] as const;

export const getCreateNodeComponentTypeMutationOptions = <TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNodeComponentType>>, TError,CreateNodeComponentTypeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createNodeComponentType>>, TError,CreateNodeComponentTypeMutationVariables, TContext> => {

const mutationKey = getCreateNodeComponentTypeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNodeComponentType>>, CreateNodeComponentTypeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createNodeComponentType(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateNodeComponentTypeMutationResult = NonNullable<Awaited<ReturnType<typeof createNodeComponentType>>>
    export type CreateNodeComponentTypeMutationBody = BodyType<NodeComponentTypeCreateRequest>
    export type CreateNodeComponentTypeMutationError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>
    export type CreateNodeComponentTypeMutationVariables = {data: BodyType<NodeComponentTypeCreateRequest>}

    /**
 * @summary Create node component type
 */
export const useCreateNodeComponentType = <TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNodeComponentType>>, TError,CreateNodeComponentTypeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createNodeComponentType>>,
        TError,
        CreateNodeComponentTypeMutationVariables,
        TContext
      > => {
      return useMutation(getCreateNodeComponentTypeMutationOptions(options), queryClient);
    }

/**
 * @summary Get node component type
 */
export const getNodeComponentType = (
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<NodeComponentType>(
      {url: `/node-component-types/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetNodeComponentTypeInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/node-component-types/${id}`
    ] as const;
    }

export const getGetNodeComponentTypeQueryKey = (id: number,) => {
    return [
    `/node-component-types/${id}`
    ] as const;
    }


export const getGetNodeComponentTypeInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getNodeComponentType>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNodeComponentType>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNodeComponentTypeInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNodeComponentType>>> = ({ signal }) => getNodeComponentType(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNodeComponentType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNodeComponentTypeInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getNodeComponentType>>>
export type GetNodeComponentTypeInfiniteQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetNodeComponentTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNodeComponentType>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNodeComponentType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNodeComponentType>>,
          TError,
          Awaited<ReturnType<typeof getNodeComponentType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNodeComponentTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNodeComponentType>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNodeComponentType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNodeComponentType>>,
          TError,
          Awaited<ReturnType<typeof getNodeComponentType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNodeComponentTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNodeComponentType>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNodeComponentType>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get node component type
 */

export function useGetNodeComponentTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNodeComponentType>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNodeComponentType>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNodeComponentTypeInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetNodeComponentTypeQueryOptions = <TData = Awaited<ReturnType<typeof getNodeComponentType>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNodeComponentType>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNodeComponentTypeQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNodeComponentType>>> = ({ signal }) => getNodeComponentType(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNodeComponentType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNodeComponentTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getNodeComponentType>>>
export type GetNodeComponentTypeQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetNodeComponentType<TData = Awaited<ReturnType<typeof getNodeComponentType>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNodeComponentType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNodeComponentType>>,
          TError,
          Awaited<ReturnType<typeof getNodeComponentType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNodeComponentType<TData = Awaited<ReturnType<typeof getNodeComponentType>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNodeComponentType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNodeComponentType>>,
          TError,
          Awaited<ReturnType<typeof getNodeComponentType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNodeComponentType<TData = Awaited<ReturnType<typeof getNodeComponentType>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNodeComponentType>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get node component type
 */

export function useGetNodeComponentType<TData = Awaited<ReturnType<typeof getNodeComponentType>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNodeComponentType>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNodeComponentTypeQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetNodeComponentTypeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getNodeComponentType>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNodeComponentType>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNodeComponentTypeQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNodeComponentType>>> = ({ signal }) => getNodeComponentType(id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNodeComponentType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNodeComponentTypeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getNodeComponentType>>>
export type GetNodeComponentTypeSuspenseQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetNodeComponentTypeSuspense<TData = Awaited<ReturnType<typeof getNodeComponentType>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNodeComponentType>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNodeComponentTypeSuspense<TData = Awaited<ReturnType<typeof getNodeComponentType>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNodeComponentType>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNodeComponentTypeSuspense<TData = Awaited<ReturnType<typeof getNodeComponentType>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNodeComponentType>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get node component type
 */

export function useGetNodeComponentTypeSuspense<TData = Awaited<ReturnType<typeof getNodeComponentType>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNodeComponentType>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNodeComponentTypeSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Update node component type
 */
export const updateNodeComponentType = (
    id: number,
    nodeComponentTypeUpdateRequest: BodyType<NodeComponentTypeUpdateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<NodeComponentType>(
      {url: `/node-component-types/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: nodeComponentTypeUpdateRequest, signal
    },
      options);
    }




export const getUpdateNodeComponentTypeMutationKey = () => ['updateNodeComponentType'] as const;

export const getUpdateNodeComponentTypeMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNodeComponentType>>, TError,UpdateNodeComponentTypeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateNodeComponentType>>, TError,UpdateNodeComponentTypeMutationVariables, TContext> => {

const mutationKey = getUpdateNodeComponentTypeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNodeComponentType>>, UpdateNodeComponentTypeMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateNodeComponentType(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateNodeComponentTypeMutationResult = NonNullable<Awaited<ReturnType<typeof updateNodeComponentType>>>
    export type UpdateNodeComponentTypeMutationBody = BodyType<NodeComponentTypeUpdateRequest>
    export type UpdateNodeComponentTypeMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>
    export type UpdateNodeComponentTypeMutationVariables = {id: number;data: BodyType<NodeComponentTypeUpdateRequest>}

    /**
 * @summary Update node component type
 */
export const useUpdateNodeComponentType = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNodeComponentType>>, TError,UpdateNodeComponentTypeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateNodeComponentType>>,
        TError,
        UpdateNodeComponentTypeMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateNodeComponentTypeMutationOptions(options), queryClient);
    }

/**
 * Soft delete (ADR-0028): the entry is withdrawn from the catalog — it stops appearing in lists and its id reads as gone — but the record is retained, so everything already keyed on it keeps its data.
 * @summary Delete node component type
 */
export const deleteNodeComponentType = (
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/node-component-types/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteNodeComponentTypeMutationKey = () => ['deleteNodeComponentType'] as const;

export const getDeleteNodeComponentTypeMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNodeComponentType>>, TError,DeleteNodeComponentTypeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteNodeComponentType>>, TError,DeleteNodeComponentTypeMutationVariables, TContext> => {

const mutationKey = getDeleteNodeComponentTypeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNodeComponentType>>, DeleteNodeComponentTypeMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteNodeComponentType(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteNodeComponentTypeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNodeComponentType>>>

    export type DeleteNodeComponentTypeMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse>
    export type DeleteNodeComponentTypeMutationVariables = {id: number}

    /**
 * @summary Delete node component type
 */
export const useDeleteNodeComponentType = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNodeComponentType>>, TError,DeleteNodeComponentTypeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteNodeComponentType>>,
        TError,
        DeleteNodeComponentTypeMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteNodeComponentTypeMutationOptions(options), queryClient);
    }

/**
 * Results are ordered newest first (`created_at` descending). Search matches the project name and the address city/street, diacritic-insensitive.
 * @summary List projects
 */
export const listProjects = (
    params?: ListProjectsParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<ProjectListResponse>(
      {url: `/projects`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListProjectsInfiniteQueryKey = (params?: ListProjectsParams,) => {
    return [
    'infinite', `/projects`, ...(params ? [params] : [])
    ] as const;
    }

export const getListProjectsQueryKey = (params?: ListProjectsParams,) => {
    return [
    `/projects`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProjectsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listProjects>>>, TError = ErrorType<UnauthorizedResponse>>(params?: ListProjectsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjects>>> = ({ signal }) => listProjects(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listProjects>>>
export type ListProjectsInfiniteQueryError = ErrorType<UnauthorizedResponse>


export function useListProjectsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjects>>>, TError = ErrorType<UnauthorizedResponse>>(
 params: undefined |  ListProjectsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjects>>,
          TError,
          Awaited<ReturnType<typeof listProjects>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjects>>>, TError = ErrorType<UnauthorizedResponse>>(
 params?: ListProjectsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjects>>,
          TError,
          Awaited<ReturnType<typeof listProjects>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjects>>>, TError = ErrorType<UnauthorizedResponse>>(
 params?: ListProjectsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List projects
 */

export function useListProjectsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjects>>>, TError = ErrorType<UnauthorizedResponse>>(
 params?: ListProjectsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProjectsQueryOptions = <TData = Awaited<ReturnType<typeof listProjects>>, TError = ErrorType<UnauthorizedResponse>>(params?: ListProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjects>>> = ({ signal }) => listProjects(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof listProjects>>>
export type ListProjectsQueryError = ErrorType<UnauthorizedResponse>


export function useListProjects<TData = Awaited<ReturnType<typeof listProjects>>, TError = ErrorType<UnauthorizedResponse>>(
 params: undefined |  ListProjectsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjects>>,
          TError,
          Awaited<ReturnType<typeof listProjects>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjects<TData = Awaited<ReturnType<typeof listProjects>>, TError = ErrorType<UnauthorizedResponse>>(
 params?: ListProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjects>>,
          TError,
          Awaited<ReturnType<typeof listProjects>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjects<TData = Awaited<ReturnType<typeof listProjects>>, TError = ErrorType<UnauthorizedResponse>>(
 params?: ListProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List projects
 */

export function useListProjects<TData = Awaited<ReturnType<typeof listProjects>>, TError = ErrorType<UnauthorizedResponse>>(
 params?: ListProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProjectsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listProjects>>, TError = ErrorType<UnauthorizedResponse>>(params?: ListProjectsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjects>>> = ({ signal }) => listProjects(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listProjects>>>
export type ListProjectsSuspenseQueryError = ErrorType<UnauthorizedResponse>


export function useListProjectsSuspense<TData = Awaited<ReturnType<typeof listProjects>>, TError = ErrorType<UnauthorizedResponse>>(
 params: undefined |  ListProjectsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectsSuspense<TData = Awaited<ReturnType<typeof listProjects>>, TError = ErrorType<UnauthorizedResponse>>(
 params?: ListProjectsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectsSuspense<TData = Awaited<ReturnType<typeof listProjects>>, TError = ErrorType<UnauthorizedResponse>>(
 params?: ListProjectsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List projects
 */

export function useListProjectsSuspense<TData = Awaited<ReturnType<typeof listProjects>>, TError = ErrorType<UnauthorizedResponse>>(
 params?: ListProjectsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Create project
 */
export const createProject = (
    projectCreateRequest: BodyType<ProjectCreateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Project>(
      {url: `/projects`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: projectCreateRequest, signal
    },
      options);
    }




export const getCreateProjectMutationKey = () => ['createProject'] as const;

export const getCreateProjectMutationOptions = <TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,CreateProjectMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,CreateProjectMutationVariables, TContext> => {

const mutationKey = getCreateProjectMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProject>>, CreateProjectMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createProject(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof createProject>>>
    export type CreateProjectMutationBody = BodyType<ProjectCreateRequest>
    export type CreateProjectMutationError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>
    export type CreateProjectMutationVariables = {data: BodyType<ProjectCreateRequest>}

    /**
 * @summary Create project
 */
export const useCreateProject = <TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,CreateProjectMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProject>>,
        TError,
        CreateProjectMutationVariables,
        TContext
      > => {
      return useMutation(getCreateProjectMutationOptions(options), queryClient);
    }

/**
 * @summary Get project
 */
export const getProject = (
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Project>(
      {url: `/projects/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetProjectInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/projects/${id}`
    ] as const;
    }

export const getGetProjectQueryKey = (id: number,) => {
    return [
    `/projects/${id}`
    ] as const;
    }


export const getGetProjectInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProject>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProject>>> = ({ signal }) => getProject(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProject>>>
export type GetProjectInfiniteQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useGetProjectInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProject>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProject>>,
          TError,
          Awaited<ReturnType<typeof getProject>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProject>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProject>>,
          TError,
          Awaited<ReturnType<typeof getProject>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProject>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project
 */

export function useGetProjectInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProject>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProjectQueryOptions = <TData = Awaited<ReturnType<typeof getProject>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProject>>> = ({ signal }) => getProject(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectQueryResult = NonNullable<Awaited<ReturnType<typeof getProject>>>
export type GetProjectQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProject>>,
          TError,
          Awaited<ReturnType<typeof getProject>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProject>>,
          TError,
          Awaited<ReturnType<typeof getProject>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project
 */

export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProjectSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProject>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProject>>> = ({ signal }) => getProject(id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProject>>>
export type GetProjectSuspenseQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useGetProjectSuspense<TData = Awaited<ReturnType<typeof getProject>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectSuspense<TData = Awaited<ReturnType<typeof getProject>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectSuspense<TData = Awaited<ReturnType<typeof getProject>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project
 */

export function useGetProjectSuspense<TData = Awaited<ReturnType<typeof getProject>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Update project
 */
export const updateProject = (
    id: number,
    projectUpdateRequest: BodyType<ProjectUpdateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Project>(
      {url: `/projects/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: projectUpdateRequest, signal
    },
      options);
    }




export const getUpdateProjectMutationKey = () => ['updateProject'] as const;

export const getUpdateProjectMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,UpdateProjectMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,UpdateProjectMutationVariables, TContext> => {

const mutationKey = getUpdateProjectMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProject>>, UpdateProjectMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateProject(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof updateProject>>>
    export type UpdateProjectMutationBody = BodyType<ProjectUpdateRequest>
    export type UpdateProjectMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>
    export type UpdateProjectMutationVariables = {id: number;data: BodyType<ProjectUpdateRequest>}

    /**
 * @summary Update project
 */
export const useUpdateProject = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,UpdateProjectMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProject>>,
        TError,
        UpdateProjectMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateProjectMutationOptions(options), queryClient);
    }

/**
 * @summary Delete project
 */
export const deleteProject = (
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/projects/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteProjectMutationKey = () => ['deleteProject'] as const;

export const getDeleteProjectMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,DeleteProjectMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,DeleteProjectMutationVariables, TContext> => {

const mutationKey = getDeleteProjectMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProject>>, DeleteProjectMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteProject(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProject>>>

    export type DeleteProjectMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse>
    export type DeleteProjectMutationVariables = {id: number}

    /**
 * @summary Delete project
 */
export const useDeleteProject = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,DeleteProjectMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProject>>,
        TError,
        DeleteProjectMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteProjectMutationOptions(options), queryClient);
    }

/**
 * Results are ordered by creation (`id` ascending). Search matches the project product's label and the product name, diacritic-insensitive.
 * @summary List project products
 */
export const listProjectProducts = (
    projectId: number,
    params?: ListProjectProductsParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<ProjectProductListResponse>(
      {url: `/projects/${projectId}/products`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListProjectProductsInfiniteQueryKey = (projectId: number,
    params?: ListProjectProductsParams,) => {
    return [
    'infinite', `/projects/${projectId}/products`, ...(params ? [params] : [])
    ] as const;
    }

export const getListProjectProductsQueryKey = (projectId: number,
    params?: ListProjectProductsParams,) => {
    return [
    `/projects/${projectId}/products`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProjectProductsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listProjectProducts>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(projectId: number,
    params?: ListProjectProductsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectProductsInfiniteQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectProducts>>> = ({ signal }) => listProjectProducts(projectId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectProductsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectProducts>>>
export type ListProjectProductsInfiniteQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>


export function useListProjectProductsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectProducts>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params: undefined |  ListProjectProductsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectProducts>>,
          TError,
          Awaited<ReturnType<typeof listProjectProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectProductsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectProducts>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectProductsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectProducts>>,
          TError,
          Awaited<ReturnType<typeof listProjectProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectProductsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectProducts>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectProductsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List project products
 */

export function useListProjectProductsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectProducts>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectProductsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectProductsInfiniteQueryOptions(projectId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProjectProductsQueryOptions = <TData = Awaited<ReturnType<typeof listProjectProducts>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(projectId: number,
    params?: ListProjectProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectProductsQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectProducts>>> = ({ signal }) => listProjectProducts(projectId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjectProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectProducts>>>
export type ListProjectProductsQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>


export function useListProjectProducts<TData = Awaited<ReturnType<typeof listProjectProducts>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params: undefined |  ListProjectProductsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectProducts>>,
          TError,
          Awaited<ReturnType<typeof listProjectProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectProducts<TData = Awaited<ReturnType<typeof listProjectProducts>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectProducts>>,
          TError,
          Awaited<ReturnType<typeof listProjectProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectProducts<TData = Awaited<ReturnType<typeof listProjectProducts>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List project products
 */

export function useListProjectProducts<TData = Awaited<ReturnType<typeof listProjectProducts>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectProductsQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProjectProductsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listProjectProducts>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(projectId: number,
    params?: ListProjectProductsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectProductsQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectProducts>>> = ({ signal }) => listProjectProducts(projectId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectProductsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectProducts>>>
export type ListProjectProductsSuspenseQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>


export function useListProjectProductsSuspense<TData = Awaited<ReturnType<typeof listProjectProducts>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params: undefined |  ListProjectProductsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectProductsSuspense<TData = Awaited<ReturnType<typeof listProjectProducts>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectProductsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectProductsSuspense<TData = Awaited<ReturnType<typeof listProjectProducts>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectProductsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List project products
 */

export function useListProjectProductsSuspense<TData = Awaited<ReturnType<typeof listProjectProducts>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectProductsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectProductsSuspenseQueryOptions(projectId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * A project holds at most one product per Product Specification: a product whose specification another product on the project already fulfills is rejected with a 422 keyed by `product_id`.
 * @summary Add product to project
 */
export const createProjectProduct = (
    projectId: number,
    projectProductCreateRequest: BodyType<ProjectProductCreateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {

      const formData = new FormData();
formData.append(`product_id`, projectProductCreateRequest.product_id.toString())
formData.append(`label`, projectProductCreateRequest.label);
if(projectProductCreateRequest.material_card !== undefined) {
 formData.append(`material_card`, projectProductCreateRequest.material_card);
 }

      return customFetch<ProjectProduct>(
      {url: `/projects/${projectId}/products`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getCreateProjectProductMutationKey = () => ['createProjectProduct'] as const;

export const getCreateProjectProductMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectProduct>>, TError,CreateProjectProductMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProjectProduct>>, TError,CreateProjectProductMutationVariables, TContext> => {

const mutationKey = getCreateProjectProductMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProjectProduct>>, CreateProjectProductMutationVariables> = (props) => {
          const {projectId,data} = props ?? {};

          return  createProjectProduct(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProjectProductMutationResult = NonNullable<Awaited<ReturnType<typeof createProjectProduct>>>
    export type CreateProjectProductMutationBody = BodyType<ProjectProductCreateRequest>
    export type CreateProjectProductMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>
    export type CreateProjectProductMutationVariables = {projectId: number;data: BodyType<ProjectProductCreateRequest>}

    /**
 * @summary Add product to project
 */
export const useCreateProjectProduct = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectProduct>>, TError,CreateProjectProductMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProjectProduct>>,
        TError,
        CreateProjectProductMutationVariables,
        TContext
      > => {
      return useMutation(getCreateProjectProductMutationOptions(options), queryClient);
    }

/**
 * @summary Get project product
 */
export const getProjectProduct = (
    projectId: number,
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<ProjectProduct>(
      {url: `/projects/${projectId}/products/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetProjectProductInfiniteQueryKey = (projectId: number,
    id: number,) => {
    return [
    'infinite', `/projects/${projectId}/products/${id}`
    ] as const;
    }

export const getGetProjectProductQueryKey = (projectId: number,
    id: number,) => {
    return [
    `/projects/${projectId}/products/${id}`
    ] as const;
    }


export const getGetProjectProductInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProjectProduct>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectProductInfiniteQueryKey(projectId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectProduct>>> = ({ signal }) => getProjectProduct(projectId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectProduct>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectProductInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectProduct>>>
export type GetProjectProductInfiniteQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetProjectProductInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectProduct>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectProduct>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectProduct>>,
          TError,
          Awaited<ReturnType<typeof getProjectProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectProductInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectProduct>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectProduct>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectProduct>>,
          TError,
          Awaited<ReturnType<typeof getProjectProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectProductInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectProduct>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project product
 */

export function useGetProjectProductInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectProduct>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectProductInfiniteQueryOptions(projectId,id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProjectProductQueryOptions = <TData = Awaited<ReturnType<typeof getProjectProduct>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectProductQueryKey(projectId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectProduct>>> = ({ signal }) => getProjectProduct(projectId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjectProduct>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectProductQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectProduct>>>
export type GetProjectProductQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetProjectProduct<TData = Awaited<ReturnType<typeof getProjectProduct>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectProduct>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectProduct>>,
          TError,
          Awaited<ReturnType<typeof getProjectProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectProduct<TData = Awaited<ReturnType<typeof getProjectProduct>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectProduct>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectProduct>>,
          TError,
          Awaited<ReturnType<typeof getProjectProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectProduct<TData = Awaited<ReturnType<typeof getProjectProduct>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project product
 */

export function useGetProjectProduct<TData = Awaited<ReturnType<typeof getProjectProduct>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectProductQueryOptions(projectId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProjectProductSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProjectProduct>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectProductQueryKey(projectId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectProduct>>> = ({ signal }) => getProjectProduct(projectId,id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectProduct>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectProductSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectProduct>>>
export type GetProjectProductSuspenseQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetProjectProductSuspense<TData = Awaited<ReturnType<typeof getProjectProduct>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectProductSuspense<TData = Awaited<ReturnType<typeof getProjectProduct>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectProductSuspense<TData = Awaited<ReturnType<typeof getProjectProduct>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project product
 */

export function useGetProjectProductSuspense<TData = Awaited<ReturnType<typeof getProjectProduct>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectProduct>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectProductSuspenseQueryOptions(projectId,id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Update project product
 */
export const updateProjectProduct = (
    projectId: number,
    id: number,
    projectProductUpdateRequest: BodyType<ProjectProductUpdateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(projectProductUpdateRequest.label !== undefined) {
 formData.append(`label`, projectProductUpdateRequest.label);
 }
if(projectProductUpdateRequest.material_card !== undefined) {
 formData.append(`material_card`, projectProductUpdateRequest.material_card);
 }

      return customFetch<ProjectProduct>(
      {url: `/projects/${projectId}/products/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getUpdateProjectProductMutationKey = () => ['updateProjectProduct'] as const;

export const getUpdateProjectProductMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProjectProduct>>, TError,UpdateProjectProductMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProjectProduct>>, TError,UpdateProjectProductMutationVariables, TContext> => {

const mutationKey = getUpdateProjectProductMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProjectProduct>>, UpdateProjectProductMutationVariables> = (props) => {
          const {projectId,id,data} = props ?? {};

          return  updateProjectProduct(projectId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProjectProductMutationResult = NonNullable<Awaited<ReturnType<typeof updateProjectProduct>>>
    export type UpdateProjectProductMutationBody = BodyType<ProjectProductUpdateRequest>
    export type UpdateProjectProductMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>
    export type UpdateProjectProductMutationVariables = {projectId: number;id: number;data: BodyType<ProjectProductUpdateRequest>}

    /**
 * @summary Update project product
 */
export const useUpdateProjectProduct = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProjectProduct>>, TError,UpdateProjectProductMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProjectProduct>>,
        TError,
        UpdateProjectProductMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateProjectProductMutationOptions(options), queryClient);
    }

/**
 * @summary Remove product from project
 */
export const deleteProjectProduct = (
    projectId: number,
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/projects/${projectId}/products/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteProjectProductMutationKey = () => ['deleteProjectProduct'] as const;

export const getDeleteProjectProductMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectProduct>>, TError,DeleteProjectProductMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProjectProduct>>, TError,DeleteProjectProductMutationVariables, TContext> => {

const mutationKey = getDeleteProjectProductMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProjectProduct>>, DeleteProjectProductMutationVariables> = (props) => {
          const {projectId,id} = props ?? {};

          return  deleteProjectProduct(projectId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectProductMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProjectProduct>>>

    export type DeleteProjectProductMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse>
    export type DeleteProjectProductMutationVariables = {projectId: number;id: number}

    /**
 * @summary Remove product from project
 */
export const useDeleteProjectProduct = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectProduct>>, TError,DeleteProjectProductMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProjectProduct>>,
        TError,
        DeleteProjectProductMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteProjectProductMutationOptions(options), queryClient);
    }

/**
 * Results are ordered by creation (`id` ascending) — predefined slots first, in their canonical order, then custom rows.
 * @summary List project documents
 */
export const listProjectDocuments = (
    projectId: number,
    params?: ListProjectDocumentsParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<ProjectDocumentListResponse>(
      {url: `/projects/${projectId}/documents`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListProjectDocumentsInfiniteQueryKey = (projectId: number,
    params?: ListProjectDocumentsParams,) => {
    return [
    'infinite', `/projects/${projectId}/documents`, ...(params ? [params] : [])
    ] as const;
    }

export const getListProjectDocumentsQueryKey = (projectId: number,
    params?: ListProjectDocumentsParams,) => {
    return [
    `/projects/${projectId}/documents`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProjectDocumentsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listProjectDocuments>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(projectId: number,
    params?: ListProjectDocumentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectDocumentsInfiniteQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectDocuments>>> = ({ signal }) => listProjectDocuments(projectId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectDocumentsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectDocuments>>>
export type ListProjectDocumentsInfiniteQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useListProjectDocumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectDocuments>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    params: undefined |  ListProjectDocumentsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectDocuments>>,
          TError,
          Awaited<ReturnType<typeof listProjectDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectDocumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectDocuments>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectDocumentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectDocuments>>,
          TError,
          Awaited<ReturnType<typeof listProjectDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectDocumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectDocuments>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectDocumentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List project documents
 */

export function useListProjectDocumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectDocuments>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectDocumentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectDocumentsInfiniteQueryOptions(projectId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProjectDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listProjectDocuments>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(projectId: number,
    params?: ListProjectDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectDocumentsQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectDocuments>>> = ({ signal }) => listProjectDocuments(projectId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjectDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectDocuments>>>
export type ListProjectDocumentsQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useListProjectDocuments<TData = Awaited<ReturnType<typeof listProjectDocuments>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    params: undefined |  ListProjectDocumentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectDocuments>>,
          TError,
          Awaited<ReturnType<typeof listProjectDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectDocuments<TData = Awaited<ReturnType<typeof listProjectDocuments>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectDocuments>>,
          TError,
          Awaited<ReturnType<typeof listProjectDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectDocuments<TData = Awaited<ReturnType<typeof listProjectDocuments>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List project documents
 */

export function useListProjectDocuments<TData = Awaited<ReturnType<typeof listProjectDocuments>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectDocumentsQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProjectDocumentsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listProjectDocuments>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(projectId: number,
    params?: ListProjectDocumentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectDocumentsQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectDocuments>>> = ({ signal }) => listProjectDocuments(projectId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectDocumentsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectDocuments>>>
export type ListProjectDocumentsSuspenseQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useListProjectDocumentsSuspense<TData = Awaited<ReturnType<typeof listProjectDocuments>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    params: undefined |  ListProjectDocumentsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectDocumentsSuspense<TData = Awaited<ReturnType<typeof listProjectDocuments>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectDocumentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectDocumentsSuspense<TData = Awaited<ReturnType<typeof listProjectDocuments>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectDocumentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List project documents
 */

export function useListProjectDocumentsSuspense<TData = Awaited<ReturnType<typeof listProjectDocuments>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectDocumentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectDocumentsSuspenseQueryOptions(projectId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Upload document to project
 */
export const createProjectDocument = (
    projectId: number,
    projectDocumentCreateRequest: BodyType<ProjectDocumentCreateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {

      const formData = new FormData();
formData.append(`label`, projectDocumentCreateRequest.label);
formData.append(`file`, projectDocumentCreateRequest.file);

      return customFetch<ProjectDocument>(
      {url: `/projects/${projectId}/documents`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getCreateProjectDocumentMutationKey = () => ['createProjectDocument'] as const;

export const getCreateProjectDocumentMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectDocument>>, TError,CreateProjectDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProjectDocument>>, TError,CreateProjectDocumentMutationVariables, TContext> => {

const mutationKey = getCreateProjectDocumentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProjectDocument>>, CreateProjectDocumentMutationVariables> = (props) => {
          const {projectId,data} = props ?? {};

          return  createProjectDocument(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProjectDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof createProjectDocument>>>
    export type CreateProjectDocumentMutationBody = BodyType<ProjectDocumentCreateRequest>
    export type CreateProjectDocumentMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>
    export type CreateProjectDocumentMutationVariables = {projectId: number;data: BodyType<ProjectDocumentCreateRequest>}

    /**
 * @summary Upload document to project
 */
export const useCreateProjectDocument = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectDocument>>, TError,CreateProjectDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProjectDocument>>,
        TError,
        CreateProjectDocumentMutationVariables,
        TContext
      > => {
      return useMutation(getCreateProjectDocumentMutationOptions(options), queryClient);
    }

/**
 * @summary Get project document
 */
export const getProjectDocument = (
    projectId: number,
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<ProjectDocument>(
      {url: `/projects/${projectId}/documents/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetProjectDocumentInfiniteQueryKey = (projectId: number,
    id: number,) => {
    return [
    'infinite', `/projects/${projectId}/documents/${id}`
    ] as const;
    }

export const getGetProjectDocumentQueryKey = (projectId: number,
    id: number,) => {
    return [
    `/projects/${projectId}/documents/${id}`
    ] as const;
    }


export const getGetProjectDocumentInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProjectDocument>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectDocument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectDocumentInfiniteQueryKey(projectId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectDocument>>> = ({ signal }) => getProjectDocument(projectId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectDocumentInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectDocument>>>
export type GetProjectDocumentInfiniteQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useGetProjectDocumentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectDocument>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectDocument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectDocument>>,
          TError,
          Awaited<ReturnType<typeof getProjectDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectDocumentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectDocument>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectDocument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectDocument>>,
          TError,
          Awaited<ReturnType<typeof getProjectDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectDocumentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectDocument>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectDocument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project document
 */

export function useGetProjectDocumentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectDocument>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectDocument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectDocumentInfiniteQueryOptions(projectId,id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProjectDocumentQueryOptions = <TData = Awaited<ReturnType<typeof getProjectDocument>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectDocument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectDocumentQueryKey(projectId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectDocument>>> = ({ signal }) => getProjectDocument(projectId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjectDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectDocument>>>
export type GetProjectDocumentQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useGetProjectDocument<TData = Awaited<ReturnType<typeof getProjectDocument>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectDocument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectDocument>>,
          TError,
          Awaited<ReturnType<typeof getProjectDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectDocument<TData = Awaited<ReturnType<typeof getProjectDocument>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectDocument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectDocument>>,
          TError,
          Awaited<ReturnType<typeof getProjectDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectDocument<TData = Awaited<ReturnType<typeof getProjectDocument>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectDocument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project document
 */

export function useGetProjectDocument<TData = Awaited<ReturnType<typeof getProjectDocument>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectDocument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectDocumentQueryOptions(projectId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProjectDocumentSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProjectDocument>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectDocument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectDocumentQueryKey(projectId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectDocument>>> = ({ signal }) => getProjectDocument(projectId,id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectDocumentSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectDocument>>>
export type GetProjectDocumentSuspenseQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useGetProjectDocumentSuspense<TData = Awaited<ReturnType<typeof getProjectDocument>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectDocument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectDocumentSuspense<TData = Awaited<ReturnType<typeof getProjectDocument>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectDocument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectDocumentSuspense<TData = Awaited<ReturnType<typeof getProjectDocument>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectDocument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project document
 */

export function useGetProjectDocumentSuspense<TData = Awaited<ReturnType<typeof getProjectDocument>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectDocument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectDocumentSuspenseQueryOptions(projectId,id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Update project document
 */
export const updateProjectDocument = (
    projectId: number,
    id: number,
    projectDocumentUpdateRequest: BodyType<ProjectDocumentUpdateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(projectDocumentUpdateRequest.label !== undefined) {
 formData.append(`label`, projectDocumentUpdateRequest.label);
 }
if(projectDocumentUpdateRequest.file !== undefined) {
 formData.append(`file`, projectDocumentUpdateRequest.file);
 }

      return customFetch<ProjectDocument>(
      {url: `/projects/${projectId}/documents/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getUpdateProjectDocumentMutationKey = () => ['updateProjectDocument'] as const;

export const getUpdateProjectDocumentMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProjectDocument>>, TError,UpdateProjectDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProjectDocument>>, TError,UpdateProjectDocumentMutationVariables, TContext> => {

const mutationKey = getUpdateProjectDocumentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProjectDocument>>, UpdateProjectDocumentMutationVariables> = (props) => {
          const {projectId,id,data} = props ?? {};

          return  updateProjectDocument(projectId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProjectDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof updateProjectDocument>>>
    export type UpdateProjectDocumentMutationBody = BodyType<ProjectDocumentUpdateRequest>
    export type UpdateProjectDocumentMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>
    export type UpdateProjectDocumentMutationVariables = {projectId: number;id: number;data: BodyType<ProjectDocumentUpdateRequest>}

    /**
 * @summary Update project document
 */
export const useUpdateProjectDocument = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProjectDocument>>, TError,UpdateProjectDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProjectDocument>>,
        TError,
        UpdateProjectDocumentMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateProjectDocumentMutationOptions(options), queryClient);
    }

/**
 * @summary Delete project document
 */
export const deleteProjectDocument = (
    projectId: number,
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/projects/${projectId}/documents/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteProjectDocumentMutationKey = () => ['deleteProjectDocument'] as const;

export const getDeleteProjectDocumentMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectDocument>>, TError,DeleteProjectDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProjectDocument>>, TError,DeleteProjectDocumentMutationVariables, TContext> => {

const mutationKey = getDeleteProjectDocumentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProjectDocument>>, DeleteProjectDocumentMutationVariables> = (props) => {
          const {projectId,id} = props ?? {};

          return  deleteProjectDocument(projectId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProjectDocument>>>

    export type DeleteProjectDocumentMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse>
    export type DeleteProjectDocumentMutationVariables = {projectId: number;id: number}

    /**
 * @summary Delete project document
 */
export const useDeleteProjectDocument = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectDocument>>, TError,DeleteProjectDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProjectDocument>>,
        TError,
        DeleteProjectDocumentMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteProjectDocumentMutationOptions(options), queryClient);
    }

/**
 * Results are ordered by creation (`id` ascending) — predefined slots first, in their canonical order, then custom rows.
 * @summary List project persons
 */
export const listProjectPersons = (
    projectId: number,
    params?: ListProjectPersonsParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<ProjectPersonListResponse>(
      {url: `/projects/${projectId}/persons`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListProjectPersonsInfiniteQueryKey = (projectId: number,
    params?: ListProjectPersonsParams,) => {
    return [
    'infinite', `/projects/${projectId}/persons`, ...(params ? [params] : [])
    ] as const;
    }

export const getListProjectPersonsQueryKey = (projectId: number,
    params?: ListProjectPersonsParams,) => {
    return [
    `/projects/${projectId}/persons`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProjectPersonsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listProjectPersons>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(projectId: number,
    params?: ListProjectPersonsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectPersons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectPersonsInfiniteQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectPersons>>> = ({ signal }) => listProjectPersons(projectId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectPersons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectPersonsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectPersons>>>
export type ListProjectPersonsInfiniteQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useListProjectPersonsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectPersons>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    params: undefined |  ListProjectPersonsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectPersons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectPersons>>,
          TError,
          Awaited<ReturnType<typeof listProjectPersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectPersonsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectPersons>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectPersonsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectPersons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectPersons>>,
          TError,
          Awaited<ReturnType<typeof listProjectPersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectPersonsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectPersons>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectPersonsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectPersons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List project persons
 */

export function useListProjectPersonsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectPersons>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectPersonsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectPersons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectPersonsInfiniteQueryOptions(projectId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProjectPersonsQueryOptions = <TData = Awaited<ReturnType<typeof listProjectPersons>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(projectId: number,
    params?: ListProjectPersonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectPersons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectPersonsQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectPersons>>> = ({ signal }) => listProjectPersons(projectId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjectPersons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectPersonsQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectPersons>>>
export type ListProjectPersonsQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useListProjectPersons<TData = Awaited<ReturnType<typeof listProjectPersons>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    params: undefined |  ListProjectPersonsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectPersons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectPersons>>,
          TError,
          Awaited<ReturnType<typeof listProjectPersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectPersons<TData = Awaited<ReturnType<typeof listProjectPersons>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectPersonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectPersons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectPersons>>,
          TError,
          Awaited<ReturnType<typeof listProjectPersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectPersons<TData = Awaited<ReturnType<typeof listProjectPersons>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectPersonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectPersons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List project persons
 */

export function useListProjectPersons<TData = Awaited<ReturnType<typeof listProjectPersons>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectPersonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectPersons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectPersonsQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProjectPersonsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listProjectPersons>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(projectId: number,
    params?: ListProjectPersonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectPersons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectPersonsQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectPersons>>> = ({ signal }) => listProjectPersons(projectId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectPersons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectPersonsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectPersons>>>
export type ListProjectPersonsSuspenseQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useListProjectPersonsSuspense<TData = Awaited<ReturnType<typeof listProjectPersons>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    params: undefined |  ListProjectPersonsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectPersons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectPersonsSuspense<TData = Awaited<ReturnType<typeof listProjectPersons>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectPersonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectPersons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectPersonsSuspense<TData = Awaited<ReturnType<typeof listProjectPersons>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectPersonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectPersons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List project persons
 */

export function useListProjectPersonsSuspense<TData = Awaited<ReturnType<typeof listProjectPersons>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectPersonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectPersons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectPersonsSuspenseQueryOptions(projectId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Add person to project
 */
export const createProjectPerson = (
    projectId: number,
    projectPersonCreateRequest: BodyType<ProjectPersonCreateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<ProjectPerson>(
      {url: `/projects/${projectId}/persons`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: projectPersonCreateRequest, signal
    },
      options);
    }




export const getCreateProjectPersonMutationKey = () => ['createProjectPerson'] as const;

export const getCreateProjectPersonMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectPerson>>, TError,CreateProjectPersonMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProjectPerson>>, TError,CreateProjectPersonMutationVariables, TContext> => {

const mutationKey = getCreateProjectPersonMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProjectPerson>>, CreateProjectPersonMutationVariables> = (props) => {
          const {projectId,data} = props ?? {};

          return  createProjectPerson(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProjectPersonMutationResult = NonNullable<Awaited<ReturnType<typeof createProjectPerson>>>
    export type CreateProjectPersonMutationBody = BodyType<ProjectPersonCreateRequest>
    export type CreateProjectPersonMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>
    export type CreateProjectPersonMutationVariables = {projectId: number;data: BodyType<ProjectPersonCreateRequest>}

    /**
 * @summary Add person to project
 */
export const useCreateProjectPerson = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectPerson>>, TError,CreateProjectPersonMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProjectPerson>>,
        TError,
        CreateProjectPersonMutationVariables,
        TContext
      > => {
      return useMutation(getCreateProjectPersonMutationOptions(options), queryClient);
    }

/**
 * @summary Get project person
 */
export const getProjectPerson = (
    projectId: number,
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<ProjectPerson>(
      {url: `/projects/${projectId}/persons/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetProjectPersonInfiniteQueryKey = (projectId: number,
    id: number,) => {
    return [
    'infinite', `/projects/${projectId}/persons/${id}`
    ] as const;
    }

export const getGetProjectPersonQueryKey = (projectId: number,
    id: number,) => {
    return [
    `/projects/${projectId}/persons/${id}`
    ] as const;
    }


export const getGetProjectPersonInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProjectPerson>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectPerson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectPersonInfiniteQueryKey(projectId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectPerson>>> = ({ signal }) => getProjectPerson(projectId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectPerson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectPersonInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectPerson>>>
export type GetProjectPersonInfiniteQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useGetProjectPersonInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectPerson>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectPerson>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectPerson>>,
          TError,
          Awaited<ReturnType<typeof getProjectPerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectPersonInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectPerson>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectPerson>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectPerson>>,
          TError,
          Awaited<ReturnType<typeof getProjectPerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectPersonInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectPerson>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectPerson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project person
 */

export function useGetProjectPersonInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectPerson>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectPerson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectPersonInfiniteQueryOptions(projectId,id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProjectPersonQueryOptions = <TData = Awaited<ReturnType<typeof getProjectPerson>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectPerson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectPersonQueryKey(projectId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectPerson>>> = ({ signal }) => getProjectPerson(projectId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjectPerson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectPersonQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectPerson>>>
export type GetProjectPersonQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useGetProjectPerson<TData = Awaited<ReturnType<typeof getProjectPerson>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectPerson>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectPerson>>,
          TError,
          Awaited<ReturnType<typeof getProjectPerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectPerson<TData = Awaited<ReturnType<typeof getProjectPerson>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectPerson>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectPerson>>,
          TError,
          Awaited<ReturnType<typeof getProjectPerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectPerson<TData = Awaited<ReturnType<typeof getProjectPerson>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectPerson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project person
 */

export function useGetProjectPerson<TData = Awaited<ReturnType<typeof getProjectPerson>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectPerson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectPersonQueryOptions(projectId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProjectPersonSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProjectPerson>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectPerson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectPersonQueryKey(projectId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectPerson>>> = ({ signal }) => getProjectPerson(projectId,id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectPerson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectPersonSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectPerson>>>
export type GetProjectPersonSuspenseQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useGetProjectPersonSuspense<TData = Awaited<ReturnType<typeof getProjectPerson>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectPerson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectPersonSuspense<TData = Awaited<ReturnType<typeof getProjectPerson>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectPerson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectPersonSuspense<TData = Awaited<ReturnType<typeof getProjectPerson>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectPerson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project person
 */

export function useGetProjectPersonSuspense<TData = Awaited<ReturnType<typeof getProjectPerson>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectPerson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectPersonSuspenseQueryOptions(projectId,id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Update project person
 */
export const updateProjectPerson = (
    projectId: number,
    id: number,
    projectPersonUpdateRequest: BodyType<ProjectPersonUpdateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<ProjectPerson>(
      {url: `/projects/${projectId}/persons/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: projectPersonUpdateRequest, signal
    },
      options);
    }




export const getUpdateProjectPersonMutationKey = () => ['updateProjectPerson'] as const;

export const getUpdateProjectPersonMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProjectPerson>>, TError,UpdateProjectPersonMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProjectPerson>>, TError,UpdateProjectPersonMutationVariables, TContext> => {

const mutationKey = getUpdateProjectPersonMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProjectPerson>>, UpdateProjectPersonMutationVariables> = (props) => {
          const {projectId,id,data} = props ?? {};

          return  updateProjectPerson(projectId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProjectPersonMutationResult = NonNullable<Awaited<ReturnType<typeof updateProjectPerson>>>
    export type UpdateProjectPersonMutationBody = BodyType<ProjectPersonUpdateRequest>
    export type UpdateProjectPersonMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>
    export type UpdateProjectPersonMutationVariables = {projectId: number;id: number;data: BodyType<ProjectPersonUpdateRequest>}

    /**
 * @summary Update project person
 */
export const useUpdateProjectPerson = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProjectPerson>>, TError,UpdateProjectPersonMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProjectPerson>>,
        TError,
        UpdateProjectPersonMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateProjectPersonMutationOptions(options), queryClient);
    }

/**
 * @summary Remove person from project
 */
export const deleteProjectPerson = (
    projectId: number,
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/projects/${projectId}/persons/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteProjectPersonMutationKey = () => ['deleteProjectPerson'] as const;

export const getDeleteProjectPersonMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectPerson>>, TError,DeleteProjectPersonMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProjectPerson>>, TError,DeleteProjectPersonMutationVariables, TContext> => {

const mutationKey = getDeleteProjectPersonMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProjectPerson>>, DeleteProjectPersonMutationVariables> = (props) => {
          const {projectId,id} = props ?? {};

          return  deleteProjectPerson(projectId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectPersonMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProjectPerson>>>

    export type DeleteProjectPersonMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse>
    export type DeleteProjectPersonMutationVariables = {projectId: number;id: number}

    /**
 * @summary Remove person from project
 */
export const useDeleteProjectPerson = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectPerson>>, TError,DeleteProjectPersonMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProjectPerson>>,
        TError,
        DeleteProjectPersonMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteProjectPersonMutationOptions(options), queryClient);
    }

/**
 * @summary List project benchmarks
 */
export const listProjectBenchmarks = (
    projectId: number,
    params?: ListProjectBenchmarksParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<BenchmarkListResponse>(
      {url: `/projects/${projectId}/benchmarks`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListProjectBenchmarksInfiniteQueryKey = (projectId: number,
    params?: ListProjectBenchmarksParams,) => {
    return [
    'infinite', `/projects/${projectId}/benchmarks`, ...(params ? [params] : [])
    ] as const;
    }

export const getListProjectBenchmarksQueryKey = (projectId: number,
    params?: ListProjectBenchmarksParams,) => {
    return [
    `/projects/${projectId}/benchmarks`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProjectBenchmarksInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listProjectBenchmarks>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(projectId: number,
    params?: ListProjectBenchmarksParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectBenchmarks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectBenchmarksInfiniteQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectBenchmarks>>> = ({ signal }) => listProjectBenchmarks(projectId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectBenchmarks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectBenchmarksInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectBenchmarks>>>
export type ListProjectBenchmarksInfiniteQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>


export function useListProjectBenchmarksInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectBenchmarks>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params: undefined |  ListProjectBenchmarksParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectBenchmarks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectBenchmarks>>,
          TError,
          Awaited<ReturnType<typeof listProjectBenchmarks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectBenchmarksInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectBenchmarks>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectBenchmarksParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectBenchmarks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectBenchmarks>>,
          TError,
          Awaited<ReturnType<typeof listProjectBenchmarks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectBenchmarksInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectBenchmarks>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectBenchmarksParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectBenchmarks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List project benchmarks
 */

export function useListProjectBenchmarksInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectBenchmarks>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectBenchmarksParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectBenchmarks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectBenchmarksInfiniteQueryOptions(projectId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProjectBenchmarksQueryOptions = <TData = Awaited<ReturnType<typeof listProjectBenchmarks>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(projectId: number,
    params?: ListProjectBenchmarksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectBenchmarks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectBenchmarksQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectBenchmarks>>> = ({ signal }) => listProjectBenchmarks(projectId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjectBenchmarks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectBenchmarksQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectBenchmarks>>>
export type ListProjectBenchmarksQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>


export function useListProjectBenchmarks<TData = Awaited<ReturnType<typeof listProjectBenchmarks>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params: undefined |  ListProjectBenchmarksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectBenchmarks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectBenchmarks>>,
          TError,
          Awaited<ReturnType<typeof listProjectBenchmarks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectBenchmarks<TData = Awaited<ReturnType<typeof listProjectBenchmarks>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectBenchmarksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectBenchmarks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectBenchmarks>>,
          TError,
          Awaited<ReturnType<typeof listProjectBenchmarks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectBenchmarks<TData = Awaited<ReturnType<typeof listProjectBenchmarks>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectBenchmarksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectBenchmarks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List project benchmarks
 */

export function useListProjectBenchmarks<TData = Awaited<ReturnType<typeof listProjectBenchmarks>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectBenchmarksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectBenchmarks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectBenchmarksQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProjectBenchmarksSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listProjectBenchmarks>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(projectId: number,
    params?: ListProjectBenchmarksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectBenchmarks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectBenchmarksQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectBenchmarks>>> = ({ signal }) => listProjectBenchmarks(projectId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectBenchmarks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectBenchmarksSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectBenchmarks>>>
export type ListProjectBenchmarksSuspenseQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>


export function useListProjectBenchmarksSuspense<TData = Awaited<ReturnType<typeof listProjectBenchmarks>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params: undefined |  ListProjectBenchmarksParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectBenchmarks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectBenchmarksSuspense<TData = Awaited<ReturnType<typeof listProjectBenchmarks>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectBenchmarksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectBenchmarks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectBenchmarksSuspense<TData = Awaited<ReturnType<typeof listProjectBenchmarks>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectBenchmarksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectBenchmarks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List project benchmarks
 */

export function useListProjectBenchmarksSuspense<TData = Awaited<ReturnType<typeof listProjectBenchmarks>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectBenchmarksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectBenchmarks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectBenchmarksSuspenseQueryOptions(projectId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Add benchmark to project
 */
export const createProjectBenchmark = (
    projectId: number,
    benchmarkCreateRequest: BodyType<BenchmarkCreateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Benchmark>(
      {url: `/projects/${projectId}/benchmarks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: benchmarkCreateRequest, signal
    },
      options);
    }




export const getCreateProjectBenchmarkMutationKey = () => ['createProjectBenchmark'] as const;

export const getCreateProjectBenchmarkMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectBenchmark>>, TError,CreateProjectBenchmarkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProjectBenchmark>>, TError,CreateProjectBenchmarkMutationVariables, TContext> => {

const mutationKey = getCreateProjectBenchmarkMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProjectBenchmark>>, CreateProjectBenchmarkMutationVariables> = (props) => {
          const {projectId,data} = props ?? {};

          return  createProjectBenchmark(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProjectBenchmarkMutationResult = NonNullable<Awaited<ReturnType<typeof createProjectBenchmark>>>
    export type CreateProjectBenchmarkMutationBody = BodyType<BenchmarkCreateRequest>
    export type CreateProjectBenchmarkMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>
    export type CreateProjectBenchmarkMutationVariables = {projectId: number;data: BodyType<BenchmarkCreateRequest>}

    /**
 * @summary Add benchmark to project
 */
export const useCreateProjectBenchmark = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectBenchmark>>, TError,CreateProjectBenchmarkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProjectBenchmark>>,
        TError,
        CreateProjectBenchmarkMutationVariables,
        TContext
      > => {
      return useMutation(getCreateProjectBenchmarkMutationOptions(options), queryClient);
    }

/**
 * @summary Get project benchmark
 */
export const getProjectBenchmark = (
    projectId: number,
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Benchmark>(
      {url: `/projects/${projectId}/benchmarks/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetProjectBenchmarkInfiniteQueryKey = (projectId: number,
    id: number,) => {
    return [
    'infinite', `/projects/${projectId}/benchmarks/${id}`
    ] as const;
    }

export const getGetProjectBenchmarkQueryKey = (projectId: number,
    id: number,) => {
    return [
    `/projects/${projectId}/benchmarks/${id}`
    ] as const;
    }


export const getGetProjectBenchmarkInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProjectBenchmark>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectBenchmark>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectBenchmarkInfiniteQueryKey(projectId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectBenchmark>>> = ({ signal }) => getProjectBenchmark(projectId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectBenchmark>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectBenchmarkInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectBenchmark>>>
export type GetProjectBenchmarkInfiniteQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetProjectBenchmarkInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectBenchmark>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectBenchmark>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectBenchmark>>,
          TError,
          Awaited<ReturnType<typeof getProjectBenchmark>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectBenchmarkInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectBenchmark>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectBenchmark>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectBenchmark>>,
          TError,
          Awaited<ReturnType<typeof getProjectBenchmark>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectBenchmarkInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectBenchmark>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectBenchmark>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project benchmark
 */

export function useGetProjectBenchmarkInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectBenchmark>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectBenchmark>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectBenchmarkInfiniteQueryOptions(projectId,id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProjectBenchmarkQueryOptions = <TData = Awaited<ReturnType<typeof getProjectBenchmark>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectBenchmark>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectBenchmarkQueryKey(projectId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectBenchmark>>> = ({ signal }) => getProjectBenchmark(projectId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjectBenchmark>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectBenchmarkQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectBenchmark>>>
export type GetProjectBenchmarkQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetProjectBenchmark<TData = Awaited<ReturnType<typeof getProjectBenchmark>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectBenchmark>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectBenchmark>>,
          TError,
          Awaited<ReturnType<typeof getProjectBenchmark>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectBenchmark<TData = Awaited<ReturnType<typeof getProjectBenchmark>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectBenchmark>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectBenchmark>>,
          TError,
          Awaited<ReturnType<typeof getProjectBenchmark>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectBenchmark<TData = Awaited<ReturnType<typeof getProjectBenchmark>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectBenchmark>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project benchmark
 */

export function useGetProjectBenchmark<TData = Awaited<ReturnType<typeof getProjectBenchmark>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectBenchmark>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectBenchmarkQueryOptions(projectId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProjectBenchmarkSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProjectBenchmark>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectBenchmark>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectBenchmarkQueryKey(projectId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectBenchmark>>> = ({ signal }) => getProjectBenchmark(projectId,id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectBenchmark>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectBenchmarkSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectBenchmark>>>
export type GetProjectBenchmarkSuspenseQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetProjectBenchmarkSuspense<TData = Awaited<ReturnType<typeof getProjectBenchmark>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectBenchmark>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectBenchmarkSuspense<TData = Awaited<ReturnType<typeof getProjectBenchmark>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectBenchmark>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectBenchmarkSuspense<TData = Awaited<ReturnType<typeof getProjectBenchmark>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectBenchmark>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project benchmark
 */

export function useGetProjectBenchmarkSuspense<TData = Awaited<ReturnType<typeof getProjectBenchmark>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectBenchmark>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectBenchmarkSuspenseQueryOptions(projectId,id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Update project benchmark
 */
export const updateProjectBenchmark = (
    projectId: number,
    id: number,
    benchmarkUpdateRequest: BodyType<BenchmarkUpdateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Benchmark>(
      {url: `/projects/${projectId}/benchmarks/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: benchmarkUpdateRequest, signal
    },
      options);
    }




export const getUpdateProjectBenchmarkMutationKey = () => ['updateProjectBenchmark'] as const;

export const getUpdateProjectBenchmarkMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProjectBenchmark>>, TError,UpdateProjectBenchmarkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProjectBenchmark>>, TError,UpdateProjectBenchmarkMutationVariables, TContext> => {

const mutationKey = getUpdateProjectBenchmarkMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProjectBenchmark>>, UpdateProjectBenchmarkMutationVariables> = (props) => {
          const {projectId,id,data} = props ?? {};

          return  updateProjectBenchmark(projectId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProjectBenchmarkMutationResult = NonNullable<Awaited<ReturnType<typeof updateProjectBenchmark>>>
    export type UpdateProjectBenchmarkMutationBody = BodyType<BenchmarkUpdateRequest>
    export type UpdateProjectBenchmarkMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>
    export type UpdateProjectBenchmarkMutationVariables = {projectId: number;id: number;data: BodyType<BenchmarkUpdateRequest>}

    /**
 * @summary Update project benchmark
 */
export const useUpdateProjectBenchmark = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProjectBenchmark>>, TError,UpdateProjectBenchmarkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProjectBenchmark>>,
        TError,
        UpdateProjectBenchmarkMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateProjectBenchmarkMutationOptions(options), queryClient);
    }

/**
 * Soft delete (ADR-0028): the benchmark is withdrawn from the project's catalog — it stops appearing in lists and its id reads as gone — but the record is retained, so baselines levelled against it keep its data.
 * @summary Delete project benchmark
 */
export const deleteProjectBenchmark = (
    projectId: number,
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/projects/${projectId}/benchmarks/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteProjectBenchmarkMutationKey = () => ['deleteProjectBenchmark'] as const;

export const getDeleteProjectBenchmarkMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectBenchmark>>, TError,DeleteProjectBenchmarkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProjectBenchmark>>, TError,DeleteProjectBenchmarkMutationVariables, TContext> => {

const mutationKey = getDeleteProjectBenchmarkMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProjectBenchmark>>, DeleteProjectBenchmarkMutationVariables> = (props) => {
          const {projectId,id} = props ?? {};

          return  deleteProjectBenchmark(projectId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectBenchmarkMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProjectBenchmark>>>

    export type DeleteProjectBenchmarkMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse>
    export type DeleteProjectBenchmarkMutationVariables = {projectId: number;id: number}

    /**
 * @summary Delete project benchmark
 */
export const useDeleteProjectBenchmark = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectBenchmark>>, TError,DeleteProjectBenchmarkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProjectBenchmark>>,
        TError,
        DeleteProjectBenchmarkMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteProjectBenchmarkMutationOptions(options), queryClient);
    }

/**
 * @summary List project networks
 */
export const listProjectNetworks = (
    projectId: number,
    params?: ListProjectNetworksParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<NetworkListResponse>(
      {url: `/projects/${projectId}/networks`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListProjectNetworksInfiniteQueryKey = (projectId: number,
    params?: ListProjectNetworksParams,) => {
    return [
    'infinite', `/projects/${projectId}/networks`, ...(params ? [params] : [])
    ] as const;
    }

export const getListProjectNetworksQueryKey = (projectId: number,
    params?: ListProjectNetworksParams,) => {
    return [
    `/projects/${projectId}/networks`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProjectNetworksInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listProjectNetworks>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(projectId: number,
    params?: ListProjectNetworksParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectNetworks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectNetworksInfiniteQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectNetworks>>> = ({ signal }) => listProjectNetworks(projectId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectNetworks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectNetworksInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectNetworks>>>
export type ListProjectNetworksInfiniteQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useListProjectNetworksInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectNetworks>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    params: undefined |  ListProjectNetworksParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectNetworks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectNetworks>>,
          TError,
          Awaited<ReturnType<typeof listProjectNetworks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectNetworksInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectNetworks>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectNetworksParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectNetworks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectNetworks>>,
          TError,
          Awaited<ReturnType<typeof listProjectNetworks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectNetworksInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectNetworks>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectNetworksParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectNetworks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List project networks
 */

export function useListProjectNetworksInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectNetworks>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectNetworksParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectNetworks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectNetworksInfiniteQueryOptions(projectId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProjectNetworksQueryOptions = <TData = Awaited<ReturnType<typeof listProjectNetworks>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(projectId: number,
    params?: ListProjectNetworksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectNetworks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectNetworksQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectNetworks>>> = ({ signal }) => listProjectNetworks(projectId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjectNetworks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectNetworksQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectNetworks>>>
export type ListProjectNetworksQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useListProjectNetworks<TData = Awaited<ReturnType<typeof listProjectNetworks>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    params: undefined |  ListProjectNetworksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectNetworks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectNetworks>>,
          TError,
          Awaited<ReturnType<typeof listProjectNetworks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectNetworks<TData = Awaited<ReturnType<typeof listProjectNetworks>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectNetworksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectNetworks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectNetworks>>,
          TError,
          Awaited<ReturnType<typeof listProjectNetworks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectNetworks<TData = Awaited<ReturnType<typeof listProjectNetworks>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectNetworksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectNetworks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List project networks
 */

export function useListProjectNetworks<TData = Awaited<ReturnType<typeof listProjectNetworks>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectNetworksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectNetworks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectNetworksQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProjectNetworksSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listProjectNetworks>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(projectId: number,
    params?: ListProjectNetworksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectNetworks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectNetworksQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectNetworks>>> = ({ signal }) => listProjectNetworks(projectId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectNetworks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectNetworksSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectNetworks>>>
export type ListProjectNetworksSuspenseQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useListProjectNetworksSuspense<TData = Awaited<ReturnType<typeof listProjectNetworks>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    params: undefined |  ListProjectNetworksParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectNetworks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectNetworksSuspense<TData = Awaited<ReturnType<typeof listProjectNetworks>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectNetworksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectNetworks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectNetworksSuspense<TData = Awaited<ReturnType<typeof listProjectNetworks>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectNetworksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectNetworks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List project networks
 */

export function useListProjectNetworksSuspense<TData = Awaited<ReturnType<typeof listProjectNetworks>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number,
    params?: ListProjectNetworksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectNetworks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectNetworksSuspenseQueryOptions(projectId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Create network
 */
export const createProjectNetwork = (
    projectId: number,
    networkCreateRequest: BodyType<NetworkCreateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Network>(
      {url: `/projects/${projectId}/networks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: networkCreateRequest, signal
    },
      options);
    }




export const getCreateProjectNetworkMutationKey = () => ['createProjectNetwork'] as const;

export const getCreateProjectNetworkMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectNetwork>>, TError,CreateProjectNetworkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProjectNetwork>>, TError,CreateProjectNetworkMutationVariables, TContext> => {

const mutationKey = getCreateProjectNetworkMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProjectNetwork>>, CreateProjectNetworkMutationVariables> = (props) => {
          const {projectId,data} = props ?? {};

          return  createProjectNetwork(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProjectNetworkMutationResult = NonNullable<Awaited<ReturnType<typeof createProjectNetwork>>>
    export type CreateProjectNetworkMutationBody = BodyType<NetworkCreateRequest>
    export type CreateProjectNetworkMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>
    export type CreateProjectNetworkMutationVariables = {projectId: number;data: BodyType<NetworkCreateRequest>}

    /**
 * @summary Create network
 */
export const useCreateProjectNetwork = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectNetwork>>, TError,CreateProjectNetworkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProjectNetwork>>,
        TError,
        CreateProjectNetworkMutationVariables,
        TContext
      > => {
      return useMutation(getCreateProjectNetworkMutationOptions(options), queryClient);
    }

/**
 * @summary Get network
 */
export const getProjectNetwork = (
    projectId: number,
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Network>(
      {url: `/projects/${projectId}/networks/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetProjectNetworkInfiniteQueryKey = (projectId: number,
    id: number,) => {
    return [
    'infinite', `/projects/${projectId}/networks/${id}`
    ] as const;
    }

export const getGetProjectNetworkQueryKey = (projectId: number,
    id: number,) => {
    return [
    `/projects/${projectId}/networks/${id}`
    ] as const;
    }


export const getGetProjectNetworkInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProjectNetwork>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectNetwork>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectNetworkInfiniteQueryKey(projectId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectNetwork>>> = ({ signal }) => getProjectNetwork(projectId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectNetwork>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectNetworkInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectNetwork>>>
export type GetProjectNetworkInfiniteQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useGetProjectNetworkInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectNetwork>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectNetwork>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectNetwork>>,
          TError,
          Awaited<ReturnType<typeof getProjectNetwork>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectNetworkInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectNetwork>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectNetwork>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectNetwork>>,
          TError,
          Awaited<ReturnType<typeof getProjectNetwork>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectNetworkInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectNetwork>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectNetwork>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get network
 */

export function useGetProjectNetworkInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectNetwork>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectNetwork>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectNetworkInfiniteQueryOptions(projectId,id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProjectNetworkQueryOptions = <TData = Awaited<ReturnType<typeof getProjectNetwork>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectNetwork>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectNetworkQueryKey(projectId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectNetwork>>> = ({ signal }) => getProjectNetwork(projectId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjectNetwork>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectNetworkQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectNetwork>>>
export type GetProjectNetworkQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useGetProjectNetwork<TData = Awaited<ReturnType<typeof getProjectNetwork>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectNetwork>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectNetwork>>,
          TError,
          Awaited<ReturnType<typeof getProjectNetwork>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectNetwork<TData = Awaited<ReturnType<typeof getProjectNetwork>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectNetwork>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectNetwork>>,
          TError,
          Awaited<ReturnType<typeof getProjectNetwork>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectNetwork<TData = Awaited<ReturnType<typeof getProjectNetwork>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectNetwork>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get network
 */

export function useGetProjectNetwork<TData = Awaited<ReturnType<typeof getProjectNetwork>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectNetwork>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectNetworkQueryOptions(projectId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProjectNetworkSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProjectNetwork>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectNetwork>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectNetworkQueryKey(projectId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectNetwork>>> = ({ signal }) => getProjectNetwork(projectId,id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectNetwork>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectNetworkSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectNetwork>>>
export type GetProjectNetworkSuspenseQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useGetProjectNetworkSuspense<TData = Awaited<ReturnType<typeof getProjectNetwork>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectNetwork>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectNetworkSuspense<TData = Awaited<ReturnType<typeof getProjectNetwork>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectNetwork>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectNetworkSuspense<TData = Awaited<ReturnType<typeof getProjectNetwork>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectNetwork>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get network
 */

export function useGetProjectNetworkSuspense<TData = Awaited<ReturnType<typeof getProjectNetwork>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectNetwork>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectNetworkSuspenseQueryOptions(projectId,id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Update network
 */
export const updateProjectNetwork = (
    projectId: number,
    id: number,
    networkUpdateRequest: BodyType<NetworkUpdateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Network>(
      {url: `/projects/${projectId}/networks/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: networkUpdateRequest, signal
    },
      options);
    }




export const getUpdateProjectNetworkMutationKey = () => ['updateProjectNetwork'] as const;

export const getUpdateProjectNetworkMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProjectNetwork>>, TError,UpdateProjectNetworkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProjectNetwork>>, TError,UpdateProjectNetworkMutationVariables, TContext> => {

const mutationKey = getUpdateProjectNetworkMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProjectNetwork>>, UpdateProjectNetworkMutationVariables> = (props) => {
          const {projectId,id,data} = props ?? {};

          return  updateProjectNetwork(projectId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProjectNetworkMutationResult = NonNullable<Awaited<ReturnType<typeof updateProjectNetwork>>>
    export type UpdateProjectNetworkMutationBody = BodyType<NetworkUpdateRequest>
    export type UpdateProjectNetworkMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>
    export type UpdateProjectNetworkMutationVariables = {projectId: number;id: number;data: BodyType<NetworkUpdateRequest>}

    /**
 * @summary Update network
 */
export const useUpdateProjectNetwork = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProjectNetwork>>, TError,UpdateProjectNetworkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProjectNetwork>>,
        TError,
        UpdateProjectNetworkMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateProjectNetworkMutationOptions(options), queryClient);
    }

/**
 * @summary Delete network
 */
export const deleteProjectNetwork = (
    projectId: number,
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/projects/${projectId}/networks/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteProjectNetworkMutationKey = () => ['deleteProjectNetwork'] as const;

export const getDeleteProjectNetworkMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | DeleteRestrictedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectNetwork>>, TError,DeleteProjectNetworkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProjectNetwork>>, TError,DeleteProjectNetworkMutationVariables, TContext> => {

const mutationKey = getDeleteProjectNetworkMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProjectNetwork>>, DeleteProjectNetworkMutationVariables> = (props) => {
          const {projectId,id} = props ?? {};

          return  deleteProjectNetwork(projectId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectNetworkMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProjectNetwork>>>

    export type DeleteProjectNetworkMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | DeleteRestrictedResponse>
    export type DeleteProjectNetworkMutationVariables = {projectId: number;id: number}

    /**
 * @summary Delete network
 */
export const useDeleteProjectNetwork = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | DeleteRestrictedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectNetwork>>, TError,DeleteProjectNetworkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProjectNetwork>>,
        TError,
        DeleteProjectNetworkMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteProjectNetworkMutationOptions(options), queryClient);
    }

/**
 * One multi-page PDF carrying a karta studni page per manhole in the network, on the same template as the per-node card and ordered by node name with digit runs compared as numbers, so KD2 precedes KD10. Drafts are included and keep their draft marking; every other node type is skipped. Rendered on demand and never stored (ADR 0037). A network holding no manhole is a 422 — there is no document to render.
 * @summary Download the manhole cards for a whole network
 */
export const getProjectNetworkCards = (
    projectId: number,
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Blob>(
      {url: `/projects/${projectId}/networks/${id}/cards`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }




export const getGetProjectNetworkCardsInfiniteQueryKey = (projectId: number,
    id: number,) => {
    return [
    'infinite', `/projects/${projectId}/networks/${id}/cards`
    ] as const;
    }

export const getGetProjectNetworkCardsQueryKey = (projectId: number,
    id: number,) => {
    return [
    `/projects/${projectId}/networks/${id}/cards`
    ] as const;
    }


export const getGetProjectNetworkCardsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProjectNetworkCards>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectNetworkCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectNetworkCardsInfiniteQueryKey(projectId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectNetworkCards>>> = ({ signal }) => getProjectNetworkCards(projectId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectNetworkCards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectNetworkCardsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectNetworkCards>>>
export type GetProjectNetworkCardsInfiniteQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>


export function useGetProjectNetworkCardsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectNetworkCards>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectNetworkCards>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectNetworkCards>>,
          TError,
          Awaited<ReturnType<typeof getProjectNetworkCards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectNetworkCardsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectNetworkCards>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectNetworkCards>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectNetworkCards>>,
          TError,
          Awaited<ReturnType<typeof getProjectNetworkCards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectNetworkCardsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectNetworkCards>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectNetworkCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download the manhole cards for a whole network
 */

export function useGetProjectNetworkCardsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectNetworkCards>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectNetworkCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectNetworkCardsInfiniteQueryOptions(projectId,id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProjectNetworkCardsQueryOptions = <TData = Awaited<ReturnType<typeof getProjectNetworkCards>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectNetworkCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectNetworkCardsQueryKey(projectId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectNetworkCards>>> = ({ signal }) => getProjectNetworkCards(projectId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjectNetworkCards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectNetworkCardsQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectNetworkCards>>>
export type GetProjectNetworkCardsQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>


export function useGetProjectNetworkCards<TData = Awaited<ReturnType<typeof getProjectNetworkCards>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectNetworkCards>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectNetworkCards>>,
          TError,
          Awaited<ReturnType<typeof getProjectNetworkCards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectNetworkCards<TData = Awaited<ReturnType<typeof getProjectNetworkCards>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectNetworkCards>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectNetworkCards>>,
          TError,
          Awaited<ReturnType<typeof getProjectNetworkCards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectNetworkCards<TData = Awaited<ReturnType<typeof getProjectNetworkCards>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectNetworkCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download the manhole cards for a whole network
 */

export function useGetProjectNetworkCards<TData = Awaited<ReturnType<typeof getProjectNetworkCards>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectNetworkCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectNetworkCardsQueryOptions(projectId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProjectNetworkCardsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProjectNetworkCards>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectNetworkCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectNetworkCardsQueryKey(projectId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectNetworkCards>>> = ({ signal }) => getProjectNetworkCards(projectId,id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectNetworkCards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectNetworkCardsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectNetworkCards>>>
export type GetProjectNetworkCardsSuspenseQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>


export function useGetProjectNetworkCardsSuspense<TData = Awaited<ReturnType<typeof getProjectNetworkCards>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectNetworkCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectNetworkCardsSuspense<TData = Awaited<ReturnType<typeof getProjectNetworkCards>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectNetworkCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectNetworkCardsSuspense<TData = Awaited<ReturnType<typeof getProjectNetworkCards>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectNetworkCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download the manhole cards for a whole network
 */

export function useGetProjectNetworkCardsSuspense<TData = Awaited<ReturnType<typeof getProjectNetworkCards>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectNetworkCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectNetworkCardsSuspenseQueryOptions(projectId,id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * The single definition of the project's network numbers, shared by the definition-flow summary and the Dashboard cards — clients never recompute. Counts include draft and ready elements alike: the quick-definition estimate is read off drafts. Splits by element composition material/size would extend this response additively.
 * @summary Get project network stats
 */
export const getProjectNetworkStats = (
    projectId: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<NetworkStatsResponse>(
      {url: `/projects/${projectId}/network-stats`, method: 'GET', signal
    },
      options);
    }




export const getGetProjectNetworkStatsInfiniteQueryKey = (projectId: number,) => {
    return [
    'infinite', `/projects/${projectId}/network-stats`
    ] as const;
    }

export const getGetProjectNetworkStatsQueryKey = (projectId: number,) => {
    return [
    `/projects/${projectId}/network-stats`
    ] as const;
    }


export const getGetProjectNetworkStatsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProjectNetworkStats>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(projectId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectNetworkStats>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectNetworkStatsInfiniteQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectNetworkStats>>> = ({ signal }) => getProjectNetworkStats(projectId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectNetworkStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectNetworkStatsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectNetworkStats>>>
export type GetProjectNetworkStatsInfiniteQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetProjectNetworkStatsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectNetworkStats>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectNetworkStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectNetworkStats>>,
          TError,
          Awaited<ReturnType<typeof getProjectNetworkStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectNetworkStatsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectNetworkStats>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectNetworkStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectNetworkStats>>,
          TError,
          Awaited<ReturnType<typeof getProjectNetworkStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectNetworkStatsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectNetworkStats>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectNetworkStats>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project network stats
 */

export function useGetProjectNetworkStatsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectNetworkStats>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectNetworkStats>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectNetworkStatsInfiniteQueryOptions(projectId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProjectNetworkStatsQueryOptions = <TData = Awaited<ReturnType<typeof getProjectNetworkStats>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectNetworkStats>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectNetworkStatsQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectNetworkStats>>> = ({ signal }) => getProjectNetworkStats(projectId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjectNetworkStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectNetworkStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectNetworkStats>>>
export type GetProjectNetworkStatsQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetProjectNetworkStats<TData = Awaited<ReturnType<typeof getProjectNetworkStats>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectNetworkStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectNetworkStats>>,
          TError,
          Awaited<ReturnType<typeof getProjectNetworkStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectNetworkStats<TData = Awaited<ReturnType<typeof getProjectNetworkStats>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectNetworkStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectNetworkStats>>,
          TError,
          Awaited<ReturnType<typeof getProjectNetworkStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectNetworkStats<TData = Awaited<ReturnType<typeof getProjectNetworkStats>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectNetworkStats>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project network stats
 */

export function useGetProjectNetworkStats<TData = Awaited<ReturnType<typeof getProjectNetworkStats>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectNetworkStats>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectNetworkStatsQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProjectNetworkStatsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProjectNetworkStats>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(projectId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectNetworkStats>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectNetworkStatsQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectNetworkStats>>> = ({ signal }) => getProjectNetworkStats(projectId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectNetworkStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectNetworkStatsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectNetworkStats>>>
export type GetProjectNetworkStatsSuspenseQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetProjectNetworkStatsSuspense<TData = Awaited<ReturnType<typeof getProjectNetworkStats>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectNetworkStats>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectNetworkStatsSuspense<TData = Awaited<ReturnType<typeof getProjectNetworkStats>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectNetworkStats>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectNetworkStatsSuspense<TData = Awaited<ReturnType<typeof getProjectNetworkStats>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectNetworkStats>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get project network stats
 */

export function useGetProjectNetworkStatsSuspense<TData = Awaited<ReturnType<typeof getProjectNetworkStats>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 projectId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectNetworkStats>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectNetworkStatsSuspenseQueryOptions(projectId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary List network nodes
 */
export const listNetworkNodes = (
    networkId: number,
    params?: ListNetworkNodesParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<NetworkNodeListResponse>(
      {url: `/networks/${networkId}/nodes`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListNetworkNodesInfiniteQueryKey = (networkId: number,
    params?: ListNetworkNodesParams,) => {
    return [
    'infinite', `/networks/${networkId}/nodes`, ...(params ? [params] : [])
    ] as const;
    }

export const getListNetworkNodesQueryKey = (networkId: number,
    params?: ListNetworkNodesParams,) => {
    return [
    `/networks/${networkId}/nodes`, ...(params ? [params] : [])
    ] as const;
    }


export const getListNetworkNodesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listNetworkNodes>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(networkId: number,
    params?: ListNetworkNodesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listNetworkNodes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNetworkNodesInfiniteQueryKey(networkId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNetworkNodes>>> = ({ signal }) => listNetworkNodes(networkId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: networkId !== null && networkId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listNetworkNodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNetworkNodesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listNetworkNodes>>>
export type ListNetworkNodesInfiniteQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useListNetworkNodesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listNetworkNodes>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 networkId: number,
    params: undefined |  ListNetworkNodesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listNetworkNodes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNetworkNodes>>,
          TError,
          Awaited<ReturnType<typeof listNetworkNodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNetworkNodesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listNetworkNodes>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 networkId: number,
    params?: ListNetworkNodesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listNetworkNodes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNetworkNodes>>,
          TError,
          Awaited<ReturnType<typeof listNetworkNodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNetworkNodesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listNetworkNodes>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 networkId: number,
    params?: ListNetworkNodesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listNetworkNodes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List network nodes
 */

export function useListNetworkNodesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listNetworkNodes>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 networkId: number,
    params?: ListNetworkNodesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listNetworkNodes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNetworkNodesInfiniteQueryOptions(networkId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListNetworkNodesQueryOptions = <TData = Awaited<ReturnType<typeof listNetworkNodes>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(networkId: number,
    params?: ListNetworkNodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNetworkNodes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNetworkNodesQueryKey(networkId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNetworkNodes>>> = ({ signal }) => listNetworkNodes(networkId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: networkId !== null && networkId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNetworkNodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNetworkNodesQueryResult = NonNullable<Awaited<ReturnType<typeof listNetworkNodes>>>
export type ListNetworkNodesQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useListNetworkNodes<TData = Awaited<ReturnType<typeof listNetworkNodes>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 networkId: number,
    params: undefined |  ListNetworkNodesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNetworkNodes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNetworkNodes>>,
          TError,
          Awaited<ReturnType<typeof listNetworkNodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNetworkNodes<TData = Awaited<ReturnType<typeof listNetworkNodes>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 networkId: number,
    params?: ListNetworkNodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNetworkNodes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNetworkNodes>>,
          TError,
          Awaited<ReturnType<typeof listNetworkNodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNetworkNodes<TData = Awaited<ReturnType<typeof listNetworkNodes>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 networkId: number,
    params?: ListNetworkNodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNetworkNodes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List network nodes
 */

export function useListNetworkNodes<TData = Awaited<ReturnType<typeof listNetworkNodes>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 networkId: number,
    params?: ListNetworkNodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNetworkNodes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNetworkNodesQueryOptions(networkId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListNetworkNodesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listNetworkNodes>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(networkId: number,
    params?: ListNetworkNodesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNetworkNodes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNetworkNodesQueryKey(networkId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNetworkNodes>>> = ({ signal }) => listNetworkNodes(networkId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNetworkNodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNetworkNodesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listNetworkNodes>>>
export type ListNetworkNodesSuspenseQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useListNetworkNodesSuspense<TData = Awaited<ReturnType<typeof listNetworkNodes>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 networkId: number,
    params: undefined |  ListNetworkNodesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNetworkNodes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNetworkNodesSuspense<TData = Awaited<ReturnType<typeof listNetworkNodes>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 networkId: number,
    params?: ListNetworkNodesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNetworkNodes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNetworkNodesSuspense<TData = Awaited<ReturnType<typeof listNetworkNodes>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 networkId: number,
    params?: ListNetworkNodesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNetworkNodes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List network nodes
 */

export function useListNetworkNodesSuspense<TData = Awaited<ReturnType<typeof listNetworkNodes>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 networkId: number,
    params?: ListNetworkNodesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNetworkNodes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNetworkNodesSuspenseQueryOptions(networkId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Create network node
 */
export const createNetworkNode = (
    networkId: number,
    networkNodeCreateRequest: BodyType<NetworkNodeCreateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<NetworkNode>(
      {url: `/networks/${networkId}/nodes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: networkNodeCreateRequest, signal
    },
      options);
    }




export const getCreateNetworkNodeMutationKey = () => ['createNetworkNode'] as const;

export const getCreateNetworkNodeMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNetworkNode>>, TError,CreateNetworkNodeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createNetworkNode>>, TError,CreateNetworkNodeMutationVariables, TContext> => {

const mutationKey = getCreateNetworkNodeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNetworkNode>>, CreateNetworkNodeMutationVariables> = (props) => {
          const {networkId,data} = props ?? {};

          return  createNetworkNode(networkId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateNetworkNodeMutationResult = NonNullable<Awaited<ReturnType<typeof createNetworkNode>>>
    export type CreateNetworkNodeMutationBody = BodyType<NetworkNodeCreateRequest>
    export type CreateNetworkNodeMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>
    export type CreateNetworkNodeMutationVariables = {networkId: number;data: BodyType<NetworkNodeCreateRequest>}

    /**
 * @summary Create network node
 */
export const useCreateNetworkNode = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNetworkNode>>, TError,CreateNetworkNodeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createNetworkNode>>,
        TError,
        CreateNetworkNodeMutationVariables,
        TContext
      > => {
      return useMutation(getCreateNetworkNodeMutationOptions(options), queryClient);
    }

/**
 * @summary Get network node
 */
export const getNetworkNode = (
    networkId: number,
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<NetworkNode>(
      {url: `/networks/${networkId}/nodes/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetNetworkNodeInfiniteQueryKey = (networkId: number,
    id: number,) => {
    return [
    'infinite', `/networks/${networkId}/nodes/${id}`
    ] as const;
    }

export const getGetNetworkNodeQueryKey = (networkId: number,
    id: number,) => {
    return [
    `/networks/${networkId}/nodes/${id}`
    ] as const;
    }


export const getGetNetworkNodeInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getNetworkNode>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(networkId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNetworkNode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNetworkNodeInfiniteQueryKey(networkId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNetworkNode>>> = ({ signal }) => getNetworkNode(networkId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: networkId !== null && networkId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNetworkNode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNetworkNodeInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getNetworkNode>>>
export type GetNetworkNodeInfiniteQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useGetNetworkNodeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNetworkNode>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 networkId: number,
    id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNetworkNode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNetworkNode>>,
          TError,
          Awaited<ReturnType<typeof getNetworkNode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNetworkNodeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNetworkNode>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNetworkNode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNetworkNode>>,
          TError,
          Awaited<ReturnType<typeof getNetworkNode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNetworkNodeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNetworkNode>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNetworkNode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get network node
 */

export function useGetNetworkNodeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNetworkNode>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNetworkNode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNetworkNodeInfiniteQueryOptions(networkId,id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetNetworkNodeQueryOptions = <TData = Awaited<ReturnType<typeof getNetworkNode>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(networkId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNetworkNode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNetworkNodeQueryKey(networkId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNetworkNode>>> = ({ signal }) => getNetworkNode(networkId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: networkId !== null && networkId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNetworkNode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNetworkNodeQueryResult = NonNullable<Awaited<ReturnType<typeof getNetworkNode>>>
export type GetNetworkNodeQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useGetNetworkNode<TData = Awaited<ReturnType<typeof getNetworkNode>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 networkId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNetworkNode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNetworkNode>>,
          TError,
          Awaited<ReturnType<typeof getNetworkNode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNetworkNode<TData = Awaited<ReturnType<typeof getNetworkNode>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNetworkNode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNetworkNode>>,
          TError,
          Awaited<ReturnType<typeof getNetworkNode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNetworkNode<TData = Awaited<ReturnType<typeof getNetworkNode>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNetworkNode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get network node
 */

export function useGetNetworkNode<TData = Awaited<ReturnType<typeof getNetworkNode>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNetworkNode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNetworkNodeQueryOptions(networkId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetNetworkNodeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getNetworkNode>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(networkId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNetworkNode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNetworkNodeQueryKey(networkId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNetworkNode>>> = ({ signal }) => getNetworkNode(networkId,id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNetworkNode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNetworkNodeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getNetworkNode>>>
export type GetNetworkNodeSuspenseQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useGetNetworkNodeSuspense<TData = Awaited<ReturnType<typeof getNetworkNode>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 networkId: number,
    id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNetworkNode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNetworkNodeSuspense<TData = Awaited<ReturnType<typeof getNetworkNode>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNetworkNode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNetworkNodeSuspense<TData = Awaited<ReturnType<typeof getNetworkNode>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNetworkNode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get network node
 */

export function useGetNetworkNodeSuspense<TData = Awaited<ReturnType<typeof getNetworkNode>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNetworkNode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNetworkNodeSuspenseQueryOptions(networkId,id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Update network node
 */
export const updateNetworkNode = (
    networkId: number,
    id: number,
    networkNodeUpdateRequest: BodyType<NetworkNodeUpdateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<NetworkNode>(
      {url: `/networks/${networkId}/nodes/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: networkNodeUpdateRequest, signal
    },
      options);
    }




export const getUpdateNetworkNodeMutationKey = () => ['updateNetworkNode'] as const;

export const getUpdateNetworkNodeMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNetworkNode>>, TError,UpdateNetworkNodeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateNetworkNode>>, TError,UpdateNetworkNodeMutationVariables, TContext> => {

const mutationKey = getUpdateNetworkNodeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNetworkNode>>, UpdateNetworkNodeMutationVariables> = (props) => {
          const {networkId,id,data} = props ?? {};

          return  updateNetworkNode(networkId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateNetworkNodeMutationResult = NonNullable<Awaited<ReturnType<typeof updateNetworkNode>>>
    export type UpdateNetworkNodeMutationBody = BodyType<NetworkNodeUpdateRequest>
    export type UpdateNetworkNodeMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>
    export type UpdateNetworkNodeMutationVariables = {networkId: number;id: number;data: BodyType<NetworkNodeUpdateRequest>}

    /**
 * @summary Update network node
 */
export const useUpdateNetworkNode = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNetworkNode>>, TError,UpdateNetworkNodeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateNetworkNode>>,
        TError,
        UpdateNetworkNodeMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateNetworkNodeMutationOptions(options), queryClient);
    }

/**
 * @summary Delete network node
 */
export const deleteNetworkNode = (
    networkId: number,
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/networks/${networkId}/nodes/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteNetworkNodeMutationKey = () => ['deleteNetworkNode'] as const;

export const getDeleteNetworkNodeMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | DeleteRestrictedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNetworkNode>>, TError,DeleteNetworkNodeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteNetworkNode>>, TError,DeleteNetworkNodeMutationVariables, TContext> => {

const mutationKey = getDeleteNetworkNodeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNetworkNode>>, DeleteNetworkNodeMutationVariables> = (props) => {
          const {networkId,id} = props ?? {};

          return  deleteNetworkNode(networkId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteNetworkNodeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNetworkNode>>>

    export type DeleteNetworkNodeMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | DeleteRestrictedResponse>
    export type DeleteNetworkNodeMutationVariables = {networkId: number;id: number}

    /**
 * @summary Delete network node
 */
export const useDeleteNetworkNode = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | DeleteRestrictedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNetworkNode>>, TError,DeleteNetworkNodeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteNetworkNode>>,
        TError,
        DeleteNetworkNodeMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteNetworkNodeMutationOptions(options), queryClient);
    }

/**
 * The one-page PDF projection of a Manhole specification, rendered on demand and never stored (ADR 0037). Available for a `manhole` node at any readiness — a node that is not ready renders with a visible draft marking — and refused with a 422 for every other node type. Copy follows the request's `Accept-Language`, Polish by default.
 * @summary Download the manhole card (karta studni)
 */
export const getNetworkNodeCard = (
    networkId: number,
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Blob>(
      {url: `/networks/${networkId}/nodes/${id}/card`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }




export const getGetNetworkNodeCardInfiniteQueryKey = (networkId: number,
    id: number,) => {
    return [
    'infinite', `/networks/${networkId}/nodes/${id}/card`
    ] as const;
    }

export const getGetNetworkNodeCardQueryKey = (networkId: number,
    id: number,) => {
    return [
    `/networks/${networkId}/nodes/${id}/card`
    ] as const;
    }


export const getGetNetworkNodeCardInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getNetworkNodeCard>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(networkId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNetworkNodeCard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNetworkNodeCardInfiniteQueryKey(networkId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNetworkNodeCard>>> = ({ signal }) => getNetworkNodeCard(networkId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: networkId !== null && networkId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNetworkNodeCard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNetworkNodeCardInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getNetworkNodeCard>>>
export type GetNetworkNodeCardInfiniteQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>


export function useGetNetworkNodeCardInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNetworkNodeCard>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(
 networkId: number,
    id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNetworkNodeCard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNetworkNodeCard>>,
          TError,
          Awaited<ReturnType<typeof getNetworkNodeCard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNetworkNodeCardInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNetworkNodeCard>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNetworkNodeCard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNetworkNodeCard>>,
          TError,
          Awaited<ReturnType<typeof getNetworkNodeCard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNetworkNodeCardInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNetworkNodeCard>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNetworkNodeCard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download the manhole card (karta studni)
 */

export function useGetNetworkNodeCardInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNetworkNodeCard>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNetworkNodeCard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNetworkNodeCardInfiniteQueryOptions(networkId,id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetNetworkNodeCardQueryOptions = <TData = Awaited<ReturnType<typeof getNetworkNodeCard>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(networkId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNetworkNodeCard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNetworkNodeCardQueryKey(networkId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNetworkNodeCard>>> = ({ signal }) => getNetworkNodeCard(networkId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: networkId !== null && networkId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNetworkNodeCard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNetworkNodeCardQueryResult = NonNullable<Awaited<ReturnType<typeof getNetworkNodeCard>>>
export type GetNetworkNodeCardQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>


export function useGetNetworkNodeCard<TData = Awaited<ReturnType<typeof getNetworkNodeCard>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(
 networkId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNetworkNodeCard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNetworkNodeCard>>,
          TError,
          Awaited<ReturnType<typeof getNetworkNodeCard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNetworkNodeCard<TData = Awaited<ReturnType<typeof getNetworkNodeCard>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNetworkNodeCard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNetworkNodeCard>>,
          TError,
          Awaited<ReturnType<typeof getNetworkNodeCard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNetworkNodeCard<TData = Awaited<ReturnType<typeof getNetworkNodeCard>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNetworkNodeCard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download the manhole card (karta studni)
 */

export function useGetNetworkNodeCard<TData = Awaited<ReturnType<typeof getNetworkNodeCard>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNetworkNodeCard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNetworkNodeCardQueryOptions(networkId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetNetworkNodeCardSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getNetworkNodeCard>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(networkId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNetworkNodeCard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNetworkNodeCardQueryKey(networkId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNetworkNodeCard>>> = ({ signal }) => getNetworkNodeCard(networkId,id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNetworkNodeCard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNetworkNodeCardSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getNetworkNodeCard>>>
export type GetNetworkNodeCardSuspenseQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>


export function useGetNetworkNodeCardSuspense<TData = Awaited<ReturnType<typeof getNetworkNodeCard>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(
 networkId: number,
    id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNetworkNodeCard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNetworkNodeCardSuspense<TData = Awaited<ReturnType<typeof getNetworkNodeCard>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNetworkNodeCard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNetworkNodeCardSuspense<TData = Awaited<ReturnType<typeof getNetworkNodeCard>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNetworkNodeCard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download the manhole card (karta studni)
 */

export function useGetNetworkNodeCardSuspense<TData = Awaited<ReturnType<typeof getNetworkNodeCard>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNetworkNodeCard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNetworkNodeCardSuspenseQueryOptions(networkId,id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary List network connections
 */
export const listNetworkConnections = (
    networkId: number,
    params?: ListNetworkConnectionsParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<NetworkConnectionListResponse>(
      {url: `/networks/${networkId}/connections`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListNetworkConnectionsInfiniteQueryKey = (networkId: number,
    params?: ListNetworkConnectionsParams,) => {
    return [
    'infinite', `/networks/${networkId}/connections`, ...(params ? [params] : [])
    ] as const;
    }

export const getListNetworkConnectionsQueryKey = (networkId: number,
    params?: ListNetworkConnectionsParams,) => {
    return [
    `/networks/${networkId}/connections`, ...(params ? [params] : [])
    ] as const;
    }


export const getListNetworkConnectionsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listNetworkConnections>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(networkId: number,
    params?: ListNetworkConnectionsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listNetworkConnections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNetworkConnectionsInfiniteQueryKey(networkId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNetworkConnections>>> = ({ signal }) => listNetworkConnections(networkId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: networkId !== null && networkId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listNetworkConnections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNetworkConnectionsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listNetworkConnections>>>
export type ListNetworkConnectionsInfiniteQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useListNetworkConnectionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listNetworkConnections>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 networkId: number,
    params: undefined |  ListNetworkConnectionsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listNetworkConnections>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNetworkConnections>>,
          TError,
          Awaited<ReturnType<typeof listNetworkConnections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNetworkConnectionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listNetworkConnections>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 networkId: number,
    params?: ListNetworkConnectionsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listNetworkConnections>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNetworkConnections>>,
          TError,
          Awaited<ReturnType<typeof listNetworkConnections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNetworkConnectionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listNetworkConnections>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 networkId: number,
    params?: ListNetworkConnectionsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listNetworkConnections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List network connections
 */

export function useListNetworkConnectionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listNetworkConnections>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 networkId: number,
    params?: ListNetworkConnectionsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listNetworkConnections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNetworkConnectionsInfiniteQueryOptions(networkId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListNetworkConnectionsQueryOptions = <TData = Awaited<ReturnType<typeof listNetworkConnections>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(networkId: number,
    params?: ListNetworkConnectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNetworkConnections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNetworkConnectionsQueryKey(networkId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNetworkConnections>>> = ({ signal }) => listNetworkConnections(networkId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: networkId !== null && networkId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNetworkConnections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNetworkConnectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listNetworkConnections>>>
export type ListNetworkConnectionsQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useListNetworkConnections<TData = Awaited<ReturnType<typeof listNetworkConnections>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 networkId: number,
    params: undefined |  ListNetworkConnectionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNetworkConnections>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNetworkConnections>>,
          TError,
          Awaited<ReturnType<typeof listNetworkConnections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNetworkConnections<TData = Awaited<ReturnType<typeof listNetworkConnections>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 networkId: number,
    params?: ListNetworkConnectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNetworkConnections>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNetworkConnections>>,
          TError,
          Awaited<ReturnType<typeof listNetworkConnections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNetworkConnections<TData = Awaited<ReturnType<typeof listNetworkConnections>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 networkId: number,
    params?: ListNetworkConnectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNetworkConnections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List network connections
 */

export function useListNetworkConnections<TData = Awaited<ReturnType<typeof listNetworkConnections>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 networkId: number,
    params?: ListNetworkConnectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNetworkConnections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNetworkConnectionsQueryOptions(networkId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListNetworkConnectionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listNetworkConnections>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(networkId: number,
    params?: ListNetworkConnectionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNetworkConnections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNetworkConnectionsQueryKey(networkId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNetworkConnections>>> = ({ signal }) => listNetworkConnections(networkId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNetworkConnections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNetworkConnectionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listNetworkConnections>>>
export type ListNetworkConnectionsSuspenseQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useListNetworkConnectionsSuspense<TData = Awaited<ReturnType<typeof listNetworkConnections>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 networkId: number,
    params: undefined |  ListNetworkConnectionsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNetworkConnections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNetworkConnectionsSuspense<TData = Awaited<ReturnType<typeof listNetworkConnections>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 networkId: number,
    params?: ListNetworkConnectionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNetworkConnections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNetworkConnectionsSuspense<TData = Awaited<ReturnType<typeof listNetworkConnections>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 networkId: number,
    params?: ListNetworkConnectionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNetworkConnections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List network connections
 */

export function useListNetworkConnectionsSuspense<TData = Awaited<ReturnType<typeof listNetworkConnections>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 networkId: number,
    params?: ListNetworkConnectionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listNetworkConnections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNetworkConnectionsSuspenseQueryOptions(networkId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Create network connection
 */
export const createNetworkConnection = (
    networkId: number,
    networkConnectionCreateRequest: BodyType<NetworkConnectionCreateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<NetworkConnection>(
      {url: `/networks/${networkId}/connections`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: networkConnectionCreateRequest, signal
    },
      options);
    }




export const getCreateNetworkConnectionMutationKey = () => ['createNetworkConnection'] as const;

export const getCreateNetworkConnectionMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNetworkConnection>>, TError,CreateNetworkConnectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createNetworkConnection>>, TError,CreateNetworkConnectionMutationVariables, TContext> => {

const mutationKey = getCreateNetworkConnectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNetworkConnection>>, CreateNetworkConnectionMutationVariables> = (props) => {
          const {networkId,data} = props ?? {};

          return  createNetworkConnection(networkId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateNetworkConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof createNetworkConnection>>>
    export type CreateNetworkConnectionMutationBody = BodyType<NetworkConnectionCreateRequest>
    export type CreateNetworkConnectionMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>
    export type CreateNetworkConnectionMutationVariables = {networkId: number;data: BodyType<NetworkConnectionCreateRequest>}

    /**
 * @summary Create network connection
 */
export const useCreateNetworkConnection = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNetworkConnection>>, TError,CreateNetworkConnectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createNetworkConnection>>,
        TError,
        CreateNetworkConnectionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateNetworkConnectionMutationOptions(options), queryClient);
    }

/**
 * @summary Get network connection
 */
export const getNetworkConnection = (
    networkId: number,
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<NetworkConnection>(
      {url: `/networks/${networkId}/connections/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetNetworkConnectionInfiniteQueryKey = (networkId: number,
    id: number,) => {
    return [
    'infinite', `/networks/${networkId}/connections/${id}`
    ] as const;
    }

export const getGetNetworkConnectionQueryKey = (networkId: number,
    id: number,) => {
    return [
    `/networks/${networkId}/connections/${id}`
    ] as const;
    }


export const getGetNetworkConnectionInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getNetworkConnection>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(networkId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNetworkConnection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNetworkConnectionInfiniteQueryKey(networkId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNetworkConnection>>> = ({ signal }) => getNetworkConnection(networkId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: networkId !== null && networkId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNetworkConnection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNetworkConnectionInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getNetworkConnection>>>
export type GetNetworkConnectionInfiniteQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useGetNetworkConnectionInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNetworkConnection>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 networkId: number,
    id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNetworkConnection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNetworkConnection>>,
          TError,
          Awaited<ReturnType<typeof getNetworkConnection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNetworkConnectionInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNetworkConnection>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNetworkConnection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNetworkConnection>>,
          TError,
          Awaited<ReturnType<typeof getNetworkConnection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNetworkConnectionInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNetworkConnection>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNetworkConnection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get network connection
 */

export function useGetNetworkConnectionInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNetworkConnection>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNetworkConnection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNetworkConnectionInfiniteQueryOptions(networkId,id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetNetworkConnectionQueryOptions = <TData = Awaited<ReturnType<typeof getNetworkConnection>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(networkId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNetworkConnection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNetworkConnectionQueryKey(networkId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNetworkConnection>>> = ({ signal }) => getNetworkConnection(networkId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: networkId !== null && networkId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNetworkConnection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNetworkConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof getNetworkConnection>>>
export type GetNetworkConnectionQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useGetNetworkConnection<TData = Awaited<ReturnType<typeof getNetworkConnection>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 networkId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNetworkConnection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNetworkConnection>>,
          TError,
          Awaited<ReturnType<typeof getNetworkConnection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNetworkConnection<TData = Awaited<ReturnType<typeof getNetworkConnection>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNetworkConnection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNetworkConnection>>,
          TError,
          Awaited<ReturnType<typeof getNetworkConnection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNetworkConnection<TData = Awaited<ReturnType<typeof getNetworkConnection>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNetworkConnection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get network connection
 */

export function useGetNetworkConnection<TData = Awaited<ReturnType<typeof getNetworkConnection>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNetworkConnection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNetworkConnectionQueryOptions(networkId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetNetworkConnectionSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getNetworkConnection>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(networkId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNetworkConnection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNetworkConnectionQueryKey(networkId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNetworkConnection>>> = ({ signal }) => getNetworkConnection(networkId,id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNetworkConnection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNetworkConnectionSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getNetworkConnection>>>
export type GetNetworkConnectionSuspenseQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useGetNetworkConnectionSuspense<TData = Awaited<ReturnType<typeof getNetworkConnection>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 networkId: number,
    id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNetworkConnection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNetworkConnectionSuspense<TData = Awaited<ReturnType<typeof getNetworkConnection>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNetworkConnection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNetworkConnectionSuspense<TData = Awaited<ReturnType<typeof getNetworkConnection>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNetworkConnection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get network connection
 */

export function useGetNetworkConnectionSuspense<TData = Awaited<ReturnType<typeof getNetworkConnection>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 networkId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNetworkConnection>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNetworkConnectionSuspenseQueryOptions(networkId,id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary Update network connection
 */
export const updateNetworkConnection = (
    networkId: number,
    id: number,
    networkConnectionUpdateRequest: BodyType<NetworkConnectionUpdateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<NetworkConnection>(
      {url: `/networks/${networkId}/connections/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: networkConnectionUpdateRequest, signal
    },
      options);
    }




export const getUpdateNetworkConnectionMutationKey = () => ['updateNetworkConnection'] as const;

export const getUpdateNetworkConnectionMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNetworkConnection>>, TError,UpdateNetworkConnectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateNetworkConnection>>, TError,UpdateNetworkConnectionMutationVariables, TContext> => {

const mutationKey = getUpdateNetworkConnectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNetworkConnection>>, UpdateNetworkConnectionMutationVariables> = (props) => {
          const {networkId,id,data} = props ?? {};

          return  updateNetworkConnection(networkId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateNetworkConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof updateNetworkConnection>>>
    export type UpdateNetworkConnectionMutationBody = BodyType<NetworkConnectionUpdateRequest>
    export type UpdateNetworkConnectionMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>
    export type UpdateNetworkConnectionMutationVariables = {networkId: number;id: number;data: BodyType<NetworkConnectionUpdateRequest>}

    /**
 * @summary Update network connection
 */
export const useUpdateNetworkConnection = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNetworkConnection>>, TError,UpdateNetworkConnectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateNetworkConnection>>,
        TError,
        UpdateNetworkConnectionMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateNetworkConnectionMutationOptions(options), queryClient);
    }

/**
 * @summary Delete network connection
 */
export const deleteNetworkConnection = (
    networkId: number,
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/networks/${networkId}/connections/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteNetworkConnectionMutationKey = () => ['deleteNetworkConnection'] as const;

export const getDeleteNetworkConnectionMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | DeleteRestrictedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNetworkConnection>>, TError,DeleteNetworkConnectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteNetworkConnection>>, TError,DeleteNetworkConnectionMutationVariables, TContext> => {

const mutationKey = getDeleteNetworkConnectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNetworkConnection>>, DeleteNetworkConnectionMutationVariables> = (props) => {
          const {networkId,id} = props ?? {};

          return  deleteNetworkConnection(networkId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteNetworkConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNetworkConnection>>>

    export type DeleteNetworkConnectionMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | DeleteRestrictedResponse>
    export type DeleteNetworkConnectionMutationVariables = {networkId: number;id: number}

    /**
 * @summary Delete network connection
 */
export const useDeleteNetworkConnection = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | DeleteRestrictedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNetworkConnection>>, TError,DeleteNetworkConnectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteNetworkConnection>>,
        TError,
        DeleteNetworkConnectionMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteNetworkConnectionMutationOptions(options), queryClient);
    }

/**
 * The network's plan, assembled server-side: one page of groups, each a node followed by the connections anchored to it. It replaces reading `/nodes` and `/connections` separately and grouping them in the client, which truncated any plan longer than one page.
 *
 * The page unit is the **group**, never the element, so no page ever separates a connection from the node it hangs under: `per_page` counts groups, and `meta.total_count` is the number of groups. Groups are ordered by their node's `created_at` ascending and then `id`.
 *
 * The feed is scoped implicitly by the caller's identity — there is no parameter to widen or narrow it. A panel account, the owner and a supervisor read the whole plan they may already read. A **foreman** reads a projection of it: the elements they hold plus their direct neighbours — an assigned connection's two endpoint nodes, an assigned node's connections at either end — and nothing at all in a network where they hold nothing.
 *
 * This is projection, never authorization (ADR 0006 as revised by ADR 0046): `/nodes` and `/connections` stay unrestricted, and absence from this feed says nothing about what the caller may read.
 *
 * `search` keeps the elements whose name contains the term, diacritics aside — nodes and connections alike, each on its own name. A matching connection whose anchor node drops out joins the trailing no-node group.
 * @summary List the network's plan as grouped elements
 */
export const listGroupedNetworkElements = (
    networkId: number,
    params?: ListGroupedNetworkElementsParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<NetworkElementGroupListResponse>(
      {url: `/networks/${networkId}/grouped-elements`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListGroupedNetworkElementsInfiniteQueryKey = (networkId: number,
    params?: ListGroupedNetworkElementsParams,) => {
    return [
    'infinite', `/networks/${networkId}/grouped-elements`, ...(params ? [params] : [])
    ] as const;
    }

export const getListGroupedNetworkElementsQueryKey = (networkId: number,
    params?: ListGroupedNetworkElementsParams,) => {
    return [
    `/networks/${networkId}/grouped-elements`, ...(params ? [params] : [])
    ] as const;
    }


export const getListGroupedNetworkElementsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listGroupedNetworkElements>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(networkId: number,
    params?: ListGroupedNetworkElementsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGroupedNetworkElementsInfiniteQueryKey(networkId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGroupedNetworkElements>>> = ({ signal }) => listGroupedNetworkElements(networkId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: networkId !== null && networkId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListGroupedNetworkElementsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listGroupedNetworkElements>>>
export type ListGroupedNetworkElementsInfiniteQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>


export function useListGroupedNetworkElementsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listGroupedNetworkElements>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 networkId: number,
    params: undefined |  ListGroupedNetworkElementsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGroupedNetworkElements>>,
          TError,
          Awaited<ReturnType<typeof listGroupedNetworkElements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGroupedNetworkElementsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listGroupedNetworkElements>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 networkId: number,
    params?: ListGroupedNetworkElementsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGroupedNetworkElements>>,
          TError,
          Awaited<ReturnType<typeof listGroupedNetworkElements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGroupedNetworkElementsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listGroupedNetworkElements>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 networkId: number,
    params?: ListGroupedNetworkElementsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the network's plan as grouped elements
 */

export function useListGroupedNetworkElementsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listGroupedNetworkElements>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 networkId: number,
    params?: ListGroupedNetworkElementsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListGroupedNetworkElementsInfiniteQueryOptions(networkId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListGroupedNetworkElementsQueryOptions = <TData = Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(networkId: number,
    params?: ListGroupedNetworkElementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGroupedNetworkElementsQueryKey(networkId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGroupedNetworkElements>>> = ({ signal }) => listGroupedNetworkElements(networkId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: networkId !== null && networkId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListGroupedNetworkElementsQueryResult = NonNullable<Awaited<ReturnType<typeof listGroupedNetworkElements>>>
export type ListGroupedNetworkElementsQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>


export function useListGroupedNetworkElements<TData = Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 networkId: number,
    params: undefined |  ListGroupedNetworkElementsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGroupedNetworkElements>>,
          TError,
          Awaited<ReturnType<typeof listGroupedNetworkElements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGroupedNetworkElements<TData = Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 networkId: number,
    params?: ListGroupedNetworkElementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGroupedNetworkElements>>,
          TError,
          Awaited<ReturnType<typeof listGroupedNetworkElements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGroupedNetworkElements<TData = Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 networkId: number,
    params?: ListGroupedNetworkElementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the network's plan as grouped elements
 */

export function useListGroupedNetworkElements<TData = Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 networkId: number,
    params?: ListGroupedNetworkElementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListGroupedNetworkElementsQueryOptions(networkId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListGroupedNetworkElementsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(networkId: number,
    params?: ListGroupedNetworkElementsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGroupedNetworkElementsQueryKey(networkId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGroupedNetworkElements>>> = ({ signal }) => listGroupedNetworkElements(networkId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListGroupedNetworkElementsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listGroupedNetworkElements>>>
export type ListGroupedNetworkElementsSuspenseQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>


export function useListGroupedNetworkElementsSuspense<TData = Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 networkId: number,
    params: undefined |  ListGroupedNetworkElementsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGroupedNetworkElementsSuspense<TData = Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 networkId: number,
    params?: ListGroupedNetworkElementsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGroupedNetworkElementsSuspense<TData = Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 networkId: number,
    params?: ListGroupedNetworkElementsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the network's plan as grouped elements
 */

export function useListGroupedNetworkElementsSuspense<TData = Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 networkId: number,
    params?: ListGroupedNetworkElementsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listGroupedNetworkElements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListGroupedNetworkElementsSuspenseQueryOptions(networkId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Assigns the node, or replaces whoever holds it: an element carries at most one assignee, so this is both the assign and the reassign call and answers 200 either way (ADR 0006). The assigner is taken from the session, never from the body.
 * @summary Assign the node to a foreman
 */
export const assignNetworkNode = (
    networkId: number,
    nodeId: number,
    elementAssignmentRequest: BodyType<ElementAssignmentRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<ElementAssignment>(
      {url: `/networks/${networkId}/nodes/${nodeId}/assignment`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: elementAssignmentRequest, signal
    },
      options);
    }




export const getAssignNetworkNodeMutationKey = () => ['assignNetworkNode'] as const;

export const getAssignNetworkNodeMutationOptions = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignNetworkNode>>, TError,AssignNetworkNodeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assignNetworkNode>>, TError,AssignNetworkNodeMutationVariables, TContext> => {

const mutationKey = getAssignNetworkNodeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignNetworkNode>>, AssignNetworkNodeMutationVariables> = (props) => {
          const {networkId,nodeId,data} = props ?? {};

          return  assignNetworkNode(networkId,nodeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignNetworkNodeMutationResult = NonNullable<Awaited<ReturnType<typeof assignNetworkNode>>>
    export type AssignNetworkNodeMutationBody = BodyType<ElementAssignmentRequest>
    export type AssignNetworkNodeMutationError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>
    export type AssignNetworkNodeMutationVariables = {networkId: number;nodeId: number;data: BodyType<ElementAssignmentRequest>}

    /**
 * @summary Assign the node to a foreman
 */
export const useAssignNetworkNode = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignNetworkNode>>, TError,AssignNetworkNodeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assignNetworkNode>>,
        TError,
        AssignNetworkNodeMutationVariables,
        TContext
      > => {
      return useMutation(getAssignNetworkNodeMutationOptions(options), queryClient);
    }

/**
 * Removes the node's assignment. An assignment has no lifecycle — unassigning deletes the fact, and the audit log carries the trail (ADR 0006). A node holding no assignment answers 404.
 * @summary Unassign the node
 */
export const unassignNetworkNode = (
    networkId: number,
    nodeId: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/networks/${networkId}/nodes/${nodeId}/assignment`, method: 'DELETE', signal
    },
      options);
    }




export const getUnassignNetworkNodeMutationKey = () => ['unassignNetworkNode'] as const;

export const getUnassignNetworkNodeMutationOptions = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unassignNetworkNode>>, TError,UnassignNetworkNodeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unassignNetworkNode>>, TError,UnassignNetworkNodeMutationVariables, TContext> => {

const mutationKey = getUnassignNetworkNodeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unassignNetworkNode>>, UnassignNetworkNodeMutationVariables> = (props) => {
          const {networkId,nodeId} = props ?? {};

          return  unassignNetworkNode(networkId,nodeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnassignNetworkNodeMutationResult = NonNullable<Awaited<ReturnType<typeof unassignNetworkNode>>>

    export type UnassignNetworkNodeMutationError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>
    export type UnassignNetworkNodeMutationVariables = {networkId: number;nodeId: number}

    /**
 * @summary Unassign the node
 */
export const useUnassignNetworkNode = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unassignNetworkNode>>, TError,UnassignNetworkNodeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unassignNetworkNode>>,
        TError,
        UnassignNetworkNodeMutationVariables,
        TContext
      > => {
      return useMutation(getUnassignNetworkNodeMutationOptions(options), queryClient);
    }

/**
 * Assigns the pipe, or replaces whoever holds it: an element carries at most one assignee, so this is both the assign and the reassign call and answers 200 either way (ADR 0006). The assigner is taken from the session, never from the body.
 * @summary Assign the connection to a foreman
 */
export const assignNetworkConnection = (
    networkId: number,
    connectionId: number,
    elementAssignmentRequest: BodyType<ElementAssignmentRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<ElementAssignment>(
      {url: `/networks/${networkId}/connections/${connectionId}/assignment`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: elementAssignmentRequest, signal
    },
      options);
    }




export const getAssignNetworkConnectionMutationKey = () => ['assignNetworkConnection'] as const;

export const getAssignNetworkConnectionMutationOptions = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignNetworkConnection>>, TError,AssignNetworkConnectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assignNetworkConnection>>, TError,AssignNetworkConnectionMutationVariables, TContext> => {

const mutationKey = getAssignNetworkConnectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignNetworkConnection>>, AssignNetworkConnectionMutationVariables> = (props) => {
          const {networkId,connectionId,data} = props ?? {};

          return  assignNetworkConnection(networkId,connectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignNetworkConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof assignNetworkConnection>>>
    export type AssignNetworkConnectionMutationBody = BodyType<ElementAssignmentRequest>
    export type AssignNetworkConnectionMutationError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>
    export type AssignNetworkConnectionMutationVariables = {networkId: number;connectionId: number;data: BodyType<ElementAssignmentRequest>}

    /**
 * @summary Assign the connection to a foreman
 */
export const useAssignNetworkConnection = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignNetworkConnection>>, TError,AssignNetworkConnectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assignNetworkConnection>>,
        TError,
        AssignNetworkConnectionMutationVariables,
        TContext
      > => {
      return useMutation(getAssignNetworkConnectionMutationOptions(options), queryClient);
    }

/**
 * Removes the pipe's assignment. An assignment has no lifecycle — unassigning deletes the fact, and the audit log carries the trail (ADR 0006). A pipe holding no assignment answers 404.
 * @summary Unassign the connection
 */
export const unassignNetworkConnection = (
    networkId: number,
    connectionId: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/networks/${networkId}/connections/${connectionId}/assignment`, method: 'DELETE', signal
    },
      options);
    }




export const getUnassignNetworkConnectionMutationKey = () => ['unassignNetworkConnection'] as const;

export const getUnassignNetworkConnectionMutationOptions = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unassignNetworkConnection>>, TError,UnassignNetworkConnectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unassignNetworkConnection>>, TError,UnassignNetworkConnectionMutationVariables, TContext> => {

const mutationKey = getUnassignNetworkConnectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unassignNetworkConnection>>, UnassignNetworkConnectionMutationVariables> = (props) => {
          const {networkId,connectionId} = props ?? {};

          return  unassignNetworkConnection(networkId,connectionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnassignNetworkConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof unassignNetworkConnection>>>

    export type UnassignNetworkConnectionMutationError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>
    export type UnassignNetworkConnectionMutationVariables = {networkId: number;connectionId: number}

    /**
 * @summary Unassign the connection
 */
export const useUnassignNetworkConnection = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unassignNetworkConnection>>, TError,UnassignNetworkConnectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unassignNetworkConnection>>,
        TError,
        UnassignNetworkConnectionMutationVariables,
        TContext
      > => {
      return useMutation(getUnassignNetworkConnectionMutationOptions(options), queryClient);
    }

/**
 * The project's bill of materials — one row per node component, whole-delivered node or project-wide pipe triple, plus whatever an administrator added by hand. Ordered by display name, ascending. Search matches the manual name, the composition material, the linked catalog part's name and the attributed node's name, diacritic-insensitive.
 * @summary List project materials
 */
export const listProjectMaterials = (
    projectId: number,
    params?: ListProjectMaterialsParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<MaterialListResponse>(
      {url: `/projects/${projectId}/materials`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListProjectMaterialsInfiniteQueryKey = (projectId: number,
    params?: ListProjectMaterialsParams,) => {
    return [
    'infinite', `/projects/${projectId}/materials`, ...(params ? [params] : [])
    ] as const;
    }

export const getListProjectMaterialsQueryKey = (projectId: number,
    params?: ListProjectMaterialsParams,) => {
    return [
    `/projects/${projectId}/materials`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProjectMaterialsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listProjectMaterials>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(projectId: number,
    params?: ListProjectMaterialsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectMaterialsInfiniteQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectMaterials>>> = ({ signal }) => listProjectMaterials(projectId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectMaterials>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectMaterialsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectMaterials>>>
export type ListProjectMaterialsInfiniteQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>


export function useListProjectMaterialsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectMaterials>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params: undefined |  ListProjectMaterialsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectMaterials>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectMaterials>>,
          TError,
          Awaited<ReturnType<typeof listProjectMaterials>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectMaterialsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectMaterials>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectMaterialsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectMaterials>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectMaterials>>,
          TError,
          Awaited<ReturnType<typeof listProjectMaterials>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectMaterialsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectMaterials>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectMaterialsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List project materials
 */

export function useListProjectMaterialsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectMaterials>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectMaterialsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectMaterialsInfiniteQueryOptions(projectId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProjectMaterialsQueryOptions = <TData = Awaited<ReturnType<typeof listProjectMaterials>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(projectId: number,
    params?: ListProjectMaterialsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectMaterialsQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectMaterials>>> = ({ signal }) => listProjectMaterials(projectId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjectMaterials>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectMaterialsQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectMaterials>>>
export type ListProjectMaterialsQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>


export function useListProjectMaterials<TData = Awaited<ReturnType<typeof listProjectMaterials>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params: undefined |  ListProjectMaterialsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectMaterials>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectMaterials>>,
          TError,
          Awaited<ReturnType<typeof listProjectMaterials>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectMaterials<TData = Awaited<ReturnType<typeof listProjectMaterials>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectMaterialsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectMaterials>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectMaterials>>,
          TError,
          Awaited<ReturnType<typeof listProjectMaterials>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectMaterials<TData = Awaited<ReturnType<typeof listProjectMaterials>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectMaterialsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List project materials
 */

export function useListProjectMaterials<TData = Awaited<ReturnType<typeof listProjectMaterials>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectMaterialsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectMaterialsQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProjectMaterialsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listProjectMaterials>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(projectId: number,
    params?: ListProjectMaterialsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectMaterialsQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectMaterials>>> = ({ signal }) => listProjectMaterials(projectId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectMaterials>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectMaterialsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectMaterials>>>
export type ListProjectMaterialsSuspenseQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>


export function useListProjectMaterialsSuspense<TData = Awaited<ReturnType<typeof listProjectMaterials>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params: undefined |  ListProjectMaterialsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectMaterialsSuspense<TData = Awaited<ReturnType<typeof listProjectMaterials>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectMaterialsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectMaterialsSuspense<TData = Awaited<ReturnType<typeof listProjectMaterials>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectMaterialsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List project materials
 */

export function useListProjectMaterialsSuspense<TData = Awaited<ReturnType<typeof listProjectMaterials>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectMaterialsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectMaterialsSuspenseQueryOptions(projectId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Adds a manual row, stamped with the calling administrator as its author.
 * @summary Create material
 */
export const createProjectMaterial = (
    projectId: number,
    materialCreateRequest: BodyType<MaterialCreateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Material>(
      {url: `/projects/${projectId}/materials`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: materialCreateRequest, signal
    },
      options);
    }




export const getCreateProjectMaterialMutationKey = () => ['createProjectMaterial'] as const;

export const getCreateProjectMaterialMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectMaterial>>, TError,CreateProjectMaterialMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProjectMaterial>>, TError,CreateProjectMaterialMutationVariables, TContext> => {

const mutationKey = getCreateProjectMaterialMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProjectMaterial>>, CreateProjectMaterialMutationVariables> = (props) => {
          const {projectId,data} = props ?? {};

          return  createProjectMaterial(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProjectMaterialMutationResult = NonNullable<Awaited<ReturnType<typeof createProjectMaterial>>>
    export type CreateProjectMaterialMutationBody = BodyType<MaterialCreateRequest>
    export type CreateProjectMaterialMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>
    export type CreateProjectMaterialMutationVariables = {projectId: number;data: BodyType<MaterialCreateRequest>}

    /**
 * @summary Create material
 */
export const useCreateProjectMaterial = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectMaterial>>, TError,CreateProjectMaterialMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProjectMaterial>>,
        TError,
        CreateProjectMaterialMutationVariables,
        TContext
      > => {
      return useMutation(getCreateProjectMaterialMutationOptions(options), queryClient);
    }

/**
 * Runs the material calculation over the project's networks and applies its requirements to the system rows in one step: rows are created, refreshed, parked at zero or removed; manual rows are never touched. Elements the calculation could not compute come back as issues and produce no row. Panel accounts only.
 * @summary Recalculate the bill of materials
 */
export const recalculateProjectMaterials = (
    projectId: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<MaterialRecalculation>(
      {url: `/projects/${projectId}/materials/recalculate`, method: 'POST', signal
    },
      options);
    }




export const getRecalculateProjectMaterialsMutationKey = () => ['recalculateProjectMaterials'] as const;

export const getRecalculateProjectMaterialsMutationOptions = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recalculateProjectMaterials>>, TError,RecalculateProjectMaterialsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recalculateProjectMaterials>>, TError,RecalculateProjectMaterialsMutationVariables, TContext> => {

const mutationKey = getRecalculateProjectMaterialsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recalculateProjectMaterials>>, RecalculateProjectMaterialsMutationVariables> = (props) => {
          const {projectId} = props ?? {};

          return  recalculateProjectMaterials(projectId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecalculateProjectMaterialsMutationResult = NonNullable<Awaited<ReturnType<typeof recalculateProjectMaterials>>>

    export type RecalculateProjectMaterialsMutationError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>
    export type RecalculateProjectMaterialsMutationVariables = {projectId: number}

    /**
 * @summary Recalculate the bill of materials
 */
export const useRecalculateProjectMaterials = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recalculateProjectMaterials>>, TError,RecalculateProjectMaterialsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recalculateProjectMaterials>>,
        TError,
        RecalculateProjectMaterialsMutationVariables,
        TContext
      > => {
      return useMutation(getRecalculateProjectMaterialsMutationOptions(options), queryClient);
    }

/**
 * @summary Get material
 */
export const getProjectMaterial = (
    projectId: number,
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Material>(
      {url: `/projects/${projectId}/materials/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetProjectMaterialInfiniteQueryKey = (projectId: number,
    id: number,) => {
    return [
    'infinite', `/projects/${projectId}/materials/${id}`
    ] as const;
    }

export const getGetProjectMaterialQueryKey = (projectId: number,
    id: number,) => {
    return [
    `/projects/${projectId}/materials/${id}`
    ] as const;
    }


export const getGetProjectMaterialInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProjectMaterial>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectMaterial>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectMaterialInfiniteQueryKey(projectId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectMaterial>>> = ({ signal }) => getProjectMaterial(projectId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectMaterial>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectMaterialInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectMaterial>>>
export type GetProjectMaterialInfiniteQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useGetProjectMaterialInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectMaterial>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectMaterial>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectMaterial>>,
          TError,
          Awaited<ReturnType<typeof getProjectMaterial>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectMaterialInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectMaterial>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectMaterial>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectMaterial>>,
          TError,
          Awaited<ReturnType<typeof getProjectMaterial>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectMaterialInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectMaterial>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectMaterial>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get material
 */

export function useGetProjectMaterialInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectMaterial>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectMaterial>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectMaterialInfiniteQueryOptions(projectId,id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProjectMaterialQueryOptions = <TData = Awaited<ReturnType<typeof getProjectMaterial>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectMaterial>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectMaterialQueryKey(projectId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectMaterial>>> = ({ signal }) => getProjectMaterial(projectId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjectMaterial>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectMaterialQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectMaterial>>>
export type GetProjectMaterialQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useGetProjectMaterial<TData = Awaited<ReturnType<typeof getProjectMaterial>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectMaterial>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectMaterial>>,
          TError,
          Awaited<ReturnType<typeof getProjectMaterial>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectMaterial<TData = Awaited<ReturnType<typeof getProjectMaterial>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectMaterial>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectMaterial>>,
          TError,
          Awaited<ReturnType<typeof getProjectMaterial>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectMaterial<TData = Awaited<ReturnType<typeof getProjectMaterial>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectMaterial>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get material
 */

export function useGetProjectMaterial<TData = Awaited<ReturnType<typeof getProjectMaterial>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectMaterial>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectMaterialQueryOptions(projectId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProjectMaterialSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProjectMaterial>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectMaterial>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectMaterialQueryKey(projectId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectMaterial>>> = ({ signal }) => getProjectMaterial(projectId,id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectMaterial>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectMaterialSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectMaterial>>>
export type GetProjectMaterialSuspenseQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


export function useGetProjectMaterialSuspense<TData = Awaited<ReturnType<typeof getProjectMaterial>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectMaterial>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectMaterialSuspense<TData = Awaited<ReturnType<typeof getProjectMaterial>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectMaterial>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectMaterialSuspense<TData = Awaited<ReturnType<typeof getProjectMaterial>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectMaterial>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get material
 */

export function useGetProjectMaterialSuspense<TData = Awaited<ReturnType<typeof getProjectMaterial>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 projectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectMaterial>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectMaterialSuspenseQueryOptions(projectId,id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Edits a manual row; a system row is refused.
 * @summary Update material
 */
export const updateProjectMaterial = (
    projectId: number,
    id: number,
    materialUpdateRequest: BodyType<MaterialUpdateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Material>(
      {url: `/projects/${projectId}/materials/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: materialUpdateRequest, signal
    },
      options);
    }




export const getUpdateProjectMaterialMutationKey = () => ['updateProjectMaterial'] as const;

export const getUpdateProjectMaterialMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProjectMaterial>>, TError,UpdateProjectMaterialMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProjectMaterial>>, TError,UpdateProjectMaterialMutationVariables, TContext> => {

const mutationKey = getUpdateProjectMaterialMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProjectMaterial>>, UpdateProjectMaterialMutationVariables> = (props) => {
          const {projectId,id,data} = props ?? {};

          return  updateProjectMaterial(projectId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProjectMaterialMutationResult = NonNullable<Awaited<ReturnType<typeof updateProjectMaterial>>>
    export type UpdateProjectMaterialMutationBody = BodyType<MaterialUpdateRequest>
    export type UpdateProjectMaterialMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>
    export type UpdateProjectMaterialMutationVariables = {projectId: number;id: number;data: BodyType<MaterialUpdateRequest>}

    /**
 * @summary Update material
 */
export const useUpdateProjectMaterial = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProjectMaterial>>, TError,UpdateProjectMaterialMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProjectMaterial>>,
        TError,
        UpdateProjectMaterialMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateProjectMaterialMutationOptions(options), queryClient);
    }

/**
 * Removes a manual row. Refused while work-status updates reference it, and refused outright on a system row — recalculation owns those.
 * @summary Delete material
 */
export const deleteProjectMaterial = (
    projectId: number,
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/projects/${projectId}/materials/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteProjectMaterialMutationKey = () => ['deleteProjectMaterial'] as const;

export const getDeleteProjectMaterialMutationOptions = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | DeleteRestrictedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectMaterial>>, TError,DeleteProjectMaterialMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProjectMaterial>>, TError,DeleteProjectMaterialMutationVariables, TContext> => {

const mutationKey = getDeleteProjectMaterialMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProjectMaterial>>, DeleteProjectMaterialMutationVariables> = (props) => {
          const {projectId,id} = props ?? {};

          return  deleteProjectMaterial(projectId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectMaterialMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProjectMaterial>>>

    export type DeleteProjectMaterialMutationError = ErrorType<UnauthorizedResponse | NotFoundResponse | DeleteRestrictedResponse>
    export type DeleteProjectMaterialMutationVariables = {projectId: number;id: number}

    /**
 * @summary Delete material
 */
export const useDeleteProjectMaterial = <TError = ErrorType<UnauthorizedResponse | NotFoundResponse | DeleteRestrictedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectMaterial>>, TError,DeleteProjectMaterialMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProjectMaterial>>,
        TError,
        DeleteProjectMaterialMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteProjectMaterialMutationOptions(options), queryClient);
    }

/**
 * The bill of materials rolled up by **material kind** (ADR 0050): the twin of `/networks/{network_id}/grouped-elements` for the materials list. A kind is the catalog part for component rows (a manual row that links a part joins that part's kind), the element-stated category / composition-material / size triple for whole-delivered nodes and pipes, and the row itself for any other manual row — always within one unit, so a kind never adds metres to pieces.
 *
 * The page unit is the **group**, never the row: `per_page` counts groups and `meta.total_count` is the number of groups, so a kind is never split across two pages. Groups are ordered by display name, ascending and diacritic-insensitive, exactly as the flat list orders its rows.
 *
 * The parameters are the flat list's. They select which **members** are listed — a group appears when at least one of its members passes — while the group's totals and member count always describe the whole kind in the project. Reading this feed is the flat list's read: whoever reads a project's materials reads them grouped. Read-only — rows are still created, edited, delivered and consumed one at a time through `/materials` and `/work-status-updates`.
 * @summary List project materials grouped by kind
 */
export const listProjectGroupedMaterials = (
    projectId: number,
    params?: ListProjectGroupedMaterialsParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<MaterialGroupListResponse>(
      {url: `/projects/${projectId}/grouped-materials`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListProjectGroupedMaterialsInfiniteQueryKey = (projectId: number,
    params?: ListProjectGroupedMaterialsParams,) => {
    return [
    'infinite', `/projects/${projectId}/grouped-materials`, ...(params ? [params] : [])
    ] as const;
    }

export const getListProjectGroupedMaterialsQueryKey = (projectId: number,
    params?: ListProjectGroupedMaterialsParams,) => {
    return [
    `/projects/${projectId}/grouped-materials`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProjectGroupedMaterialsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listProjectGroupedMaterials>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(projectId: number,
    params?: ListProjectGroupedMaterialsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectGroupedMaterialsInfiniteQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectGroupedMaterials>>> = ({ signal }) => listProjectGroupedMaterials(projectId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectGroupedMaterialsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectGroupedMaterials>>>
export type ListProjectGroupedMaterialsInfiniteQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>


export function useListProjectGroupedMaterialsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectGroupedMaterials>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params: undefined |  ListProjectGroupedMaterialsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectGroupedMaterials>>,
          TError,
          Awaited<ReturnType<typeof listProjectGroupedMaterials>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectGroupedMaterialsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectGroupedMaterials>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectGroupedMaterialsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectGroupedMaterials>>,
          TError,
          Awaited<ReturnType<typeof listProjectGroupedMaterials>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectGroupedMaterialsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectGroupedMaterials>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectGroupedMaterialsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List project materials grouped by kind
 */

export function useListProjectGroupedMaterialsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectGroupedMaterials>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectGroupedMaterialsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectGroupedMaterialsInfiniteQueryOptions(projectId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProjectGroupedMaterialsQueryOptions = <TData = Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(projectId: number,
    params?: ListProjectGroupedMaterialsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectGroupedMaterialsQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectGroupedMaterials>>> = ({ signal }) => listProjectGroupedMaterials(projectId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectGroupedMaterialsQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectGroupedMaterials>>>
export type ListProjectGroupedMaterialsQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>


export function useListProjectGroupedMaterials<TData = Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params: undefined |  ListProjectGroupedMaterialsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectGroupedMaterials>>,
          TError,
          Awaited<ReturnType<typeof listProjectGroupedMaterials>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectGroupedMaterials<TData = Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectGroupedMaterialsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectGroupedMaterials>>,
          TError,
          Awaited<ReturnType<typeof listProjectGroupedMaterials>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectGroupedMaterials<TData = Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectGroupedMaterialsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List project materials grouped by kind
 */

export function useListProjectGroupedMaterials<TData = Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectGroupedMaterialsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectGroupedMaterialsQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProjectGroupedMaterialsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(projectId: number,
    params?: ListProjectGroupedMaterialsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectGroupedMaterialsQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectGroupedMaterials>>> = ({ signal }) => listProjectGroupedMaterials(projectId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectGroupedMaterialsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectGroupedMaterials>>>
export type ListProjectGroupedMaterialsSuspenseQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>


export function useListProjectGroupedMaterialsSuspense<TData = Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params: undefined |  ListProjectGroupedMaterialsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectGroupedMaterialsSuspense<TData = Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectGroupedMaterialsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectGroupedMaterialsSuspense<TData = Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectGroupedMaterialsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List project materials grouped by kind
 */

export function useListProjectGroupedMaterialsSuspense<TData = Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 projectId: number,
    params?: ListProjectGroupedMaterialsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectGroupedMaterials>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectGroupedMaterialsSuspenseQueryOptions(projectId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Results are ordered newest first (`created_at` descending).
 * @summary List work status updates
 */
export const listProjectWorkStatusUpdates = (
    params?: ListProjectWorkStatusUpdatesParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<WorkStatusUpdateListResponse>(
      {url: `/work-status-updates`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListProjectWorkStatusUpdatesInfiniteQueryKey = (params?: ListProjectWorkStatusUpdatesParams,) => {
    return [
    'infinite', `/work-status-updates`, ...(params ? [params] : [])
    ] as const;
    }

export const getListProjectWorkStatusUpdatesQueryKey = (params?: ListProjectWorkStatusUpdatesParams,) => {
    return [
    `/work-status-updates`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProjectWorkStatusUpdatesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(params?: ListProjectWorkStatusUpdatesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectWorkStatusUpdatesInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>> = ({ signal }) => listProjectWorkStatusUpdates(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectWorkStatusUpdatesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>>
export type ListProjectWorkStatusUpdatesInfiniteQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useListProjectWorkStatusUpdatesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 params: undefined |  ListProjectWorkStatusUpdatesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>,
          TError,
          Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectWorkStatusUpdatesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 params?: ListProjectWorkStatusUpdatesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>,
          TError,
          Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectWorkStatusUpdatesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 params?: ListProjectWorkStatusUpdatesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List work status updates
 */

export function useListProjectWorkStatusUpdatesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 params?: ListProjectWorkStatusUpdatesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectWorkStatusUpdatesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProjectWorkStatusUpdatesQueryOptions = <TData = Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(params?: ListProjectWorkStatusUpdatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectWorkStatusUpdatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>> = ({ signal }) => listProjectWorkStatusUpdates(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectWorkStatusUpdatesQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>>
export type ListProjectWorkStatusUpdatesQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useListProjectWorkStatusUpdates<TData = Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 params: undefined |  ListProjectWorkStatusUpdatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>,
          TError,
          Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectWorkStatusUpdates<TData = Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 params?: ListProjectWorkStatusUpdatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>,
          TError,
          Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectWorkStatusUpdates<TData = Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 params?: ListProjectWorkStatusUpdatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List work status updates
 */

export function useListProjectWorkStatusUpdates<TData = Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 params?: ListProjectWorkStatusUpdatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectWorkStatusUpdatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProjectWorkStatusUpdatesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(params?: ListProjectWorkStatusUpdatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectWorkStatusUpdatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>> = ({ signal }) => listProjectWorkStatusUpdates(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProjectWorkStatusUpdatesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>>
export type ListProjectWorkStatusUpdatesSuspenseQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useListProjectWorkStatusUpdatesSuspense<TData = Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 params: undefined |  ListProjectWorkStatusUpdatesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectWorkStatusUpdatesSuspense<TData = Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 params?: ListProjectWorkStatusUpdatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProjectWorkStatusUpdatesSuspense<TData = Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 params?: ListProjectWorkStatusUpdatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List work status updates
 */

export function useListProjectWorkStatusUpdatesSuspense<TData = Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 params?: ListProjectWorkStatusUpdatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProjectWorkStatusUpdates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectWorkStatusUpdatesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Reporting is app-side only: a panel account is refused with a 403, and app visibility follows the mobile project scope. A network element subject is refused with a 403 unless the author is that element's active assignee — one reporting mouth per element — except a supervisor, who may report on any element in a reachable project regardless of its assignee; the owner still cannot report. A `Material` subject carries no assignee and stays open to the project. The subject decides the allowed status group: a `Material` takes an issue, a `delivery` or a `consumption`, a network element takes an issue or a progress status. A `delivery` or a `consumption` requires a positive `quantity` and counts towards the material's `delivered_quantity` or `consumed_quantity` the moment it is filed.
 * @summary Create work status update
 */
export const createProjectWorkStatusUpdate = (
    workStatusUpdateCreateRequest: BodyType<WorkStatusUpdateCreateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {

      const formData = new FormData();
formData.append(`project_id`, workStatusUpdateCreateRequest.project_id.toString())
formData.append(`status`, workStatusUpdateCreateRequest.status);
formData.append(`statusable_type`, workStatusUpdateCreateRequest.statusable_type);
formData.append(`statusable_id`, workStatusUpdateCreateRequest.statusable_id.toString())
if(workStatusUpdateCreateRequest.quantity !== undefined) {
 formData.append(`quantity`, workStatusUpdateCreateRequest.quantity.toString())
 }
if(workStatusUpdateCreateRequest.description !== undefined) {
 formData.append(`description`, workStatusUpdateCreateRequest.description);
 }
if(workStatusUpdateCreateRequest.photos !== undefined) {
 workStatusUpdateCreateRequest.photos.forEach(value => formData.append(`photos[]`, value));
 }

      return customFetch<WorkStatusUpdate>(
      {url: `/work-status-updates`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getCreateProjectWorkStatusUpdateMutationKey = () => ['createProjectWorkStatusUpdate'] as const;

export const getCreateProjectWorkStatusUpdateMutationOptions = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectWorkStatusUpdate>>, TError,CreateProjectWorkStatusUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProjectWorkStatusUpdate>>, TError,CreateProjectWorkStatusUpdateMutationVariables, TContext> => {

const mutationKey = getCreateProjectWorkStatusUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProjectWorkStatusUpdate>>, CreateProjectWorkStatusUpdateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createProjectWorkStatusUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProjectWorkStatusUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof createProjectWorkStatusUpdate>>>
    export type CreateProjectWorkStatusUpdateMutationBody = BodyType<WorkStatusUpdateCreateRequest>
    export type CreateProjectWorkStatusUpdateMutationError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>
    export type CreateProjectWorkStatusUpdateMutationVariables = {data: BodyType<WorkStatusUpdateCreateRequest>}

    /**
 * @summary Create work status update
 */
export const useCreateProjectWorkStatusUpdate = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectWorkStatusUpdate>>, TError,CreateProjectWorkStatusUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProjectWorkStatusUpdate>>,
        TError,
        CreateProjectWorkStatusUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getCreateProjectWorkStatusUpdateMutationOptions(options), queryClient);
    }

/**
 * @summary Get work status update
 */
export const getProjectWorkStatusUpdate = (
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<WorkStatusUpdate>(
      {url: `/work-status-updates/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetProjectWorkStatusUpdateInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/work-status-updates/${id}`
    ] as const;
    }

export const getGetProjectWorkStatusUpdateQueryKey = (id: number,) => {
    return [
    `/work-status-updates/${id}`
    ] as const;
    }


export const getGetProjectWorkStatusUpdateInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectWorkStatusUpdateInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>> = ({ signal }) => getProjectWorkStatusUpdate(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectWorkStatusUpdateInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>>
export type GetProjectWorkStatusUpdateInfiniteQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetProjectWorkStatusUpdateInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>,
          TError,
          Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectWorkStatusUpdateInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>,
          TError,
          Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectWorkStatusUpdateInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get work status update
 */

export function useGetProjectWorkStatusUpdateInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectWorkStatusUpdateInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProjectWorkStatusUpdateQueryOptions = <TData = Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectWorkStatusUpdateQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>> = ({ signal }) => getProjectWorkStatusUpdate(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectWorkStatusUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>>
export type GetProjectWorkStatusUpdateQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetProjectWorkStatusUpdate<TData = Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>,
          TError,
          Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectWorkStatusUpdate<TData = Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>,
          TError,
          Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectWorkStatusUpdate<TData = Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get work status update
 */

export function useGetProjectWorkStatusUpdate<TData = Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectWorkStatusUpdateQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProjectWorkStatusUpdateSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectWorkStatusUpdateQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>> = ({ signal }) => getProjectWorkStatusUpdate(id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectWorkStatusUpdateSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>>
export type GetProjectWorkStatusUpdateSuspenseQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetProjectWorkStatusUpdateSuspense<TData = Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectWorkStatusUpdateSuspense<TData = Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectWorkStatusUpdateSuspense<TData = Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get work status update
 */

export function useGetProjectWorkStatusUpdateSuspense<TData = Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProjectWorkStatusUpdate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectWorkStatusUpdateSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * The review action — set `resolved` (resolve or reopen) with an optional `comment`; resolving stamps `resolved_at`/`resolved_by`, reopening clears them to null. Open to any panel account, and to an app supervisor or owner that reaches the update's project; every other app account — a foreman included — is refused with a 403. A delivery's or a consumption's `quantity` can be corrected here too, and the material's delivered or consumed sum follows, but that field is panel-only: an app account sending it is refused with a 403.
 * @summary Update work status update
 */
export const updateProjectWorkStatusUpdate = (
    id: number,
    workStatusUpdatePatchRequest: BodyType<WorkStatusUpdatePatchRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<WorkStatusUpdate>(
      {url: `/work-status-updates/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: workStatusUpdatePatchRequest, signal
    },
      options);
    }




export const getUpdateProjectWorkStatusUpdateMutationKey = () => ['updateProjectWorkStatusUpdate'] as const;

export const getUpdateProjectWorkStatusUpdateMutationOptions = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProjectWorkStatusUpdate>>, TError,UpdateProjectWorkStatusUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProjectWorkStatusUpdate>>, TError,UpdateProjectWorkStatusUpdateMutationVariables, TContext> => {

const mutationKey = getUpdateProjectWorkStatusUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProjectWorkStatusUpdate>>, UpdateProjectWorkStatusUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateProjectWorkStatusUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProjectWorkStatusUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof updateProjectWorkStatusUpdate>>>
    export type UpdateProjectWorkStatusUpdateMutationBody = BodyType<WorkStatusUpdatePatchRequest>
    export type UpdateProjectWorkStatusUpdateMutationError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>
    export type UpdateProjectWorkStatusUpdateMutationVariables = {id: number;data: BodyType<WorkStatusUpdatePatchRequest>}

    /**
 * @summary Update work status update
 */
export const useUpdateProjectWorkStatusUpdate = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProjectWorkStatusUpdate>>, TError,UpdateProjectWorkStatusUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProjectWorkStatusUpdate>>,
        TError,
        UpdateProjectWorkStatusUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateProjectWorkStatusUpdateMutationOptions(options), queryClient);
    }

/**
 * The author's own app-side edit, allowed only while the update is unresolved — a panel account, a non-author, or a resolved update is refused with a 403. Only `description`, `photos` and a delivery's or a consumption's `quantity` can change; `status`, the target and the project are immutable — a correction of those is a new update.
 * @summary Edit own work status update
 */
export const authorEditProjectWorkStatusUpdate = (
    id: number,
    workStatusUpdateAuthorEditRequest: BodyType<WorkStatusUpdateAuthorEditRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(workStatusUpdateAuthorEditRequest.description !== undefined) {
 formData.append(`description`, workStatusUpdateAuthorEditRequest.description);
 }
if(workStatusUpdateAuthorEditRequest.quantity !== undefined) {
 formData.append(`quantity`, workStatusUpdateAuthorEditRequest.quantity.toString())
 }
if(workStatusUpdateAuthorEditRequest.photos !== undefined) {
 workStatusUpdateAuthorEditRequest.photos.forEach(value => formData.append(`photos[]`, value));
 }

      return customFetch<WorkStatusUpdate>(
      {url: `/work-status-updates/${id}`, method: 'PUT',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getAuthorEditProjectWorkStatusUpdateMutationKey = () => ['authorEditProjectWorkStatusUpdate'] as const;

export const getAuthorEditProjectWorkStatusUpdateMutationOptions = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authorEditProjectWorkStatusUpdate>>, TError,AuthorEditProjectWorkStatusUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof authorEditProjectWorkStatusUpdate>>, TError,AuthorEditProjectWorkStatusUpdateMutationVariables, TContext> => {

const mutationKey = getAuthorEditProjectWorkStatusUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authorEditProjectWorkStatusUpdate>>, AuthorEditProjectWorkStatusUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  authorEditProjectWorkStatusUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthorEditProjectWorkStatusUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof authorEditProjectWorkStatusUpdate>>>
    export type AuthorEditProjectWorkStatusUpdateMutationBody = BodyType<WorkStatusUpdateAuthorEditRequest>
    export type AuthorEditProjectWorkStatusUpdateMutationError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>
    export type AuthorEditProjectWorkStatusUpdateMutationVariables = {id: number;data: BodyType<WorkStatusUpdateAuthorEditRequest>}

    /**
 * @summary Edit own work status update
 */
export const useAuthorEditProjectWorkStatusUpdate = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authorEditProjectWorkStatusUpdate>>, TError,AuthorEditProjectWorkStatusUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authorEditProjectWorkStatusUpdate>>,
        TError,
        AuthorEditProjectWorkStatusUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAuthorEditProjectWorkStatusUpdateMutationOptions(options), queryClient);
    }

/**
 * Panel-wide moderation: an app account is refused with a 403.
 * @summary Delete work status update
 */
export const deleteProjectWorkStatusUpdate = (
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/work-status-updates/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteProjectWorkStatusUpdateMutationKey = () => ['deleteProjectWorkStatusUpdate'] as const;

export const getDeleteProjectWorkStatusUpdateMutationOptions = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectWorkStatusUpdate>>, TError,DeleteProjectWorkStatusUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProjectWorkStatusUpdate>>, TError,DeleteProjectWorkStatusUpdateMutationVariables, TContext> => {

const mutationKey = getDeleteProjectWorkStatusUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProjectWorkStatusUpdate>>, DeleteProjectWorkStatusUpdateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteProjectWorkStatusUpdate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectWorkStatusUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProjectWorkStatusUpdate>>>

    export type DeleteProjectWorkStatusUpdateMutationError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>
    export type DeleteProjectWorkStatusUpdateMutationVariables = {id: number}

    /**
 * @summary Delete work status update
 */
export const useDeleteProjectWorkStatusUpdate = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectWorkStatusUpdate>>, TError,DeleteProjectWorkStatusUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProjectWorkStatusUpdate>>,
        TError,
        DeleteProjectWorkStatusUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteProjectWorkStatusUpdateMutationOptions(options), queryClient);
    }

/**
 * The papers attached to one network element. `element_type` and `element_id` are sent together and name the element; results are ordered oldest first (`created_at` ascending).
 * @summary List element documents
 */
export const listElementDocuments = (
    params?: ListElementDocumentsParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<ElementDocumentListResponse>(
      {url: `/element-documents`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListElementDocumentsInfiniteQueryKey = (params?: ListElementDocumentsParams,) => {
    return [
    'infinite', `/element-documents`, ...(params ? [params] : [])
    ] as const;
    }

export const getListElementDocumentsQueryKey = (params?: ListElementDocumentsParams,) => {
    return [
    `/element-documents`, ...(params ? [params] : [])
    ] as const;
    }


export const getListElementDocumentsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listElementDocuments>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(params?: ListElementDocumentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listElementDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListElementDocumentsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listElementDocuments>>> = ({ signal }) => listElementDocuments(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listElementDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListElementDocumentsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listElementDocuments>>>
export type ListElementDocumentsInfiniteQueryError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>


export function useListElementDocumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listElementDocuments>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params: undefined |  ListElementDocumentsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listElementDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listElementDocuments>>,
          TError,
          Awaited<ReturnType<typeof listElementDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListElementDocumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listElementDocuments>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListElementDocumentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listElementDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listElementDocuments>>,
          TError,
          Awaited<ReturnType<typeof listElementDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListElementDocumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listElementDocuments>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListElementDocumentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listElementDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List element documents
 */

export function useListElementDocumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listElementDocuments>>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListElementDocumentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listElementDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListElementDocumentsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListElementDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listElementDocuments>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(params?: ListElementDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listElementDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListElementDocumentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listElementDocuments>>> = ({ signal }) => listElementDocuments(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listElementDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListElementDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listElementDocuments>>>
export type ListElementDocumentsQueryError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>


export function useListElementDocuments<TData = Awaited<ReturnType<typeof listElementDocuments>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params: undefined |  ListElementDocumentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listElementDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listElementDocuments>>,
          TError,
          Awaited<ReturnType<typeof listElementDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListElementDocuments<TData = Awaited<ReturnType<typeof listElementDocuments>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListElementDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listElementDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listElementDocuments>>,
          TError,
          Awaited<ReturnType<typeof listElementDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListElementDocuments<TData = Awaited<ReturnType<typeof listElementDocuments>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListElementDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listElementDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List element documents
 */

export function useListElementDocuments<TData = Awaited<ReturnType<typeof listElementDocuments>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListElementDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listElementDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListElementDocumentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListElementDocumentsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listElementDocuments>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(params?: ListElementDocumentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listElementDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListElementDocumentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listElementDocuments>>> = ({ signal }) => listElementDocuments(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listElementDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListElementDocumentsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listElementDocuments>>>
export type ListElementDocumentsSuspenseQueryError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>


export function useListElementDocumentsSuspense<TData = Awaited<ReturnType<typeof listElementDocuments>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params: undefined |  ListElementDocumentsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listElementDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListElementDocumentsSuspense<TData = Awaited<ReturnType<typeof listElementDocuments>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListElementDocumentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listElementDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListElementDocumentsSuspense<TData = Awaited<ReturnType<typeof listElementDocuments>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListElementDocumentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listElementDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List element documents
 */

export function useListElementDocumentsSuspense<TData = Awaited<ReturnType<typeof listElementDocuments>>, TError = ErrorType<UnauthorizedResponse | ValidationErrorResponse>>(
 params?: ListElementDocumentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listElementDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListElementDocumentsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Attaches one labelled file to a network node or connection. Panel-wide: an app account is refused with a 403. A ready element refuses the add — the lock freezes the element's own record, so it must be unlocked first (ADR 0030).
 * @summary Create element document
 */
export const createElementDocument = (
    elementDocumentCreateRequest: BodyType<ElementDocumentCreateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {

      const formData = new FormData();
formData.append(`label`, elementDocumentCreateRequest.label);
formData.append(`element_type`, elementDocumentCreateRequest.element_type);
formData.append(`element_id`, elementDocumentCreateRequest.element_id.toString())
formData.append(`file`, elementDocumentCreateRequest.file);

      return customFetch<ElementDocument>(
      {url: `/element-documents`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getCreateElementDocumentMutationKey = () => ['createElementDocument'] as const;

export const getCreateElementDocumentMutationOptions = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createElementDocument>>, TError,CreateElementDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createElementDocument>>, TError,CreateElementDocumentMutationVariables, TContext> => {

const mutationKey = getCreateElementDocumentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createElementDocument>>, CreateElementDocumentMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createElementDocument(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateElementDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof createElementDocument>>>
    export type CreateElementDocumentMutationBody = BodyType<ElementDocumentCreateRequest>
    export type CreateElementDocumentMutationError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ValidationErrorResponse>
    export type CreateElementDocumentMutationVariables = {data: BodyType<ElementDocumentCreateRequest>}

    /**
 * @summary Create element document
 */
export const useCreateElementDocument = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createElementDocument>>, TError,CreateElementDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createElementDocument>>,
        TError,
        CreateElementDocumentMutationVariables,
        TContext
      > => {
      return useMutation(getCreateElementDocumentMutationOptions(options), queryClient);
    }

/**
 * Removes the document and purges its stored file. Panel-wide: an app account is refused with a 403. A ready element refuses the delete (ADR 0030).
 * @summary Delete element document
 */
export const deleteElementDocument = (
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<void>(
      {url: `/element-documents/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteElementDocumentMutationKey = () => ['deleteElementDocument'] as const;

export const getDeleteElementDocumentMutationOptions = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | DeleteRestrictedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteElementDocument>>, TError,DeleteElementDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteElementDocument>>, TError,DeleteElementDocumentMutationVariables, TContext> => {

const mutationKey = getDeleteElementDocumentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteElementDocument>>, DeleteElementDocumentMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteElementDocument(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteElementDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteElementDocument>>>

    export type DeleteElementDocumentMutationError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | DeleteRestrictedResponse>
    export type DeleteElementDocumentMutationVariables = {id: number}

    /**
 * @summary Delete element document
 */
export const useDeleteElementDocument = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | DeleteRestrictedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteElementDocument>>, TError,DeleteElementDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteElementDocument>>,
        TError,
        DeleteElementDocumentMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteElementDocumentMutationOptions(options), queryClient);
    }

/**
 * Results are ordered newest first (`created_at` descending). To read a person's winning baseline for a day, filter by `network_id`, `person_id`, `measurement_spot=network_baseline` and `measured_on`, and take the first result: a person may set the instrument up more than once a day, and their latest entry of the day is the one every elevation on that network derives from.
 * @summary List measurements
 */
export const listMeasurements = (
    params?: ListMeasurementsParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<MeasurementListResponse>(
      {url: `/measurements`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListMeasurementsInfiniteQueryKey = (params?: ListMeasurementsParams,) => {
    return [
    'infinite', `/measurements`, ...(params ? [params] : [])
    ] as const;
    }

export const getListMeasurementsQueryKey = (params?: ListMeasurementsParams,) => {
    return [
    `/measurements`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMeasurementsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listMeasurements>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(params?: ListMeasurementsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listMeasurements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMeasurementsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMeasurements>>> = ({ signal }) => listMeasurements(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listMeasurements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMeasurementsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listMeasurements>>>
export type ListMeasurementsInfiniteQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>


export function useListMeasurementsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listMeasurements>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 params: undefined |  ListMeasurementsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listMeasurements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMeasurements>>,
          TError,
          Awaited<ReturnType<typeof listMeasurements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMeasurementsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listMeasurements>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 params?: ListMeasurementsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listMeasurements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMeasurements>>,
          TError,
          Awaited<ReturnType<typeof listMeasurements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMeasurementsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listMeasurements>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 params?: ListMeasurementsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listMeasurements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List measurements
 */

export function useListMeasurementsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listMeasurements>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 params?: ListMeasurementsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listMeasurements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMeasurementsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListMeasurementsQueryOptions = <TData = Awaited<ReturnType<typeof listMeasurements>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(params?: ListMeasurementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMeasurements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMeasurementsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMeasurements>>> = ({ signal }) => listMeasurements(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMeasurements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMeasurementsQueryResult = NonNullable<Awaited<ReturnType<typeof listMeasurements>>>
export type ListMeasurementsQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>


export function useListMeasurements<TData = Awaited<ReturnType<typeof listMeasurements>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 params: undefined |  ListMeasurementsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMeasurements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMeasurements>>,
          TError,
          Awaited<ReturnType<typeof listMeasurements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMeasurements<TData = Awaited<ReturnType<typeof listMeasurements>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 params?: ListMeasurementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMeasurements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMeasurements>>,
          TError,
          Awaited<ReturnType<typeof listMeasurements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMeasurements<TData = Awaited<ReturnType<typeof listMeasurements>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 params?: ListMeasurementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMeasurements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List measurements
 */

export function useListMeasurements<TData = Awaited<ReturnType<typeof listMeasurements>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 params?: ListMeasurementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMeasurements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMeasurementsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListMeasurementsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listMeasurements>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(params?: ListMeasurementsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMeasurements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMeasurementsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMeasurements>>> = ({ signal }) => listMeasurements(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMeasurements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMeasurementsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listMeasurements>>>
export type ListMeasurementsSuspenseQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>


export function useListMeasurementsSuspense<TData = Awaited<ReturnType<typeof listMeasurements>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 params: undefined |  ListMeasurementsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMeasurements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMeasurementsSuspense<TData = Awaited<ReturnType<typeof listMeasurements>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 params?: ListMeasurementsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMeasurements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMeasurementsSuspense<TData = Awaited<ReturnType<typeof listMeasurements>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 params?: ListMeasurementsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMeasurements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List measurements
 */

export function useListMeasurementsSuspense<TData = Awaited<ReturnType<typeof listMeasurements>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | ValidationErrorResponse>>(
 params?: ListMeasurementsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listMeasurements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMeasurementsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Recording is app-side only: a panel account is refused with a 403, and app visibility follows the mobile project scope. Measuring is an observation, not authorship — it is NOT gated by element assignment, and Tie-ins and Inlets accept measurements like any other element.
 *
 * The foreman always sends the raw staff `reading`; the server does the arithmetic and stores the resulting absolute elevation as `value`, keeping the reading for provenance. For a `network_baseline` that is `benchmark.elevation + reading`; for an element spot it is `latest same-day baseline − reading`.
 *
 * The hard gate (ADR-0009): any levelled measurement whose spot is NOT `network_baseline` requires the author's own same-day baseline on that network, and is refused with a 422 without one. The gate covers measurements only — work status updates and browsing are never blocked by a missing baseline.
 *
 * Requiredness by method: `levelled` (the default) needs `instrument_id` and `reading`, and computes `value`; `approximate` needs `value` and `method_note` instead, takes no instrument and no baseline, and is flagged wherever it is shown. A `network_baseline` additionally requires `benchmark_id`, is always `levelled`, and is the only spot a `Network` measurable accepts. A `label` belongs to the `other` spot and is refused elsewhere.
 * @summary Create measurement
 */
export const createMeasurement = (
    measurementCreateRequest: BodyType<MeasurementCreateRequest>,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Measurement>(
      {url: `/measurements`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: measurementCreateRequest, signal
    },
      options);
    }




export const getCreateMeasurementMutationKey = () => ['createMeasurement'] as const;

export const getCreateMeasurementMutationOptions = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMeasurement>>, TError,CreateMeasurementMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createMeasurement>>, TError,CreateMeasurementMutationVariables, TContext> => {

const mutationKey = getCreateMeasurementMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMeasurement>>, CreateMeasurementMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createMeasurement(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMeasurementMutationResult = NonNullable<Awaited<ReturnType<typeof createMeasurement>>>
    export type CreateMeasurementMutationBody = BodyType<MeasurementCreateRequest>
    export type CreateMeasurementMutationError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>
    export type CreateMeasurementMutationVariables = {data: BodyType<MeasurementCreateRequest>}

    /**
 * @summary Create measurement
 */
export const useCreateMeasurement = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMeasurement>>, TError,CreateMeasurementMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createMeasurement>>,
        TError,
        CreateMeasurementMutationVariables,
        TContext
      > => {
      return useMutation(getCreateMeasurementMutationOptions(options), queryClient);
    }

/**
 * @summary Get measurement
 */
export const getMeasurement = (
    id: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<Measurement>(
      {url: `/measurements/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetMeasurementInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/measurements/${id}`
    ] as const;
    }

export const getGetMeasurementQueryKey = (id: number,) => {
    return [
    `/measurements/${id}`
    ] as const;
    }


export const getGetMeasurementInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getMeasurement>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMeasurement>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeasurementInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeasurement>>> = ({ signal }) => getMeasurement(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMeasurement>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeasurementInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getMeasurement>>>
export type GetMeasurementInfiniteQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetMeasurementInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMeasurement>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMeasurement>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeasurement>>,
          TError,
          Awaited<ReturnType<typeof getMeasurement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeasurementInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMeasurement>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMeasurement>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeasurement>>,
          TError,
          Awaited<ReturnType<typeof getMeasurement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeasurementInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMeasurement>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMeasurement>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get measurement
 */

export function useGetMeasurementInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMeasurement>>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMeasurement>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeasurementInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMeasurementQueryOptions = <TData = Awaited<ReturnType<typeof getMeasurement>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeasurement>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeasurementQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeasurement>>> = ({ signal }) => getMeasurement(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMeasurement>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeasurementQueryResult = NonNullable<Awaited<ReturnType<typeof getMeasurement>>>
export type GetMeasurementQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetMeasurement<TData = Awaited<ReturnType<typeof getMeasurement>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeasurement>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeasurement>>,
          TError,
          Awaited<ReturnType<typeof getMeasurement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeasurement<TData = Awaited<ReturnType<typeof getMeasurement>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeasurement>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeasurement>>,
          TError,
          Awaited<ReturnType<typeof getMeasurement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeasurement<TData = Awaited<ReturnType<typeof getMeasurement>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeasurement>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get measurement
 */

export function useGetMeasurement<TData = Awaited<ReturnType<typeof getMeasurement>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeasurement>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeasurementQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMeasurementSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMeasurement>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMeasurement>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeasurementQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeasurement>>> = ({ signal }) => getMeasurement(id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMeasurement>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeasurementSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMeasurement>>>
export type GetMeasurementSuspenseQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


export function useGetMeasurementSuspense<TData = Awaited<ReturnType<typeof getMeasurement>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMeasurement>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeasurementSuspense<TData = Awaited<ReturnType<typeof getMeasurement>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMeasurement>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeasurementSuspense<TData = Awaited<ReturnType<typeof getMeasurement>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMeasurement>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get measurement
 */

export function useGetMeasurementSuspense<TData = Awaited<ReturnType<typeof getMeasurement>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMeasurement>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeasurementSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary List audit logs
 */
export const listAuditLogs = (
    params?: ListAuditLogsParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {


      return customFetch<AuditLogListResponse>(
      {url: `/audit-logs`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListAuditLogsInfiniteQueryKey = (params?: ListAuditLogsParams,) => {
    return [
    'infinite', `/audit-logs`, ...(params ? [params] : [])
    ] as const;
    }

export const getListAuditLogsQueryKey = (params?: ListAuditLogsParams,) => {
    return [
    `/audit-logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAuditLogsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listAuditLogs>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ValidationErrorResponse>>(params?: ListAuditLogsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuditLogsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditLogs>>> = ({ signal }) => listAuditLogs(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAuditLogsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditLogs>>>
export type ListAuditLogsInfiniteQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ValidationErrorResponse>


export function useListAuditLogsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listAuditLogs>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ValidationErrorResponse>>(
 params: undefined |  ListAuditLogsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof listAuditLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditLogsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listAuditLogs>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ValidationErrorResponse>>(
 params?: ListAuditLogsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof listAuditLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditLogsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listAuditLogs>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ValidationErrorResponse>>(
 params?: ListAuditLogsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List audit logs
 */

export function useListAuditLogsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listAuditLogs>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ValidationErrorResponse>>(
 params?: ListAuditLogsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAuditLogsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListAuditLogsQueryOptions = <TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ValidationErrorResponse>>(params?: ListAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuditLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditLogs>>> = ({ signal }) => listAuditLogs(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAuditLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditLogs>>>
export type ListAuditLogsQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ValidationErrorResponse>


export function useListAuditLogs<TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ValidationErrorResponse>>(
 params: undefined |  ListAuditLogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof listAuditLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditLogs<TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ValidationErrorResponse>>(
 params?: ListAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof listAuditLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditLogs<TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ValidationErrorResponse>>(
 params?: ListAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List audit logs
 */

export function useListAuditLogs<TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ValidationErrorResponse>>(
 params?: ListAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAuditLogsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListAuditLogsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ValidationErrorResponse>>(params?: ListAuditLogsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuditLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditLogs>>> = ({ signal }) => listAuditLogs(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAuditLogsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditLogs>>>
export type ListAuditLogsSuspenseQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ValidationErrorResponse>


export function useListAuditLogsSuspense<TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ValidationErrorResponse>>(
 params: undefined |  ListAuditLogsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditLogsSuspense<TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ValidationErrorResponse>>(
 params?: ListAuditLogsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditLogsSuspense<TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ValidationErrorResponse>>(
 params?: ListAuditLogsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List audit logs
 */

export function useListAuditLogsSuspense<TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ValidationErrorResponse>>(
 params?: ListAuditLogsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAuditLogsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







